export const cs = {
    addDatabase: {
        addDatabase: "PÅidat databÃ¡zi",
        addFromFile: "PÅidat ze souboru",
        analyse: "Analyzovat",
        analysingYourData: "VaÅ¡e data se analyzujÃ­",
        createFromExcel: "VytvoÅit z Excelu",
        databaseImport: "Import databÃ¡ze",
        databaseNotImported: "Import skonÄil s chybami",
        databasePrepared: "DatabÃ¡ze ÃºspÄÅ¡nÄ pÅipravena",
        excelFile: "Excel soubor",
        fileInformation: "Informace o souboru",
        fixErrors: "Chcete-li pokraÄovat, opravte nÃ¡sledujÃ­cÃ­ chyby a zkuste to znovu",
        importingYourData: "VaÅ¡e data se importujÃ­",
        productFilesPath: "Cesta k souborÅ¯m produktÅ¯",
        productImagesPath: "Cesta k obrÃ¡zkÅ¯m produktÅ¯"
    },
    availablePrice: {
        allPackage: "VÅ¡echna balenÃ­",
        onePackage: "Jedno balenÃ­",
        priceType: "Typ ceny",
        setPriceVatVisibility: "Nastavit viditelnost danÄ",
        setVisibilityAndOrder: "Nastavit viditelnost a poÅadÃ­ typÅ¯ cen",
        withAndWithoutVat: "S i bez danÄ",
        withVat: "Pouze s danÃ­",
        withoutVat: "Pouze bez danÄ"
    },
    barvis: {
        base: "NÃ¡zev bÃ¡ze",
        bigCanSize: "VelkÃ© dÃ¡vky",
        coating: "NÃ¡tÄry",
        identifier: "IdentifikÃ¡tor",
        laboratory: "LaboratoÅ",
        orderOverview: "PÅehled objednÃ¡vky",
        rank: "Å arÅ¾e",
        smallCanSize: "MalÃ© dÃ¡vky"
    },
    basicSetup: {
        alreadyLoggedIn: "Jste jiÅ¾ pÅihlÃ¡Å¡eni jako %{login}.",
        askSupplier: "PoÅ¾Ã¡dejte dodavatele software, aby vÃ¡m pÅidÄlil vÃ­ce licencÃ­.",
        asterisk: "PoloÅ¾ky oznaÄenÃ© hvÄzdiÄkou musÃ­ bÃ½t vyplnÄny.",
        identificationKeys: "IdentifikaÄnÃ­ klÃ­Äe",
        importCustomData: "Pokud chcete, importujte svÃ¡ vlastnÃ­ data z pÅedchozÃ­ho tÃ³novacÃ­ho softvÃ©ru.",
        learnIdentification: "ZjistÄte identifikaÄnÃ­ klÃ­Äe od dodavatele software.",
        login: "NÃ¡sledujÃ­cÃ­ kroky ÃºvodnÃ­ho nastavenÃ­ vyÅ¾adujÃ­ prÃ¡va sprÃ¡vce.",
        noDatabase: "ZatÃ­m nebyla pÅidÃ¡na Å¾Ã¡dnÃ¡ databÃ¡ze, musÃ­ bÃ½t vloÅ¾ena alespoÅ jedna.",
        offlineLicensing: "Offline zalicencovÃ¡nÃ­",
        productSelection: "VÃ½bÄr productu",
        registrationForm: "RegistraÄnÃ­ formulÃ¡Å",
        seeQuestionMark: "DalÅ¡Ã­ informace o nastavenÃ­ naleznete pÅi nastavenÃ­ v malÃ½ch ikonÃ¡ch otÃ¡znikÅ¯.",
        selectDefaultPrinter: "Vyberte vÃ½chozÃ­ tiskÃ¡rnu a nastavte dalÅ¡Ã­ konfiguraci.",
        selectDefaultTemplate:
            "Vyberte vÃ½chozÃ­ Å¡ablony z jiÅ¾ existujÃ­cÃ­ch, vytvoÅte novou Å¡ablonu, nebo nahrajte vlastnÃ­.",
        selectDispenser: "Vyberte typ stroje, kterÃ½ pouÅ¾Ã­vÃ¡te.",
        selectLanguage: "Vyberte svÅ¯j jazyk.",
        selectProducts: "Vyberte jeden z dostupnÃ½ch produktÅ¯, kterÃ½ chcete aktivovat.",
        selectSpectroType: "Vyberte typ spektra, kterÃ½ pouÅ¾Ã­vÃ¡te.",
        setAdditionalPrinterOptions: "Nastavte dalÅ¡Ã­ moÅ¾nosti tiskÃ¡rny.",
        setAutomaticUpdates: "Nastavte moÅ¾nosti automatickÃ½ch aktualizacÃ­.",
        setCustomItems: "Nastavte viditelnost vlastnÃ­ch poloÅ¾ek a dat. DalÅ¡Ã­ moÅ¾nosti zobrazÃ­te posunutÃ­m dolÅ¯.",
        setEnvironment: "Nastavte celkovÃ© prostÅedÃ­ software. DalÅ¡Ã­ moÅ¾nosti zobrazÃ­te posunutÃ­m dolÅ¯.",
        setFormulaRepresentation: "Nastavte zobrazenÃ­ receptury. DalÅ¡Ã­ moÅ¾nosti zobrazÃ­te posunutÃ­m dolÅ¯.",
        summary:
            "Toto nastavenÃ­ mÅ¯Å¾ete kdykoli zmÄnit a najÃ­t jeÅ¡tÄ vÃ­ce moÅ¾nostÃ­ konfigurace. UÅ¾ijte si pouÅ¾Ã­vÃ¡nÃ­ %{name}!",
        summarySuccess: "VÅ¡echno je pÅipraveno!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "ÄÃ­slo Å¡arÅ¾e: %{batchNumber}",
        colorantIsDefective: "Kanystr je naplnÄnÃ­ vadnou sarÅ¾Ã­ kolorantu.  NepouÅ¾Ã­vejte tuto sarÅ¾i.",
        defectiveInfoLine1: "ProsÃ­m, nepouÅ¾Ã­vejte tento colorant",
        defectiveInfoLine2: "S tÃ­mto ÄÃ­slem Å¡arÅ¾e",
        emptyQuickTint: "VyprÃ¡zdnÄte kanystr pouÅ¾Ã­tÃ­m Quick tint.",
        warningInfoLine1: "Kolorant ",
        warningInfoLine2: "s tÃ­mto ÄÃ­slem Å¡arÅ¾e mÅ¯Å¾e bÃ½t poÅ¡kozenÃ½."
    },
    canisterLevel: {
        canisterLevel: "Hladina kolorantu v kanystru",
        criticalLevelCanister: "KritickÃ© hladiny kanystru",
        fillToMax: "Doplnit do maxima",
        maxDispenseLevel: "Maximum tÃ³novÃ¡nÃ­",
        otherCanisters: "DalÅ¡Ã­ kanystry",
        warningLevelCanister: "VarovnÃ­ hladiny kanystru"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "ÄÃ­slo Å¡arÅ¾e nÃ¡plnÄ",
        ufiCodeStatus: "Stav UFI kÃ³du"
    },
    canistersTab: {
        availableServiceActions: "DostupnÃ© servisnÃ­ Ãºkoly",
        canisterInformation: "Informace o kanystru",
        canisterPreview: "NÃ¡hled kanystru",
        currentLevel: "SouÄasnÃ¡ ÃºroveÅ",
        errors: "Chyby",
        fillState: "Stav nÃ¡plnÄ",
        fillToMax: "Doplnit do maxima",
        fillingAmount: "MnoÅ¾stvÃ­ k plnÄnÃ­",
        finalLevel: "KoneÄnÃ¡ ÃºroveÅ ",
        minimumAmount: "MinimÃ¡lnÃ­ mnoÅ¾stvÃ­",
        minimumLevel: "MinimÃ¡lnÃ­ ÃºroveÅ",
        moveTableToRefill: "PÅesunout stÅ¯l k plnÄnÃ­",
        refillNoAmount: "NenÃ­ zadÃ¡no Å¾Ã¡dne mnoÅ¾stvÃ­",
        refillOverLimit: "ZadanÃ¡ hodnota pÅesahuje maximÃ¡lnÃ­ kapacitu kanystru",
        refillSummary: "%{amount} %{unit} kolorantu %{colorant} bude pÅidÃ¡no do kanystru %{canisterId}.",
        systemWarningAmount: "VarovnÃ© mnoÅ¾stvÃ­",
        warningAmount: "VarovnÃ© mnoÅ¾stvÃ­"
    },
    changeDatabase: {
        changeDatabase: "ZmÄna databÃ¡ze",
        databaseWarning: "Database %{databaseName} nemÅ¯Å¾e bÃ½t pouÅ¾itÃ¡ kvÅ¯li"
    },
    changelog: {
        allVersion: "VÅ¡echny verze",
        changelog: "Changelog",
        link: "Odkaz",
        links: "Odkazy",
        version: "Verze",
        versionFilter: "Filtr verzÃ­"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "V kanystrech nenÃ­ dostatek kolorantu na %{numOfPackages} balenÃ­.",
        fillAdditionally: "Doplnit dodateÄnÄ",
        refillToMax: "Doplnit na maximum"
    },
    cleanChannels: {
        cleanAllChannels: "VyÄistit vÅ¡echny okruhy",
        cleanChannels: "VyÄistit okruhy",
        cleaningTime: "Doba ÄiÅ¡tÄnÃ­",
        selectChannels: "Vybrat okruhy",
        startCleaning: "ZahÃ¡jit ÄiÅ¡tÄnÃ­"
    },
    clientServerSettings: {
        activeServer: "AktivnÃ­ server",
        addNewServer: "PÅidat novÃ½ server",
        availableServers: "DalÅ¡Ã­ dostupnÃ© servery",
        clientIdentifier: "IdentifikÃ¡tor klienta",
        clientServerSettings: "NastavenÃ­ klienta/serveru",
        disabledStatus: "ZruÅ¡enÃ½",
        editServer: "Upravit server",
        fillRequiredFields: "VyplÅte povinnÃ¡ pole",
        noOtherServers: "Nejsou dostupnÃ© Å¾Ã¡dnÃ© dalÅ¡Ã­ servery",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        port: "Port",
        serverName: "NÃ¡zev serveru",
        serverNameMissing: "NÃ¡zev serveru musÃ­ bÃ½t vyplnÄn",
        stabileConnection: "ProsÃ­m pouÅ¾ijte statickou IP adresu pro zajiÅ¡tÄnÃ­ stabilnÃ­ho pÅipojenÃ­.",
        wrongFormatIp: "Å patnÃ½ formÃ¡t IP adresy"
    },
    colorSearchTab: {
        notEveryItemSelected: "NenÃ­ vybrÃ¡na jedna nebo vÃ­ce poloÅ¾ek"
    },
    colorTab: {
        colorTone: "BarevnÃ½ tÃ³n",
        fandeckPosition: "Pozice vzorkovnice",
        moreInfoIcons: "Ikony dalÅ¡Ã­ch informacÃ­",
        notExistingFormula: "NeexistujÃ­ci receptury",
        orderBy: "SeÅadit dle",
        selectYourGrid: "Velikost mÅÃ­Å¾ky",
        showInPanel: "UkÃ¡zat v panelu",
        warningIcon: "VarovnÃ­ ikonka neexistujÃ­cÃ­ch"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "PouÅ¾ijte ÄÃ­sla sarÅ¾Ã­ v procentech",
        batchNumberFromLastFilling: "PouÅ¾ijte ÄÃ­sla sarÅ¾Ã­ z poslednÃ­ho plnÄnÃ­",
        defectiveBatchOfColorant: "VadnÃ¡ Å¡arÅ¾e bariva",
        enableBatchNumber: "Povolte ÄÃ­sla sarÅ¾Ã­ kolorantu",
        possibleDamagedBatchOfColorant: "NejspÃ­Å¡e poÅ¡kozenÃ¡ Å¡arÅ¾e kolorantu",
        scanOrTypeBatchNumber: "Naskenujte nebo zapiÅ¡te ÄÃ­sla Å¡arÅ¾e"
    },
    colorantPanel: {
        manualMachine: "Stroj "
    },
    colorantsTable: {
        numberOfColorants: "PoÄet kolorantÅ¯:",
        preview: "NÃ¡hled",
        prices: "Ceny"
    },
    currencySettings: {
        addNewCurrency: "PÅidat novou mÄnu",
        codePlaceholder: "KÃ³d mÄny",
        currencySettings: "NastavenÃ­ mÄn",
        namePlaceholder: "NÃ¡zev",
        ratePlaceholder: "Kurz",
        setDecimalPlaces: "Nastavte poÄet desetinnÃ½ch mÃ­st",
        setMainCurrency: "Nastavte hlavnÃ­ mÄnu",
        setRounding: "Nastavte zaokrouhlovÃ¡nÃ­",
        symbolPlaceholder: "Znak"
    },
    customFandecks: {
        customFandecks: "VlastnÃ­ vzorkovnice",
        deleteButtonWarning: "VÅ¡echny receptury ve vzorkovnici budou smazÃ¡ny.",
        deleteCustomFandeck:
            "Opravdu chcete smazat vlastnÃ­ vzorkovnici? VÅ¡echny receptury ve vzorkovnici budou smazÃ¡ny.",
        disableStandardFandecks: "Zobrazit pouze vlastnÃ­ vzorkovnice",
        enableStandardFandecks: "Zobrazit standartnÃ­ vzorkovnice ",
        fandeckName: "NÃ¡zev vzornice"
    },
    customRedlike: {
        addColorantFromBrand: "PÅidat kolorant znaÄky %{brandName}",
        addNewCustomer: "PÅidat novÃ©ho zÃ¡kaznÃ­ka",
        addNewNote: "PÅidat novou poznÃ¡mku",
        addedDate: "PÅidat datum",
        addedQuantity: "PÅidÃ¡no mnoÅ¾stvÃ­",
        availableMachine: "DostupnÃ½ stroj",
        brand: "ZnaÄka",
        brandPlease: "Vyberte znaÄku, prosÃ­m",
        cancelCustomer: "ZruÅ¡it zÃ¡kaznÃ­ka",
        colorPlease: "Vyberte barvu, prosÃ­m",
        confirmCustomerData: "Potvrdit data o zÃ¡kaznÃ­kovi",
        confirmNoteData: "Potvrdit poznÃ¡mku",
        confirmSelectedUser: "Chcete vybrat zÃ¡kaznÃ­ka %{customerName}?",
        confirmed: "Potvrzena",
        controlData: "FinÃ¡lnÃ­ kontrola dat",
        customerCellNumber: "MobilnÃ­ telefon zÃ¡kaznÃ­ka",
        customerFilter: "FiltrovÃ¡nÃ­ zÃ¡kaznÃ­kÅ¯",
        customerName: "JmÃ©no zÃ¡kaznÃ­ka",
        customerPhone: "Telefon",
        customerPlease: "Vyberte prosÃ­m zÃ¡kaznÃ­ka",
        dateFilter: "FlitrovÃ¡nÃ­ dle data",
        enterPin: "Zadejte svÅ¯j PIN",
        enterTheNumberOfPackages: "Zadejte poÄet balenÃ­",
        existingCustomer: "UÅ¾ivatel jiÅ¾ existuje",
        fandeckPlease: "ProsÃ­m vyberte vzornÃ­k",
        fillCanisterHistory: "Historie plnÄnÃ­ kanystru",
        findCustomer:
            " Pro pÅiÅazenÃ­ zÃ¡kaznickÃ© karty k tÃ©to objednÃ¡vce naskenujte ÄÃ¡rovÃ½ kÃ³d nebo zadejte e-mailovou adresu",
        findCustomerByEmail: "FiltrovÃ¡nÃ­ zÃ¡kaznÃ­kÅ¯ dle emailu nebo ÄÃ¡rovÃ©ho kÃ³du",
        finishPreviousStep: "(DokonÄete pÅedchozÃ­ krok)",
        formulaUnit: "Jednotky receptury",
        getBackToList: "ZpÄt na seznam zÃ¡kaznÃ­kÅ¯",
        historyOfOrders: "Historie objednÃ¡vek",
        insertNote: "VloÅ¾it poznÃ¡mku",
        loadHistoryOrder: "Chcete naÄÃ­st vybranou objednÃ¡vku?",
        loyaltyCards: "ZÃ¡kaznickÃ© karty",
        machineIsAvailable: "Stroj je pÅipraven.",
        machineIsUnavailable: "Stroj nenÃ­ dostupnÃ½.",
        newLoyaltyCard: "NovÃ¡ zÃ¡kaznickÃ¡ karta",
        noAvailableMachine: "Stroj nenÃ­ dostupnÃ½",
        noCustomerSelected: "NenÃ­ vybrÃ¡n Å¾Ã¡dnÃ½ zÃ¡kaznÃ­k. Opravdu chcete pokraÄovat?",
        notePlease: "VloÅ¾te poznÃ¡mku, prosÃ­m.",
        openHistory: "OtevÅÃ­t Historii",
        orAdd: "nebo pÅidejte zÃ¡kaznÃ­ka",
        orSelect: "nebo vyberte zÃ¡kaznÃ­ka",
        orderModification: "PÅ¯vodnÃ­ objednÃ¡vka bude zmÄnÄna. Opravdu chcete pokraÄovat?",
        orderOverview: "ShrnutÃ­ objednÃ¡vky",
        orderToMachine: "Odeslat objednÃ¡vku ke zpracovÃ¡nÃ­",
        ordersHistory: "Historie objednÃ¡vek",
        packagePlease: "Vyberte prosÃ­m balenÃ­",
        pleaseSelectBrand: "Vyberte prosÃ­m znaÄku",
        previewImage: "NÃ¡hled obrÃ¡zku",
        previewPackage: "NÃ¡hled balenÃ­",
        productPlease: "ProsÃ­m vyberte produkt",
        resetFilters: "ZruÅ¡it vÅ¡echny filtry",
        searchForHistoricalOrders: "Nebo hledejte ve starÅ¡Ã­ch objednÃ¡vkÃ¡ch",
        selectBrand: "Vyberte prosÃ­m znaÄku.",
        selectColor: "Vyberte barvu",
        selectCustomer: "Vyberte zÃ¡kaznÃ­ka",
        selectExistingCustomer: "Vybrat existujÃ­cÃ­ho zÃ¡kaznÃ­ka",
        selectFandeck: "Vyberte vzornÃ­k",
        selectManually: "Pokud chcete pouÅ¾Ã­t tento odstÃ­n ve %{brandNames}, vyberte ho prosÃ­m ruÄnÄ.",
        selectPackage: "Vyberte balenÃ­",
        selectProduct: "Vyberte produkt",
        shotsCoefficient: "Koeficient shotÅ¯",
        showDetail: "Zobrazit detail",
        showHideEshopName: "Zobrazit/skÃ½t pro barvu nÃ¡zev obchodu v oddÄlenÃ©m sloupci",
        showKeyboard: "Zobrazit klÃ¡vesnici",
        skipCustomerButton: "PÅeskoÄit vÃ½bÄr zÃ¡kaznÃ­ka",
        skipCustomerText: "PÅeskoÄit vÃ½bÄr zÃ¡kaznÃ­ka",
        skipNote: "PÅeskoÄit zadÃ¡nÃ­ poznÃ¡mky a zobrazit souhrn",
        spectroBrand: "HledÃ¡nÃ­ ve znaÄce %{brandName}",
        statusAccepted: "pÅijatÃ¡",
        statusCanceled: "zruÅ¡enÃ¡",
        statusCreated: "vytvoÅenÃ¡",
        statusDone: "hotovÃ¡",
        statusPartlyDone: "ÄÃ¡steÄnÄ hotovÃ¡",
        statusPreparing: "pÅÃ­prava",
        summaryChosenBase: "BÃ¡ze",
        summaryChosenBrand: "ZnaÄka",
        summaryChosenCanSize: "Velikost plechovky",
        summaryChosenColor: "Barva",
        summaryChosenColorCard: "BarevnÃ¡ karta",
        summaryChosenProduct: "Produkt",
        summaryChosenQuantity: "MnoÅ¾stvÃ­",
        summaryColorPreview: "color preview",
        summaryCustomNote: "VlastnÃ­ poznÃ¡mka",
        summaryCustomerNumber: "ÄÃ­slo zÃ¡kaznÃ­ka",
        summaryFormula: "ReceptÃºra",
        summaryFormulaNote: "PoznÃ¡mka k receptÃºre",
        summaryNote: "PoznÃ¡mka",
        sureAboutSend: " UrÄitÄ chcete odeslat objednÃ¡vku?",
        useCustomerInOrder: "Chcete pÅiÅadit %{customerName} k nÃ¡sledujÃ­cÃ­ objednÃ¡vce?",
        uuid: "Uuid",
        viewSummary: "Zobrazit souhrn",
        volume: "Intenzita "
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "PotvrzenÃ­ objednÃ¡vky PIN kÃ³dem",
        pinScreenSaverConfirmation: "PotvrzenÃ­ nastavenÃ­ PIN kÃ³du spoÅiÄe obrazovky",
        pinSettingsConfirmation: "PotvrzenÃ­ nastavenÃ­ PIN kÃ³du",
        printAuto: "Povolit automatickÃ½ tisk",
        printerSettings: "NastavenÃ­ tisku",
        selectColorWithFandeck: "SpoleÄnÃ½ vÃ½bÄr barvy a vzorkovnice",
        setKeyboard: "Nastavit klÃ¡vesnici",
        setKioskMode: "NastavenÃ­ kioskovÃ©ho mÃ³du",
        setLanguage: "Nastavit jazyk",
        setModule: "Nastavit modul",
        setQuickSelect: "NastavenÃ­ rychlÃ©ho vÃ½bÄru",
        setScreensaverTimeout: "NastavenÃ­ ÄasovaÄe spoÅiÄe obrazovky",
        setUnit: "NastavenÃ­ jednotky"
    },
    customRedlikeMachine: {
        action: "Akce",
        additionalPrint: "DalÅ¡Ã­ tisk",
        brand: "ZnaÄka",
        brandAccess: "UÅ¾ivatel '%{userName}' NemÅ¯Å¾e zÃ­skat pÅÃ­stup k datÅ¯m od znaÄky '%{brandName}'",
        can: "UmÃ­stÄte plechovku",
        canistersLevel: "PÅehled ÃºrovnÃ­ zÃ¡sobnÃ­kÅ¯",
        closeDetailInformation: "ZavÅÃ­t detail",
        colorantsAmount: "MnoÅ¾stvÃ­ kolorantÅ¯",
        confirmRefill: "Potvrdit doplnÄnÃ­ kolorantu",
        deleteOrder: "Smazat objednÃ¡vku",
        dialogNoMachine: "Stroj nenÃ­ pÅipojen",
        dialogNoRcc: "NenÃ­ pÅipojeno Å¾Ã¡dnÃ© RCC",
        dispense: "TÃ³novÃ¡nÃ­",
        dispenserInErrorState: "Stroj je v chybnÃ©m stavu",
        dispensingIsOk: "Stroj je OK",
        emergencyButtonPressed: "NouzovÃ© tlaÄÃ­tko stisknuto",
        errorCode: "ChybovÃ½ kÃ³d",
        errorEvents: "Chyba stroje",
        errorReset: "Restart chyby",
        explanation: "VysvÄtlenÃ­",
        imageNotAvailable: "ObrÃ¡zek nenÃ­ k dispozici",
        incorrectCanister: "NaskenovÃ¡n nesprÃ¡vnÃ½ zÃ¡sobnÃ­k",
        incorrectColorant: "NaskenovÃ¡n nesprÃ¡vnÃ½ balÃ­Äek kolorantu",
        lastEvents: "PoslednÃ­ udÃ¡losti",
        machineActions: "Status dÃ¡vkovaÄe ",
        machineConfiguration: "Konfigurace tÃ³novacÃ­ho stroje",
        machineError: "Chyba stroje",
        machineIsBusy: "Stroj je zaneprÃ¡zdnÄn",
        machineNotAvailable: "Stroj nenÃ­ dostupnÃ½",
        machineTinting: "PoÄkejte prosÃ­m, stroj tÃ³nuje",
        manualScan: "ManuÃ¡lnÃ­ skenovÃ¡nÃ­",
        notEnoughSpace: "CHYBA: Nesdostatek mÃ­sta pro toto balenÃ­ kolorantu",
        numberOfCanistersUnderCriticalLevel: "PoÄet kanystrÅ¯ pod kritickou hladinou je %{0}",
        numberOfCanistersUnderWarningLevel: "PoÄet kanystrÅ¯ pod varovnou hladinou je %{0}",
        offlinePressed: "Stisknuto tlaÄÃ­tko offline",
        orderSettings: "Nastaveni objednÃ¡vky",
        otherOrderInformation: "Detail objednÃ¡vky",
        packageCount: "PoÄet balenÃ­",
        packageWithSeparator: "BalenÃ­",
        received: "PÅijatÃ©",
        receivedOrders: "PÅijatÃ© objednÃ¡vky",
        receivedTime: "Äas pÅijetÃ­ objednÃ¡vky",
        recirculation: "Recirkulace",
        refillInformation: "Kolorant: %{0}, PlnÄnÃ­: %{1}, Kanystr: %{2}",
        resetErrors: "Resetovat chyby",
        scanCanister: "Sken kanystru",
        scanColorantPackage: "NaÄtÄte odpovÃ­dajÃ­cÃ­ balenÃ­ kolorantu",
        selectedOrder: "VybranÃ¡ objednÃ¡vka",
        shelfMovingDown: "StÅ¯l se pohybuje smÄrem dolÅ¯",
        shelfMovingUp: "StÅ¯l se pohybuje smÄrem nahoru",
        solution: "ÅeÅ¡enÃ­",
        startDispensing: "ZaÄÃ­t tÃ³novÃ¡nÃ­",
        stirring: "MÃ­chanÃ­",
        touchToStartFilling: "StisknutÃ­m zaÄente doplÅovat kolorant",
        unknownBrand: "NeznÃ¡mÃ¡ znaÄka"
    },
    customRedlikeSettings: {
        addPos: "Pos Info",
        addServer: "PÅidat server",
        adminOperations: "SprÃ¡vcovskÃ© operace",
        adminSettings: "NastavenÃ­ admina",
        another: "OstatnÃ­",
        aslOrService: "ASL nebo sluÅ¾ba",
        availableMachines: "DostupnÃ© stroje",
        barcode: "ÄÃ¡rovÃ½ kÃ³d",
        basicOperations: "ZÃ¡kladnÃ­ operace",
        canisterBarcodes: "ÄÃ¡rovÃ© kÃ³dy kanystrÅ¯",
        canisterLevels: "Hladiny kanystrÅ¯",
        closeConnection: "Odpojit",
        closeRedlike: "ZavÅÃ­t %{name}",
        databaseList: "DatabÃ¡ze",
        disabledStatus: "deaktivovÃ¡no",
        dispenseLogicType: "Typ logiky tÃ³novÃ¡nÃ­",
        dropServers: "Smazat servry",
        editServer: "Upravit server",
        lastEvent: "'PoslednÃ­ udalost",
        logOut: "OdhlÃ¡sit",
        machineConfiguration: "NastavenÃ­",
        maxDispenseAmount: "MaximÃ¡lnÃ­ tÃ³novatelnÃ© mnoÅ¾stvÃ­",
        offlineStatus: "neaktivnÃ­",
        onlineStatus: "aktivnÃ­",
        openFrondesk: "OtevÅÃ­t frontdesk",
        print: "NastavenÃ­ tisku",
        rebootPC: "Restartovat PC",
        restartRedlike: "Restartovat %{name}",
        restoreConnection: "Obnovit pÅipojenÃ­",
        scanCanisterBarcode: "Naskenovat ÄÃ¡rovÃ½ kÃ³d kanystru",
        scanOrDeleteCanisterBarcode: "Naskenovat nebo smazat ÄÃ¡rovÃ½ kÃ³d",
        setCanisterBarcode: "Nastavit ÄÃ¡rovÃ½ kÃ³d kanystrÅ¯",
        swVersion: "Verze software",
        systemFunctions: "Funkce systÃ©mu",
        userSettings: "UÅ¾ivatelskÃ© nastavenÃ­"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Upravit barvu",
        editColorant: "Upravit kolorant",
        emptyColorant: "Kolorant nemÃ¡ zadanÃ© mnoÅ¾stvÃ­",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Receptura master produktu",
        formulaForMasterProductWithParam: "Receptura hlavnÃ­ho produktu %{productName}",
        isNotAvailable: "NenÃ­ dostupnÃ©",
        noBaseSelected: "Nutno vybrat bÃ¡zi",
        noColorantsSelected: "Nejsou vybrÃ¡ny Å¾Ã¡dnÃ© koloranty",
        noFandeckSelected: "Nutno vybrat vzorkovnici",
        noNameOrCode: "Nutno zadat nÃ¡zev a kÃ³d barvy",
        noProductSelected: "Nutno zadat produkt",
        productPreview: "NÃ¡hled produktu",
        saveCustomRecipe: "UloÅ¾it vlastnÃ­ recepturu",
        saveIsNotAvailable: "Nelze uloÅ¾it",
        showSiblingProducts: "Zobrazit blÃ­zkÃ© produkty",
        siblingProducts: "BlÃ­zkÃ© produkty dle hlavnÃ­ho produktu"
    },
    customersTab: {
        addCustomer: "PÅidat zÃ¡kaznÃ­ka",
        additionalSettings: "DalÅ¡Ã­ nastavenÃ­",
        adress: "Adresa",
        createAndSelect: "VytvoÅit a zvolit",
        createNewCustomer: "VytvoÅit novÃ©ho zÃ¡kaznÃ­ka",
        editCustomer: "Upravit zÃ¡kaznÃ­ka",
        expiration: "Platnost zÃ¡kaznÃ­ka %{name} vyprÅ¡Ã­ za %{dayCount} dnÃ­",
        identificationNumber: "IdentifikaÄnÃ­ ÄÃ­slo",
        information: "KontaktnÃ­ informace",
        listOfCustomers: "Seznam zÃ¡kaznÃ­kÅ¯",
        rabat: "Sleva",
        selectCustomer: "Zvolit zÃ¡kaznÃ­ka",
        spentLastMonth: "Utraceno minulÃ½ mÄsÃ­c",
        spentMoney: "UtracenÃ© penÃ­ze",
        typeOfMargin: "Typ marÅ¾e",
        zipCode: "PSÄ"
    },
    dialog: {
        cheaperColorSearch: "ProbÃ­hÃ¡ vyhledÃ¡vÃ¡nÃ­ levnÄjÅ¡Ã­ho odstÃ­nu",
        competitiveColorSearch: "ProbÃ­hÃ¡ vyhledÃ¡vÃ¡nÃ­ konkurenÄnÃ­ch odstÃ­nÅ¯",
        reallyChangeModule: "Obravdu chcete zmÄnit modul?",
        reallyCloseRedlike:
            "Opravdu chcete zavÅÃ­t %{name}? VÅ¡echny panely %{name} budou uzavÅeny a neuloÅ¾enÃ© zmÄny budou ztraceny.",
        reallyDeleteOrder: "Opravdu chcete tuto objednÃ¡vku smazat?",
        reallyRebootPC:
            "Opravdu chcete restartovat tento poÄÃ­taÄ? VÅ¡echny panely budou uzavÅeny a neuloÅ¾enÃ© zmÄny budou ztraceny.",
        reallyRestartRedlike:
            "Opravdu chcete restartovat %{name}? VÅ¡echny panely budou uzavÅeny a neuloÅ¾enÃ© zmÄny budou ztraceny.",
        reallyShutdownPc:
            "Opravdu chcete tento poÄÃ­taÄ vypnout? VÅ¡echny panely %{name} budou uzavÅeny a neuloÅ¾enÃ© zmÄny budou ztraceny.",
        unlockComputer: "PoÄÃ­taÄ bude odemÄen."
    },
    dispenseLogicTypes: {
        1: "TÃ³novat pouze maximÃ¡lnÄ vytÃ³novatelnÃ© mnoÅ¾stvÃ­",
        2: "Povolit ruÄnÃ­ tÃ³novÃ¡nÃ­ pomocÃ­ stupnice pro mnoÅ¾stvÃ­ pÅesahujÃ­cÃ­ maximÃ¡lnÃ­ tÃ³novacÃ­ mnoÅ¾stvÃ­",
        3: "PlnÄnÃ­ bÄhem tÃ³novÃ¡nÃ­ (rozdÄlit mnoÅ¾stvÃ­ na menÅ¡Ã­ ÄÃ¡sti)",
        4: "Vynutit ruÄnÃ­ tÃ³novanÃ­ pomocÃ­ vÃ¡hy pouze v pÅÃ­padÄ vlastnÃ­ velikosti balenÃ­"
    },
    editCustomFandeck: {
        fandeckName: "NÃ¡zev vzornice"
    },
    editFormulaRgbModal: {
        apply: "Upravit",
        blue: "ModrÃ¡",
        green: "ZelenÃ¡",
        modalLabel: "Upravit barvu",
        red: "ÄervenÃ¡",
        tryGenerateRgb: "Pokusit se vygenerovat RGB dle mnoÅ¾stvÃ­ kolorantu"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Automaticky zavÅÃ­t zÃ¡loÅ¾ku receptury",
        allowBarcodes: "Povolit ÄÃ¡rovÃ© kÃ³dy",
        allowBuildingSitePanel: "Povolit specifikaci staveniÅ¡tÄ",
        allowCustomers: "Povolit zÃ¡kaznÃ­ky",
        allowDeleteConfirmation: "Povolit potvrzenÃ­ odstranÄnÃ­",
        allowDiskSpaceNotification: "Povolit upozornÄnÃ­ mÃ­sto na disku",
        allowDispensing: "Povolit tÃ³novÃ¡nÃ­",
        allowFileTransfer: "Povolit automatickÃ½ pÅenos souborÅ¯",
        allowFormulaModificationPanel: "Povolit panel s datem Ãºpravy receptury",
        allowFormulaStatusPanel: "Povolit stavovÃ½ panel receptury",
        allowInternalNotes: "Povolit internÃ­ poznÃ¡mky",
        allowLight: "Povolit %{name}",
        allowOrderNotificationModal: "Zobrazit upozornÄnÃ­ na novÃ© objednÃ¡vky",
        allowOrdering: "Povolit objednÃ¡vky",
        allowPricing: "Povolit ceny",
        allowPrint: "Povolit tisk",
        allowProductPreviewImage: "Povolit nÃ¡hled obrÃ¡zku produktu pÅi tÃ³novÃ¡nÃ­",
        allowQualityControl: "Povolit kontrolu kvality",
        allowSearchCheaperColors: "Povolit vyhledÃ¡vÃ¡nÃ­ levnÄjÅ¡Ã­ch odstÃ­nÅ¯",
        allowSound: "Povolit zvukovÃ© upozornÄnÃ­",
        allowSpectro: "Povolit spektrometr",
        allowTabs: "Povolit karty",
        applyZoom: "Potvrdit",
        automaticLogout: "AutomatickÃ© odhlÃ¡Å¡enÃ­",
        barcodeScan: "ÄtenÃ­ ÄÃ¡rovÃ½ch kÃ³dÅ¯",
        canisterBarcode: "ÄÃ¡rovÃ© kÃ³dy kanystrÅ¯",
        canisterLevel: "Hladina kanystrÅ¯",
        changelog: "Seznam zmÄn",
        closeTab: "ZavÅÃ­t zÃ¡loÅ¾ku",
        colorDifference: "BarevnÃ½ rozdÃ­l",
        colorPanelNavItem: "Paleta barev",
        competitiveColorSearch: "VyhledÃ¡vÃ¡nÃ­ konkurenÄnÃ­ch odstÃ­nÅ¯",
        customBanner: "VlastnÃ­ banner",
        customCurrencyFormat: "FormÃ¡t mÄny",
        customDateFormat: "FormÃ¡t data",
        customNumberFormat: "FormÃ¡t ÄÃ­sla",
        customTimeFormat: "FormÃ¡t Äasu",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Zobrazit slevu",
        dispensingHistory: "Historie tÃ³novÃ¡nÃ­",
        dispensingNotes: "Povolit poznÃ¡mku k tÃ³novÃ¡nÃ­",
        enableCustomers: "NastavenÃ­ zÃ¡kazÃ­kÅ¯",
        enableDeleteConfirmation: "NastavenÃ­ potvrzenÃ­ odstranÄnÃ­",
        enableDispensing: "NastavenÃ­ tÃ³novÃ¡nÃ­",
        enableLight: "NastavenÃ­ %{name}",
        enableMarginMarkup: "Povolit marÅ¾i nebo obchodnÃ­ pÅirÃ¡Å¾ku",
        enableNotes: "Povolit poznÃ¡mky",
        enableOrdering: "NastavenÃ­ objednÃ¡vek",
        enableProductPreviewImage: "NastavenÃ­ nÃ¡hledu obrÃ¡zku produktu",
        enableSpectro: "NastavenÃ­ spektrometru",
        enableVirtualKeyboard: "Povolit virtuÃ¡lnÃ­ klÃ¡vesnici",
        environmentsSettings: "NastavenÃ­ prostÅedÃ­",
        exportTranslationKeys: "Export pÅekladovÃ½ch klÃ­ÄÅ¯",
        formulaNotes: "Povolit poznÃ¡mky k receptuÅe",
        hintTooltips: "Zobrazit nÃ¡povÄdu",
        image: "ObrÃ¡zek",
        keyboardShortcuts: "KlÃ¡vesovÃ© zkratky",
        languageBased: "Na zÃ¡kladÄ jazyka",
        lockYourComputer: "Uzamknout poÄÃ­taÄ",
        machineReset: "Reset stroje",
        manageTranslations: "Spravovat pÅeklady",
        margin: "Jenom marÅ¾e",
        markup: "Jenom obchodnÃ­ pÅirÃ¡Å¾ka",
        matchingRowCount: "Nastavte poÄet nalezenÃ½ch vÃ½sledkÅ¯",
        maxNumberTabs: "MaximÃ¡lnÃ­ poÄet zÃ¡loÅ¾ek s recepturou",
        memoryTabs: "UloÅ¾it nedÃ¡vno otevÅenÃ© karty",
        moreInfo: "Barva + obrÃ¡zek + dalÅ¡Ã­ informace",
        navigationItems: "NastavenÃ­ navigaÄnÃ­ch poloÅ¾ek",
        newTab: "NovÃ¡ zÃ¡loÅ¾ka",
        numberOfPriceGroups: "PoÄet cenovÃ½ch skupin",
        order: "ObjednÃ¡vka",
        orderId: "ID objednÃ¡vky",
        ordersHistory: "Historie objednÃ¡vek",
        overwriteLastTab: "PÅepsat pÅedchozÃ­ panel receptury",
        priceCalculation: "VÃ½poÄet ceny",
        priceDefBothPurchasePrimary: "PouÅ¾Ã­t obÄ ceny, upÅednostnit nÃ¡kupnÃ­",
        priceDefBothSellPrimary: "PouÅ¾Ã­t obÄ ceny, upÅednostnit prodejnÃ­",
        priceDefPurchaseOnly: "Pouze nÃ¡kupnÃ­ ceny",
        priceDefSellOnly: "Pouze prodejnÃ­ ceny",
        priceDefinition: "StanovenÃ­ ceny",
        priceGroupsEnabled: "Povolit cenovÃ© skupiny",
        runLightAtStartUp: "Spustit %{light} pÅi startu",
        screenSaverTimeout: "ÄasovÃ½ limit spoÅiÄe obrazovky",
        selectedSpectro: "VybranÃ© %{spectro} spektro.",
        selectedSpectroNone: "NenÃ­ vybranÃ© Å¾Ã¡dne spektro.",
        setAutomaticClientStart: "Spustit %{name} pÅi startu poÄÃ­taÄe",
        setCustomHomeButton: "Nastavit vlastnÃ­ tlaÄÃ­tko v navigaÄnÃ­ch poloÅ¾kÃ¡ch",
        setDecimalPlaces: "Nastavit poÄet desetinnÃ½ch mÃ­st",
        setFormulaPreview: "Nastavit nÃ¡hled receptury",
        setFormulaUnit: "Nastavit mÄrnou jednotku receptury",
        setFts: "VyhledÃ¡vanÃ­ plnÃ©ho textu",
        setInfoItemInRgb: "Nastavit informaci viditelnou v nÃ¡hledu barvy",
        setKeyboardShortcuts: "Nastavit klÃ¡vesovÃ© zkratky",
        setKioskMode: "NastavenÃ­ reÅ¾imu kiosku",
        setKioskModeOff: "Vypnout reÅ¾im kiosku",
        setKioskModeOn: "Zapnout reÅ¾im kiosku",
        setNavigationItems: "Nastavte navigaÄnÃ­ poloÅ¾ky",
        setNavigationItemsList: "Nastavte viditelnost a poÅadÃ­ navigaÄnÃ­ch poloÅ¾ek",
        setOrderSearchItems: "Nastavit parametry pro vyhledÃ¡vÃ¡nÃ­ objednÃ¡vek",
        setRounding: "Nastavte zaokrouhlovÃ¡nÃ­",
        setSearchParameters: "Nastavit parametry pro vyhledÃ¡vÃ¡nÃ­ odstÃ­nÅ¯",
        setTabLimit: "Nastavit limit zÃ¡loÅ¾ek",
        setYourLanguage: "Nastavit jazyk",
        setZoom: "NastavenÃ­ pÅiblÃ­Å¾enÃ­",
        showLocalPrices: "Zobrazit lokÃ¡lnÃ­ ceny",
        skipPlaceCanDialogEnabled:
            "Toto nastavenÃ­ nelze zmÄnit, protoÅ¾e dialog nastavenÃ­ umÃ­stnÄnÃ­ byl deaktivovÃ¡n v nastavenÃ­ stroje",
        sortItems: "UspoÅÃ¡dat navigaÄnÃ­ poloÅ¾ky",
        startDispensing: "ZaÄÃ­t tÃ³novÃ¡nÃ­",
        stir: "PromÃ­chÃ¡nÃ­"
    },
    error: {
        errorDetail: "Detail chyby",
        errorOccurred:
            "Objevila se neoÄekÃ¡vanÃ¡ chyba. Kontaktujte prosÃ­m naÅ¡i podporu na %{0}, ozveme se VÃ¡m co nejdÅÃ­ve to bude moÅ¾nÃ©.",
        hideDetail: "SkrÃ½t detail"
    },
    favoritesTab: {
        addFolder: "PÅidat sloÅ¾ku",
        closeTabToLoadFormula:
            "ZavÅete prosÃ­m jednu z receptur, abyste mohli otevÅÃ­t novou zÃ¡loÅ¾ku. DosÃ¡hli jste maximÃ¡lnÃ­ho poÄtu zÃ¡loÅ¾ek.",
        deleteFolder: "Smazat sloÅ¾ku",
        editFolder: "Upravit sloÅ¾ku",
        favoriteFormulas: "OblÃ­benÃ© receptury",
        formulaNotes: "PoznÃ¡mky k odstÃ­nu",
        message: {
            formulasFromFolder: "Receptury ze sloÅ¾ky",
            moveAllFormulas: "PÅesunout vÅ¡echny receptury z tÃ©to sloÅ¾ky do nadÅazenÃ© sloÅ¾ky",
            removeAllFormulas: "Odstranit vÅ¡echny receptury z tÃ©to sloÅ¾ky",
            wantToDeleteFolder: "Opravdu chcete smazat tuto sloÅ¾ku?"
        },
        newFolder: "NovÃ¡ sloÅ¾ka",
        packages: "BalenÃ­",
        pricePerPackage: "Cena za balenÃ­",
        regularPrice: "BÄÅ¾nÃ¡ cena",
        removeFromFavorites: "Odstranit z oblÃ­benÃ½ch",
        specialPriceOff: "SpeciÃ¡lnÃ­ cena %{number}% z",
        specialPriceVIP: "SpeciÃ¡lnÃ­ cena VIP"
    },
    fileTransfer: {
        afterImport: "Po importu",
        alreadyExists: "Ãloha pro danÃ½ typ a formÃ¡t jiÅ¾ existuje",
        customFormulaSimple: "VlastnÃ­ formula jednoÅ¡e ",
        direction: "SmÄr",
        exportTask: "Ãloha exportu souborÅ¯",
        fileTransferNotification: "OznÃ¡menÃ­ o pÅenosu souboru",
        flashMessage: "BleskovÃ¡ zprÃ¡va",
        importTask: "Ãloha importu souboru",
        noInformation: "Å½Ã¡dnÃ© informace",
        protocol: {
            folder: "SloÅ¾ka",
            ftp: "Protokol FTP",
            ftps: "Protokol FTPS",
            redlikeStorage: "%{softwareName} Protokol ÃºloÅ¾iÅ¡tÄ FTP",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Soubory kontroly protokolu v definovanÃ© mÃ­stnÃ­ sloÅ¾ce.",
            ftp: "Kontrola protokolu ve vzdÃ¡lenÃ© sloÅ¾ce FTP pomocÃ­ standardnÃ­ho pÅipojenÃ­ FTP.",
            ftps: "Kontrola protokolÅ¯ souborÅ¯ na vzdÃ¡lenÃ©m serveru FTPS (FTP-SSL / FTP Secure) pomocÃ­ standardnÃ­ho pÅipojenÃ­ FTP.",
            redlikeStorage: "Protokol kontrolujÃ­cÃ­ soubory v ÃºloÅ¾iÅ¡ti %{softwareName}."
        },
        remoteFolder: "VzdÃ¡lenÃ¡ sloÅ¾ka",
        startType: "ZpÅ¯sob spuÅ¡tÄnÃ­",
        statusbar: "Informace stavovÃ©ho ÅÃ¡dku",
        testConnection: "Test pÅipojenÃ­",
        xMoreLeft: "(zbÃ½vÃ¡ %{amount})",
        xmlImporting: "ProbÃ­hÃ¡ import souboru XML"
    },
    filtering: {
        consumptionType: "Typ spotÅeby",
        filter: "Filtr",
        from: "Od",
        to: "Do"
    },
    findText: {
        findTextTitle: "NajÃ­t text",
        removeMarks: "Odstranit znaÄenÃ­",
        search: "Hledat slovo"
    },
    flashMessage: {
        VMNotAllowed: "VirtuÃ¡lnÃ­ stroj nenÃ­ povolen",
        addedToStock: "PoloÅ¾ky byly ÃºspÄÅ¡nÄ pÅidÃ¡ny do skladu.",
        allRecordsDeleted: "VÅ¡echny importovanÃ© zÃ¡znamy byly ÃºspÄÅ¡nÄ smazÃ¡ny",
        autologinFailed: "AutomatickÃ© pÅihlÃ¡Å¡enÃ­ k databÃ¡zi selhalo.",
        autotaskDuplicateName:
            "Chyba integrity databÃ¡ze: %{0} poloÅ¾ka s %{1} %{2} jiÅ¾ existuje, prosÃ­m pouÅ¾ijte jinÃ½ %{3}",
        barcodeIsUsed: "ÄÃ¡rovÃ½ kÃ³d byl jiÅ¾ pouÅ¾it.",
        barcodeNotFound: "ÄÃ¡rovÃ½ kÃ³d nebyl nalezen",
        bugReportSent: "VaÅ¡e zprÃ¡va o chybÄ byla odeslÃ¡na.",
        cannoctConnectToServer: "NenÃ­ moÅ¾nÃ© se pÅipojit k serveru",
        cannotWriteLicense: "NenÃ­ moÅ¾nÃ© zapsat licenci",
        clientConnectionRejected: "SpojenÃ­ odmÃ­tnuto",
        clientNotLoggedIn: "Klient nenÃ­ pÅihlÃ¡Å¡en",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "BalenÃ­ kolorantu bylo ÃºspÄÅ¡nÄ odebrÃ¡no ze skladu.",
        competitiveSearchEmpty:
            "Å½Ã¡dnÃ© konkurenÄnÃ­ odstÃ­ny nebyly nalezeny. ZmÄÅte parametry vyhledÃ¡vÃ¡nÃ­ nebo zvolte jinÃ½ odstÃ­n.",
        competitiveSearchSelectProduct: "Vyberte produkt pro zahÃ¡jenÃ­ konkurenÄnÃ­ho vyhledÃ¡vÃ¡nÃ­ odstÃ­nÅ¯.",
        computerBackdated: "Äas na poÄÃ­taÄi byl posunut dozadu",
        connectionFailed: "Test pÅipojenÃ­ se nezdaÅil: %{0}",
        connectionSuccess: "Test pÅipojenÃ­ probÄhl ÃºspÄÅ¡nÄ",
        corruptedLicenseFile: "LicenÄnÃ­ soubor je poÅ¡kozen",
        customFormulaCreated: "VlastnÃ­ receptura byla ÃºspÄÅ¡nÄ vytvoÅena.",
        customFormulaCreationError: "Chyba pÅi vytvÃ¡ÅenÃ­ vlastnÃ­ receptury.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "ZÃ¡kaznÃ­k nebyl nalezen.",
        dataNotAvailable: "Server se nemÅ¯Å¾e pÅipojit k databÃ¡zi",
        datacolorMatching: {
            couldNotConnect: "Nelze se pÅipojit k Datacolor Matchingu, server nenÃ­ dostupnÃ½ nebo poÄÃ­taÄ je offline.",
            disabled: "Datacolor Matching zakÃ¡zÃ¡n.",
            internalError: "Datacolor Matching internÃ­ chyba: '%{0}'",
            invalidCredentials:
                "Nejsou zadÃ¡ny Å¾Ã¡dnÃ© nebo neplatnÃ© pÅihlaÅ¡ovacÃ­ Ãºdaje pro Datacolor Matching, kontaktujte poskytovatele databÃ¡ze.",
            noCansAvailable:
                "Pro vybranÃ½ colorfile (produkt line) nejsou k dispozici Å¾Ã¡dnÃ© balenÃ­, kontaktujte poskytovatele databÃ¡ze."
        },
        defaultMessage: "BÄhem poslednÃ­ akce nastala neoÄekÃ¡vanÃ¡ chyba",
        deleteAll: "Smazat vÅ¡echno",
        deletingImportedData: "MazÃ¡nÃ­ importovanÃ½ch zÃ¡znamÅ¯.",
        disableWinterPlugin: "ZimnÃ­ plugin mÅ¯Å¾ete vypnout pomocÃ­ rozevÃ­racÃ­ho seznamu na pravÃ© stranÄ navigace tabÅ¯",
        duplicateBarcode: "Tento ÄÃ¡rovÃ½ kÃ³d jiÅ¾ existuje.",
        duplicateName: "Tento nÃ¡zev jiÅ¾ existuje",
        emptyFandeck: "VybranÃ¡ vzorkovnice je prÃ¡zdnÃ¡.",
        emptyStock: "Pro poloÅ¾ku, kterou hledÃ¡te, nejsou Å¾Ã¡dnÃ© zÃ¡znamy na skladÄ.",
        expiredLicense: "Licence vyprÅ¡ela",
        exportSuccess: "Data byla ÃºspÄÅ¡nÄ exportovÃ¡na",
        fandeckExist: "Toto jmÃ©no vzorkovnice jiÅ¾ existuje.",
        featureNotAutorized: "Funkce nenÃ­ autorizovÃ¡na",
        fileExportComplete: "Soubor byl ÃºspÄÅ¡nÄ exportovÃ¡n",
        fileExportError: "PÅi exportu souboru doÅ¡lo k chybÄ.",
        fileSaveComplete: "Soubor byl ÃºspÄÅ¡nÄ uloÅ¾en.",
        fileSaveError: "Soubor byl ÃºspÄÅ¡nÄ uloÅ¾en.",
        fileTransferCustomFormulaRecordsAdded: "Z pÅijatÃ©ho souboru byly pÅidÃ¡ny novÃ© vlastnÃ­ receptury.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Nelze plnÄ zpracovat vlastnÃ­ receptury v souboru: '%{0}', dalÅ¡Ã­ informace naleznete v souborech s error logy.",
        fileTransferCustomFormulaRecordsProcessed:
            "NovÃ© vlastnÃ­ receptury (%{0} z %{1}) byly ÃºspÄÅ¡nÄ pÅidÃ¡ny z pÅijatÃ©ho souboru.",
        fileTransferCustomerRecordsAdded: "Z pÅijatÃ©ho souboru byli pÅidÃ¡ni novÃ­ zÃ¡kaznÃ­ci.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Nelze plnÄ zpracovat zÃ¡kaznÃ­ky ze souboru: '%{0}', dalÅ¡Ã­ informace naleznete v souborech s error logy.",
        fileTransferCustomerRecordsProcessed:
            "NovÃ­ zÃ¡kaznÃ­ci (%{0} of the %{1}) byli ÃºspÄÅ¡nÄ pÅidÃ¡ni z pÅijatÃ©ho souboru.",
        fileTransferFileNotProvided: "Soubor nenÃ­ poskytnut nebo je prÃ¡zdnÃ½.",
        fileTransferHistoryRecordsAdded: "Z pÅijatÃ©ho souboru byly pÅidÃ¡ny novÃ© zÃ¡znamy historie tÃ³novanÃ­.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Nelze plnÄ zpracovat Ãºdaje s historii tÃ³novanÃ­ v souboru: '%{0}', dalÅ¡Ã­ informace naleznete v souborech s error logy.",
        fileTransferHistoryRecordsProcessed:
            "NovÃ© zÃ¡znamy historie (%{0} z %{1}) byly ÃºspÄÅ¡nÄ pÅidÃ¡ny z pÅijatÃ©ho souboru.",
        fileTransferInvalidFile: "Nemohly bÃ½t zpracovÃ¡ny data v souboru, soubor nenÃ­ platnÃ½.",
        fileTransferOrderRecordsAdded: "Z pÅijatÃ©ho souboru byly pÅidÃ¡ny novÃ© zÃ¡znamy objednÃ¡vek.",
        fileTransferOrderRecordsNotFullyProcessed:
            "NepodaÅilo se plnÄ zpracovat objednÃ¡vky v souboru: '%{0}', dalÅ¡Ã­ informace naleznete v souborech s error logy.",
        fileTransferOrderRecordsProcessed: "NovÃ© objednÃ¡vky (%{0} z %{1}) byly ÃºspÄÅ¡nÄ pÅidÃ¡ny z pÅijatÃ©ho souboru.",
        fileTransferUnknownVersion: "Nemohla bÃ½t detekovÃ¡na verze souborÅ¯.",
        filetransferNoData: "Å½Ã¡dnÃ¡ komunikace s databÃ¡zÃ­, zkontrolujte nastavenÃ­.",
        formulaDataUnavailable: "Ãdaje o receptuÅe nejsou k dispozici",
        helperDefaultMessage: "BÄhem poslednÃ­ akce Helper serveru doÅ¡lo k neoÄekÃ¡vanÃ© chybÄ",
        helperServerError: "Chyba Helper serveru",
        importAborted: "Proces importu byl pÅeruÅ¡en",
        importSuccess: "Data byla ÃºspÄÅ¡nÄ importovÃ¡na",
        incompatibleBaseCan: "Plechovka bÃ¡ze nenÃ­ kompatibilnÃ­ se zvolenÃ½m produktem, bÃ¡zÃ­ a balenÃ­m",
        incorrectPassword: "VaÅ¡e starÃ© heslo nenÃ­ sprÃ¡vnÃ©. ProsÃ­m, zkuste to znovu.",
        invalidCurrency: "KÃ³d mÄny nenÃ­ platnÃ½. Euro je nastaveno jako vÃ½chozÃ­ mÄna.",
        invalidDatabaseName: "NÃ¡zev databÃ¡ze nenÃ­ platnÃ½",
        invalidEmail: "VÃ¡Å¡ email nenÃ­ platnÃ½",
        invalidFormulaColorants: "VAROVÃNÃ!!! Receptura mÅ¯Å¾e bÃ½t Å¡patnÃ¡! Kontaktujte svou podporu!",
        invalidLicenseCompanyUserKey: "NeplatnÃ½ company-user key",
        invalidLicenseFile: "NeplatnÃ½ licenÄnÃ­ soubor",
        invalidLicenseIdentificationKeys: "VaÅ¡e licenÄnÃ­ klÃ­Äe nejsou platnÃ©",
        invalidLicenseKey: "VÃ¡Å¡ licenÄnÃ­ klÃ­Ä nenÃ­ platnÃ½",
        invalidLicenseProduct: "LicenÄnÃ­ soubor neodpovÃ­dÃ¡ produktu",
        invalidRccResponse: "BÄhem zpracovÃ¡nÃ­ poslednÃ­ odpovÄdi RCC doÅ¡lo k neoÄekÃ¡vanÃ© chybÄ",
        invalidServerResponse: "Nastala neoÄekÃ¡vanÃ¡ chyba bÄhem zpracovÃ¡nÃ­ poslednÃ­ odpovÄdi ze serveru",
        invalidUrl: "URL nenÃ­ platnÃ¡",
        itemNotFound: "PoloÅ¾ka nebyla nalezena",
        keyboardShortcutUsedInModal:
            "Tuto klÃ¡vesovou zkratku nelze pouÅ¾Ã­t ve vyskakovacÃ­m oknÄ. ZavÅete prosÃ­m vyskakovacÃ­ okno.",
        keyboardShortcutValidation: "Nelze mÃ­t stejnou klÃ¡vesovou zkratku pro dvÄ rÅ¯znÃ© akce",
        licenseHasBeenRevoked: "VaÅ¡e licence byla zruÅ¡ena. Chcete-li ji obnovit, obraÅ¥te se na dodavatele software.",
        licenseProlongationNeeded:
            "Je tÅeba prodlouÅ¾enÃ­ licence (pro zÃ­skÃ¡nÃ­ novÃ© licence pÅipojte poÄÃ­taÄ k internetu).",
        licenseUpToDate: "VaÅ¡e licence je aktuÃ¡lnÃ­. NenÃ­ potÅeba Å¾Ã¡dnÃ¡ aktualizace.",
        licenseUpdateUnsuccessful: "Licence nelze aktualizovat.",
        licenseUpdated: "Licence byla ÃºspÄÅ¡nÄ aktualizovÃ¡na.",
        licensedOnDifferentComputer: "PÅ¯vodnÄ licencovÃ¡n na jinÃ©m poÄÃ­taÄi",
        logFileArchiveDownloadComplete: "StahovÃ¡nÃ­ logÅ¯ bylo ÃºspÄÅ¡nÄ dokonÄeno",
        loginError: "BÄhem pÅihlÃ¡Å¡enÃ­ doÅ¡lo k neoÄekÃ¡vanÃ© chybÄ",
        logoutError: "BÄhem odhlÃ¡Å¡enÃ­ doÅ¡lo k neoÄekÃ¡vanÃ© chybÄ",
        machineIsConnecting: "Stroj se pÅipojuje, prosÃ­m Äekejte",
        machineIsNotConnected: "VÃ¡Å¡ stroj nenÃ­ pÅipojen k RCC. Zkontrolujte prosÃ­m konfiguraci RCC.",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Korekci nelze provÃ©st, pouÅ¾ijte reformulaci.",
            forbidden: "PoÅ¾adavek '%{0}' selhal: zakÃ¡zÃ¡no.",
            internalServerError: "Internal server error.",
            invalidBase: "NeplatnÃ¡ bÃ¡ze v produktu.",
            invalidBipp: "NeplatnÃ¡ bÃ¡ze v balenÃ­ produktu.",
            invalidColorantId: "NeplatnÃ½ kolorant s ID: %{0}.",
            invalidColorantName: "NeplatnÃ½ kolorant s nÃ¡zvem: %{0}.",
            invalidColorfile: "NeplatnÃ½ colorfile s ID: %{0} pre produkt s ID: %{1}.",
            invalidIlluminant: "NeplatnÃ½ illuminant: %{0}",
            invalidProduct: "NeplatnÃ½ produkt s ID: %{0}.",
            invalidSpectralCurve: "NeplatnÃ¡ spektrÃ¡lnÃ­ kÅivka.",
            noColorfiles: "Å½Ã¡dnÃ½ colorfile nenÃ­ definovÃ¡n pro produkt s ID: %{0}.",
            notAuthorized: "PoÅ¾adavek '%{0}' selhal: neoprÃ¡vnÄno.",
            notFound: "PoÅ¾adavek '%{0}' selhal: nenalezeno.",
            reformulationNotPossible: "Reformulaci nelze provÃ©st.",
            unknownError: "NeznÃ¡mÃ¡ chyba.",
            validationError: "PoÅ¾adavek '%{0}' selhal kvÅ¯li chybÃ¡m ovÄÅovÃ¡nÃ­: %{0}."
        },
        maxFileSizeExceeded: "PÅekroÄena maximÃ¡lnÃ­ velikost souboru %{0} MB",
        maxTabs: "Byl dosaÅ¾en maximÃ¡lnÃ­ poÄet karet, zavÅete jednu prosÃ­m.",
        noTemplate: "Tisk nelze provÃ©st, protoÅ¾e nejsou k dispozici Å¾Ã¡dne Å¡ablony.",
        openNewTab: "Pro naÄtenÃ­ receptury za pomoci ÄÃ¡rovÃ©ho kÃ³du prosÃ­m otevÅete novou zÃ¡loÅ¾ku receptury.",
        orderAlreadyAcquired: "ObjednÃ¡vka jiÅ¾ byla obsazena, nejdÅÃ­v musÃ­ bÃ½t uvolnÄna",
        orderCreated: "ObjednÃ¡vka byla ÃºspÄÅ¡nÄ odeslÃ¡na",
        passwordIsNotUnique: "StarÃ© heslo se musÃ­ liÅ¡it od novÃ©ho.",
        printCannotBeCarriedOut: "Tisk nelze provÃ©st, protoÅ¾e nÃ¡zev tiskÃ¡rny je neplatnÃ½",
        problemWithFileExport: "PÅi uklÃ¡dÃ¡nÃ­ souboru se vyskytl problÃ©m.",
        productFileWarning: "Soubor produktu je dostupnÃ½ pouze online.",
        productNotLicensed: "Produkt nenÃ­ licencovÃ¡n",
        rccDefaultMessage: "BÄhem poslednÃ­ RCC akce nastala neoÄekÃ¡vanÃ¡ chyba",
        rccError: "Chyba RCC",
        rccNeedRestart: "ProsÃ­m, restartujte RCC",
        restoredSettings: "NastavenÃ­ bylo obnoveno.",
        revokedLicense: "Licence byla zruÅ¡ena",
        runningOutOfSpace: "V poÄÃ­taÄi dochÃ¡zÃ­ volnÃ© mÃ­sto.",
        savedFormulaToHistory: "Receptura byla ÃºspÄÅ¡nÄ uloÅ¾ena do historie.",
        savedLogArchive: "Logy byly ÃºspÄÅ¡nÄ uloÅ¾eny do vaÅ¡eho adresÃ¡Åe.",
        scanning: "ProbÃ­hÃ¡ proces skenovÃ¡nÃ­",
        serverError: "Chyba serveru",
        setClientIdentifier: "ProsÃ­m, nastavte identifikÃ¡tor klienta",
        showLess: "UkÃ¡zat mÃ©nÄ",
        showMore: "UkÃ¡zat vÃ­ce",
        spectroIsDisconnecting: "Spektrometr se odpÃ¡jÃ­, prosÃ­m Äekejte",
        spectroIsNotConnected: "VÃ¡Å¡ spektrometr nenÃ­ v tuto chvÃ­li pÅipojen. Zkontrolujte prosÃ­m konfiguraci RCC.",
        spectroIsNotSelected: "VÃ¡Å¡ spektrometr nenÃ­ v tuto chvÃ­li vybrÃ¡n. Zkontrolujte prosÃ­m konfiguraci RCC.",
        tmcNotAvailable: "%{tmc} nenÃ­ k dispozici. Zkontrolujte prosÃ­m svÅ¯ %{collector}.",
        tmcNotConnected: "%{tmc} nenÃ­ pÅipojeno. SpusÅ¥te prosÃ­m svÅ¯j %{collector}  a restartujte server.",
        unknownError: "NeznÃ¡mÃ¡ chyba: %{0}",
        userAlreadyLoggedIn: "Jste jiÅ¾ pÅihlÃ¡Å¡en!",
        versionNotAllowedByLicense: "Verze softwaru je pÅÃ­liÅ¡ novÃ¡ a nenÃ­ pro VaÅ¡Ã­ licenci povolena.",
        webApiConnectionError: "Nelze pÅipojit k serveru Web Api",
        webApiInternalError: "InternÃ­ chyba serveru Web Api",
        webApiInvalidUser: "NeplatnÃ½ uÅ¾ivatel serveru Web Api",
        webApiNoLicenseAvailable: "Web Api server nemÃ¡ k dispozici Å¾Ã¡dnou licenci",
        wrongDataSaved: "Do souboru XML ve sloÅ¾ce %{0} byla uloÅ¾ena nesprÃ¡vnÃ¡ data.",
        wrongHelpInput: "Å patnÃ½ formÃ¡t %{0} input.",
        wrongRccVersion: "Zkontrolujte prosÃ­m verzi vaÅ¡eho RCC. VÃ¡Å¡ klient je kompatibilnÃ­ pouze se RCC %{0}."
    },
    footer: {
        aboutApplication: "O aplikaci",
        activeUser: "AktivnÃ­ uÅ¾ivatel",
        logOut: "OdhlÃ¡sit se",
        machineErrors: "Chyby na stroji"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "VÅ¡echny jednotky dostupnÃ© v databÃ¡zi",
        allowCustomFormulas: "Povolit vlastnÃ­ receptury",
        allowCustomPackageSize: "Povolit vlastnÃ­ velikost balenÃ­",
        allowFormulaAutomaticNaming: "Povolit automatickÃ© pojmenovÃ¡nÃ­",
        automaticNaming: "AutomatickÃ© pojmenovÃ¡nÃ­ receptury",
        basePanelSize: "NastavenÃ­ velikosti panelu bÃ¡ze",
        bippPanelSize: "NastavenÃ­ bÃ¡ze na panelu balenÃ­ produktu",
        blendColorNameAndCode: "Spojit nÃ¡zev barvy s kÃ³dem barvy",
        buttonBellowMoreInfo: "Zobrazit tlaÄÃ­tko pod poznÃ¡mkou k receptuÅe",
        buttonInColorantPanel: "Zobrazit tlaÄÃ­tko na panelu kolorantÅ¯",
        colorCodePrimary: "KÃ³d barvy jako hlavnÃ­",
        colorPanel: "Paleta barev",
        colorPreviewAsImage: "ProhlÃ­Å¾et odstÃ­n ve formÄ obrÃ¡zku",
        colorPreviewResizable: "NÃ¡hled barvy s upravitelnou velikostÃ­",
        competitiveColorSearch: "VyhledÃ¡vÃ¡nÃ­ konkurenÄnÃ­ch odstÃ­nÅ¯",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "VlastnÃ­ receptury",
        customPackageSettingsUnitGrav: "VlastnÃ­ nastavenÃ­ balenÃ­ v gravimetrickÃ½ch jednotkÃ¡ch",
        customPackageSettingsUnitVol: "VlastnÃ­ nastavenÃ­ balenÃ­ ve volumetrickÃ½ch jednotkÃ¡ch",
        customPackageSize: "VlastnÃ­ velikost balenÃ­",
        customUnits: "Zvolit vlastnÃ­ jednotky",
        dropDownCalculate: "RozÅ¡Ã­Åit rozbalovacÃ­ menu na vÃ½Å¡ku okna.",
        editColorants: "Editace kolorantÅ¯",
        editColorantsAllowed: "Povolit editaci",
        fandeckPanelSize: "NastavenÃ­ velikosti panelu vÄjÃ­Åe",
        favoriteFormulas: "OblÃ­benÃ© receptury",
        formulaColorPreview: "NÃ¡hled barvy receptury",
        formulaDataSettings: "NastavenÃ­ dat o receptuÅe",
        formulaPanel: "Panel receptury",
        formulaPanelSize: "NastavenÃ­ velikosti panelu receptury",
        formulaSettings: "NastavenÃ­ receptury",
        generateColorPreview: "Generovat nÃ¡hled barvy",
        gravimetricOnly: "Pouze gravimetrickÃ© jednotky",
        hideAlternativeFormulas: "SkrÃ½t alternativnÃ­ receptury",
        hideFormulaProperties: "SkrÃ½t vlastnosti receptury",
        hideHistoricalFormulas: "SkrÃ½t historickÃ© receptury",
        imagesLocal: "PouÅ¾Ã­t pouze obrÃ¡zek z lokÃ¡lnÃ­ databÃ¡ze",
        imagesOnline: "PrimÃ¡rnÄ otevÃ­rat obrÃ¡zek online a pouze v pÅÃ­padÄ selhÃ¡nÃ­, pouÅ¾Ã­t obrÃ¡zek z lokÃ¡lnÃ­ databÃ¡ze",
        infoPanelResizable: "InformaÄnÃ­ panel s upravitelnou velikostÃ­",
        numberOfColorants: "PoÄet zobrazenÃ½ch kolorantÅ¯",
        orderByDistance: "PoÅadÃ­ vÃ½sledkÅ¯ vyhledÃ¡vÃ¡nÃ­ podle vzdÃ¡lenosti",
        productDependent: "Jednotka je zÃ¡vislÃ¡ na produktu",
        productFilesDialog: "Zobrazit dialog pro otevÅenÃ­ lokÃ¡lnÃ­ho souboru nebo souboru online",
        productFilesLocal: "PouÅ¾Ã­vat pouze sobory produktÅ¯ z lokÃ¡lnÃ­ databÃ¡ze",
        productFilesOnline:
            "PrimÃ¡rnÄ otevÃ­rat soubor online a pouze v pÅÃ­padÄ selhÃ¡nÃ­, pouÅ¾Ã­t soubor z lokÃ¡lnÃ­ databÃ¡ze",
        productPanelSize: "Nastavit velikosti panelu produktÅ¯",
        searchPanelQuickSelect: "RychlÃ½ vÃ½bÄr",
        setAdditionalFormulaPanel: "Nastavte dalÅ¡Ã­ panel receptury",
        setCompetitiveColorSearch: "Povolit hledÃ¡nÃ­ konkurenÄnÃ­ch odstÃ­nÅ¯",
        setInitialFormulaPanel: "Nastavte poÄÃ¡teÄnÃ­ panel",
        setMaxToleranceForCompetitiveColors: "Nastavit maximÃ¡lnÃ­ toleranci pro vyhledÃ¡vÃ¡nÃ­ konkurenÄnÃ­ch odstÃ­nÅ¯",
        setNumberOfCompetitiveColors: "Nastavit poÄet konkurenÄnÃ­ch master odstÃ­nÅ¯",
        setSearchPanel: "NastavenÃ­ vyhledÃ¡vacÃ­ho panelu",
        setVisibilityAndOrder: "Nastavit viditelnost a poÅadÃ­ rÅ¯znÃ½ch dat receptur",
        setVisibleUnit: "NastavenÃ­ zobrazenÃ­ jednotek",
        showColorPreview: "UkÃ¡zat nÃ¡hled barvy",
        showInFormulaStatusPanel: "Zobrazit na panelu stavu receptury",
        showInMoreInfoPanel: "Zobrazit v poznÃ¡mkÃ¡ch k receptuÅe",
        sorting: "ÅazenÃ­ panelu kolorantÅ¯",
        useBase: "PouÅ¾Ã­t poloÅ¾ku vÃ½bÄru bÃ¡ze",
        useBaseInProductPackage: "PouÅ¾Ã­t poloÅ¾ku vÃ½bÄru bÃ¡ze v balenÃ­ produktu",
        useColorCode: "PouÅ¾Ã­t kÃ³d barvy",
        useColorName: "PouÅ¾Ã­t jmÃ©no barvy",
        useFandeckGroups: "PouÅ¾ijte skupiny vzorkovnic",
        useProduct: "PouÅ¾Ã­t poloÅ¾ku vÃ½bÄru produktu",
        useProductCode: "PouÅ¾Ã­t kÃ³d produktu",
        useProductGroups: "PouÅ¾itÃ­ produktovÃ½ch skupin",
        volumetricOnly: "Pouze objemovÃ© jednotky"
    },
    general: {
        accepted: "AkceptovÃ¡no",
        active: "PoslednÃ­ aktivita",
        actual: "AktuÃ¡lnÃ­",
        actualLevel: "AktuÃ¡lnÃ­ ÃºroveÅ",
        add: "PÅidat",
        addColorant: "PÅidat kolorant",
        addColorantForPackage: "PÅidat kolorant pro balenÃ­",
        addFile: "PÅidat soubor",
        all: "VÅ¡e",
        amount: "MnoÅ¾stvÃ­",
        applyNow: "Apply now",
        attachments: "PÅÃ­lohy",
        automaticCorrection: "AutomatickÃ¡ korekce",
        automatically: "Automaticky",
        available: "DostupnÃ©",
        back: "ZpÄt",
        base: "BÃ¡ze",
        baseInProductPackage: "BÃ¡ze v produktu a balenÃ­",
        batchNumber: "ÄÃ­slo Å¡arÅ¾e",
        bottom: "Dole",
        buildingSite: "StaveniÅ¡tÄ",
        calculate: "VypoÄÃ­tat",
        can: "Plechovka",
        canSize: "Velikost plechovky",
        cancel: "ZruÅ¡it",
        canister: "Kanistr",
        canisterId: "ID kanystru",
        canisterIndex: "Index kanystru",
        canisters: "Kanystry",
        cap: "VÃ­Äko zvlhÄovaÄe trysky",
        capacity: "Kapacita",
        channels: "Okruhy",
        choose: "Vybrat",
        city: "MÄsto",
        clean: "Äistit",
        clear: "VyÄistit",
        client: "Klient",
        close: "ZavÅÃ­t",
        closeAll: "ZavÅÃ­t vÅ¡e",
        collapseAll: "ZavÅÃ­t vÅ¡echno",
        color: "OdstÃ­n",
        colorCode: "KÃ³d barvy",
        colorFile: "Colorfile",
        colorName: "JmÃ©no odstÃ­nu",
        colorPreview: "NÃ¡hled odstÃ­nu",
        colorant: "Kolorant",
        colorantBatchNumber: "ÄÃ­slo Å¡arÅ¾e kolorantu",
        colorantPackage: "BalenÃ­ kolorantu",
        colorants: "Koloranty",
        colors: "OdstÃ­ny",
        company: "Firma",
        competitiveColor: "KonkurenÄnÃ­ odstÃ­n",
        confirm: "Potvrdit",
        confirmDeletion: "Opravdu chcete tuto poloÅ¾ku trvale smazat?",
        confirmHelpSettings: "Opravdu chcete uloÅ¾it formulÃ¡Å a nechat pole prÃ¡zdna?",
        connect: "PÅipojit",
        continue: "PokraÄovat",
        correction: "Korekce",
        country: " ZemÄ",
        created: "VytvoÅeno",
        creationDateOf: "Datum vytvoÅenÃ­",
        criticalLevel: "KritickÃ¡ ÃºroveÅ",
        currency: "MÄna",
        currentBatchNumber: "AktuÃ¡lnÃ­ ÄÃ­slo Å¡arÅ¾e",
        currentUfiCode: "AktuÃ¡lnÃ­ UFI kÃ³d",
        custom: "VlastnÃ­",
        customData: "VlastnÃ­ data",
        customFandeck: "VlastnÃ­ vzorkovnice",
        customFormula: "VlastnÃ­ receptura",
        customPackage: "VlastnÃ­",
        customPackageSettings: "NastavenÃ­ vlastnÃ­ho balenÃ­",
        customer: "ZÃ¡kaznÃ­k",
        customerVersion: "Verze zÃ¡kaznÃ­ka",
        customers: "ZÃ¡kaznÃ­ci",
        database: "DatabÃ¡ze",
        date: "Datum",
        default: "VÃ½chozÃ­",
        delete: "Smazat",
        deleteImportedData: "Smazat importovanÃ© zÃ¡znamy",
        delta: "Delta",
        description: "Popis",
        disconnect: "Odpojit",
        discount: "Sleva",
        discover: "Objevit",
        dispense: "TÃ³novat",
        dispensing: "TÃ³novÃ¡nÃ­",
        doNotShowAgain: "Tuto zprÃ¡vu pÅÃ­Å¡tÄ nezobrazovat.",
        downloadingFile: "StahovÃ¡nÃ­ souborÅ¯",
        edit: "Upravit",
        email: "E-mail",
        enabled: "Povoleno",
        error: "Chyba",
        expandAll: "OtvevÅÃ­t vÅ¡echno",
        exportData: "Exportovat data",
        exportPdf: "Exportovat PDF",
        fan: "Vzorkovnice",
        fandeck: "Vzorkovnice",
        fandeckCode: "KÃ³d vzorkovnice",
        fandeckName: "NÃ¡zev vzorkovnice",
        fandecks: "VÄjÃ­Åe",
        favorite: "OblÃ­benÃ©",
        fileTransfer: "PÅenos souboru",
        filling: "PlnÄnÃ­",
        fillingDate: "Datum plnÄnÃ­",
        find: "NajÃ­t",
        finish: "DokonÄit",
        finishedCorrection: "HotovÃ¡ korekce",
        formula: "Receptura",
        formulas: "Receptury",
        frontdesk: "Frontdesk",
        getQrCode: "ZÃ­skat QR kÃ³d",
        gravimetric: "GravimetrickÃ©",
        historical: "HistorickÃ©",
        history: "Historie",
        hours: "Hod.",
        id: "Id",
        images: "ObrÃ¡zky",
        in: "V",
        index: "Index",
        insertBarcode: "ProsÃ­m vloÅ¾te ÄÃ¡rovÃ½ kÃ³d",
        install: "Instalovat",
        installed: "InstalovÃ¡no",
        instructions: "Instrukce",
        internalNote: "InternÃ­ poznÃ¡mka",
        interval: "Interval",
        ip: "IP adresa",
        itemNumber: "PoloÅ¾ka Ä.",
        itemXOfY: "PoloÅ¾ka %{x}/%{y}",
        itemsCount: "PoÄet poloÅ¾ek",
        later: "Later",
        limit: "Limit",
        load: "NaÄÃ­st",
        loadFormula: "Vybrat v oknÄ receptury",
        localVersion: "LokÃ¡lnÃ­ verze",
        machine: "Stroj",
        manualCorrection: "ManuÃ¡lnÃ­ korekce",
        manually: "ManuÃ¡lnÄ",
        margin: "MarÅ¾e",
        markup: "ObchodnÃ­ pÅirÃ¡Å¾ka",
        matching: "Matching",
        matchingFormula: "Receptura z matchingu",
        maxLevel: "MaximÃ¡lnÃ­ ÃºroveÅ",
        maxValue: "MaximÃ¡lnÃ­ hodnota",
        maximum: "MaximÃ¡lnÃ­",
        mayTakeAWhile: "This may take a while",
        measured: "ZmÄÅeno",
        metamarism: "Metamarism",
        minimum: "MinimÃ¡lnÃ­",
        minutes: "Min.",
        missingItem: "ChybÄjÃ­cÃ­ poloÅ¾ka",
        missingRequiredItems: "VyplÅte vÅ¡echny povinnÃ© poloÅ¾ky (oznaÄenÃ© hvÄzdiÄkou)",
        modified: "Upraveno",
        modifiedAutomaticCorrection: "Korekce cÃ­lovÃ© barvy",
        modifiedCustomFormula: "ÃpravenÃ¡ vlastnÃ­ receptura",
        modifiedStandardFormula: "ÃpravenÃ¡ standardnÃ­ receptura",
        moduleChange: "ZmÄna modulu",
        more: "VÃ­ce",
        moreInfo: "VÃ­ce informacÃ­",
        moveDown: "Posunout dolÅ¯",
        moveUp: "Posunout nahoru",
        myOrders: "Moje objednÃ¡vky",
        name: "NÃ¡zev",
        nameTitle: "NÃ¡zev",
        new: "NovÃ½",
        next: "DÃ¡le",
        no: "Ne",
        noColorantsAvailable: "Å½Ã¡dnÃ© koloranty",
        noFormulas: "ZatÃ­m Å¾Ã¡dne receptury",
        noPricesAvailable: "Å½Ã¡dnÃ© ceny",
        nominalAmount: "NominÃ¡lnÃ­ mnoÅ¾stvÃ­",
        notAvailable: "NedostupnÃ©",
        note: "PoznÃ¡mka",
        numberOfCanisters: "PoÄet kanystrÅ¯",
        numberOfItemCount: "PoÄet '%{item}': %{count}",
        numberOfLabels: "PoÄet Å¡tÃ­tkÅ¯",
        numberOfPackages: "PoÄet balenÃ­",
        off: "Vypnout",
        ok: "OK",
        on: "Zapnout",
        onFocus: "S kurzorem",
        open: "OtevÅÃ­t",
        operator: "OperÃ¡tor",
        options: "Volby",
        order: "ObjednÃ¡vka",
        other: "JinÃ©",
        otherError: "JinÃ¡ chyba",
        out: "Ven",
        overwrite: "Overwrite",
        package: "BalenÃ­",
        packagePreview: "NÃ¡hled balenÃ­",
        partialUpdates: "Partial updates",
        phone: "Telefon",
        pleaseWait: "ProsÃ­m poÄkejte",
        previous: "PÅedchozÃ­",
        price: "Cena",
        priceGroup: "CenovÃ¡ skupina",
        print: "Tisk",
        printTask: "Tisk",
        processingStep: "ZpracovÃ¡vÃ¡ se %{step}",
        product: "Produkt",
        productCode: "KÃ³d produktu",
        productName: "JmÃ©no produktu",
        products: "Produkty",
        pump1: "Pumpa 1",
        pump2: "Pumpa 2",
        purchasePrice: "NÃ¡kupnÃ­ cena",
        purge: "OdstÅik",
        qualityControl: "Kontrola kvality",
        quantity: "MnoÅ¾stvÃ­",
        quantityQty: "MnoÅ¾.",
        quickTint: "RychlÃ© tÃ³novÃ¡nÃ­",
        rccIsNotAvailable: "RCC je nedostupnÃ©",
        rccIsNotConnected: "RCC nenÃ­ pÅipojeno",
        rccNotLicensed: "RCC nenÃ­ licencovanÃ©",
        reconnect: "Znovu pÅipojit",
        refill: "DoplnÄnÃ­",
        refillManualLevelCorrection: "ManuÃ¡lnÃ­ oprava",
        reformulation: "Reformulace",
        reloadTab: "Reload Tab",
        reset: "Resetovat",
        restart: "Restartovat",
        restore: "Obnovit",
        retint: "PÅetÃ³novat",
        revision: "Revize",
        safetySheet: "BezpeÄnostnÃ­ dokumentace",
        save: "UloÅ¾it",
        saveAs: "UloÅ¾it jako",
        saveToDispensingHistory: "UloÅ¾it do historie",
        searchResult: "VÃ½sledek hledÃ¡nÃ­",
        searching: "HledÃ¡nÃ­",
        seconds: "Sek.",
        select: "Vybrat",
        selectAll: "Vybrat vÅ¡e",
        selectChannels: "Zvolit okruhy",
        selectColumns: "Vyberte sloupce, se kterÃ½mi chcete pracovat",
        selectXFirst: "Nejprve vyberte %{item}",
        sellPrice: "ProdejnÃ­ cena",
        settings: "NastavenÃ­",
        shelf: "StÅ¯l",
        showItem: "Show %{item}",
        showOptions: "Zobrazit dalÅ¡Ã­ moÅ¾nosti",
        size: "Velikost",
        skip: "PÅeskoÄit",
        smartPurge: "ChytrÃ½ odstÅik",
        softwareRestartInSeconds: "%{software} bude automaticky restartovÃ¡n za %{seconds} sekund",
        sortResults: "SeÅadit vÃ½sledky",
        spectro: "Spektrometr",
        standardFormula: "StandardnÃ­ receptura",
        status: "Stav",
        street: "Ulice",
        sum: "Sum",
        summary: "ShrnutÃ­",
        sync: "Synchronizovat",
        technicalSheet: "TechnickÃ¡ dokumentace",
        templates: "Å ablony",
        threshold: "PrÃ¡h",
        ticketing: "Ticketing",
        tintometricSystem: "TintometrickÃ½ systÃ©m",
        toDispenseOrders: "K tÃ³novÃ¡nÃ­",
        top: "NahoÅe",
        total: "Spolu",
        totalAmount: "CelkovÃ© mnoÅ¾stvÃ­",
        totalBaseAmount: "CelkovÃ© mnoÅ¾stvÃ­ bÃ¡ze",
        totalColorantAmount: "CelkovÃ© mnoÅ¾stvÃ­ kolorantu",
        type: "Typ",
        ufiCode: "UFI kÃ³d",
        ufiThreshold: "Hranice UFI",
        unableToSynchronize: "Unable to synchronize",
        undefined: "NedefinovÃ¡no",
        unit: "Jednotky",
        units: "Jednotky",
        unknown: "Unknown",
        update: "Aktualizace",
        updated: "AktualizovÃ¡no",
        user: "UÅ¾ivatel",
        value: "Hodnota",
        vat: "DPH",
        verified: "OvÄÅeno",
        version: "Verze",
        versionId: "ID verze",
        versionStructure: "Struktura verze",
        volumetric: "ObjemovÃ©",
        warning: "VarovÃ¡nÃ­",
        warningLevel: "VarovnÃ¡ ÃºroveÅ",
        withoutName: "(bez jmnÃ©na)",
        workingProperly: "Working properly",
        yes: "Ano",
        zoom: "PÅiblÃ­Å¾it"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Nastavte tuto automatickou Ãºlohu, aÅ¥ %{name} ve stanovenÃ½ Äas vyÅ¾aduje akci automatickÃ©ho ÄiÅ¡tÄnÃ­ kartÃ¡ÄovÃ© nÃ¡doby. Obsluha tÃ³novacÃ­ho stroje musÃ­  manuÃ¡lnÄ odstranit, vyÄistit a opÄt vrÃ¡tit kartÃ¡Äovou nÃ¡dobu.",
            capMaintenance:
                "Nastavte automatickou Ãºlohu, aÅ¥ %{name} ve stanovenÃ½ Äas vyÅ¾aduje akci automatickÃ©ho ÄiÅ¡tÄnÃ­ vÃ­Äka zvlhÄovaÄe trysky. Obsluha tÃ³novacÃ­ho stroje musÃ­ po otevÅenÃ­ manuÃ¡lnÄ vyÄistit vÃ­Äko zvlhÄovaÄe trysky.",
            cleanAll:
                "Nastavte automatickou Ãºlohu, aby tÃ³novacÃ­ stroj ve stanovenÃ½ Äas provedl akci automatickÃ©ho ÄÃ­Å¡tÄnÃ­ vÅ¡ech kanÃ¡lÅ¯.",
            cleanChannels:
                "Nastavte automatickou Ãºlohu, aby tÃ³novacÃ­ stroj ve stanovenÃ½ Äas provedl akci automatickÃ©ho ÄÃ­Å¡tÄnÃ­ konkrÃ©tnÃ­ch kanÃ¡lÅ¯.",
            computerReboot: "Nastavte automatickou Ãºlohu, aby byl poÄÃ­taÄ  ve stanovenÃ½ Äas restarovÃ¡n.",
            computerShutdown: "Nastavte automatickou Ãºlohu, aby byl poÄÃ­taÄ  ve stanovenÃ½ Äas vypnut.",
            dispenserCleaning:
                "Nastavit automatickou Ãºlohu tak, aby %{name}  ve stanovenÃ½ Äas vyÅ¾adovala akci automatickÃ©ho ÄiÅ¡tÄnÃ­ tÃ³novacÃ­ho stroje. Obsluha musÃ­ tÃ³novacÃ­ stroj manuÃ¡lnÄ vyÄistit za pomoci hadÅÃ­ku.",
            humidifierWaterLevelMaintenance:
                "Nastavte automatickou Ãºlohu, aÅ¥ %{name} ve stanovenÃ½ Äas vyÅ¾aduje akci automatickÃ©ho doplnÄnÃ­ zvlhÄovaÄe. Obsluha tÃ³novacÃ­ho stroje musÃ­ manuÃ¡lnÄ zkontrolovat a doplnit vodu ve zvlhÄovaÄi.",
            purgeAll:
                "Nastavte automatickou Ãºlohu, aby tÃ³novacÃ­ stroj ve stanovenÃ½ Äas provedl akci automatickÃ©ho odstÅiku vÅ¡ech kanÃ¡lÅ¯.",
            purgeChannels:
                "Nastavte automatickou Ãºlohu, aby tÃ³novacÃ­ stroj ve stanovenÃ½ Äas provedl akci automatickÃ©ho odstÅiku konkrÃ©tnÃ­ch kanÃ¡lÅ¯.",
            recirculateAll:
                "Nastavte automatickou Ãºlohu, aby tÃ³novacÃ­ stroj ve stanovenÃ½ Äas provedl akci recilkulace vÅ¡ech kanÃ¡lÅ¯.",
            recirculateChannels:
                "Nastavte automatickou Ãºlohu, aby tÃ³novacÃ­ stroj ve stanovenÃ½ Äas provedl akci recilkulace konkrÃ©tnÃ­ch kanÃ¡lÅ¯.",
            refillAll:
                "Nastavte automatickou Ãºlohu, aÅ¥ %{name} ve stanovenÃ½ Äas vyÅ¾aduje akci automatickÃ©ho doplnÄnÃ­ vÅ¡ech kanÃ¡lÅ¯. Obsluha musÃ­ manuÃ¡lnÄ doplnit koloranty do vÅ¡ech kanystrÅ¯.",
            refillCanisters:
                "Nastavte automatickou Ãºlohu, aÅ¥ %{name} ve stanovenÃ½ Äas vyÅ¾aduje akci automatickÃ©ho doplnÄnÃ­ konkrÃ©tnÃ­ch kanÃ¡lÅ¯. Obsluha musÃ­ manuÃ¡lnÄ doplnit koloranty do kanystrÅ¯, kterÃ© doplnÄnÃ­ vyÅ¾adujÃ­ na zÃ¡kladÄ stanovenÃ½ch poÅ¾adavkÅ¯.",
            smartPurgeAll:
                "Nastavte automatickou Ãºlohu, aby tÃ³novacÃ­ stroj ve stanovenÃ½ Äas provedl akci chytrÃ©ho odstÅiku vÅ¡ech kanÃ¡lÅ¯. OdstÅik bude proveden nejsou-li splnÄny pravidla chytrÃ©ho odstÅiku.",
            smartPurgeChannels:
                "Nastavte automatickou Ãºlohu, aby tÃ³novacÃ­ stroj ve stanovenÃ½ Äas provedl akci chytrÃ©ho osatÅiku konkrÃ©tnÃ­ch kanÃ¡lÅ¯. OdstÅik bude proveden nejsou-li splnÄny pravidla chytrÃ©ho odstÅiku.",
            stirAll:
                "Nastavte automatickou Ãºlohu, aby tÃ³novacÃ­ stroj ve stanovenÃ½ Äas vyÅ¾adoval akci automatickÃ©ho zamÃ­chÃ¡nÃ­ vÅ¡ech kanÃ¡lÅ¯.",
            stirCanisters:
                "Nastavte automatickou Ãºlohu, aby tÃ³novacÃ­ stroj ve stanovenÃ½ Äas vyÅ¾adoval akci automatickÃ©ho zamÃ­chÃ¡nÃ­ konkrÃ©tnÃ­ch kanÃ¡lÅ¯.",
            switchPlateMaintenance:
                "Nastavte automatickou Ãºlohu, aÅ¥ %{name} ve stanovenÃ½ Äas vyÅ¾aduje akci automatickÃ©ho ÄiÅ¡tÄnÃ­ desky. Obsluha tÃ³novacÃ­ho stroje musÃ­ manuÃ¡lnÄ odstranit, vyÄistit a vrÃ¡tit desku zpÄt."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "ÄÃ­slo Å¡arÅ¾e, kterÃ© pÅevlÃ¡dÃ¡, se pouÅ¾Ã­vÃ¡ pro tisk s ohledem na skuteÄnÃ© mnoÅ¾stvÃ­ v kanystru. PÅejdÄte do NastavenÃ­ a definujte prÃ¡h pro kaÅ¾dÃ½ kanistr zvlÃ¡Å¡Å¥.",
            batchNumberFromLastFilling:
                "Pro tisk se pouÅ¾Ã­vÃ¡ Å¡arÅ¾e z poslednÃ­ho doplnÄnÃ­ zadanÃ¡ obsluhou bez ohledu na doplnÄnÃ© mÅ¾nostvÃ­.",
            enableBatchNumber: "S tÃ­mto nastavenÃ­m jsou sledovÃ¡nÃ½ znovu naplnÄnÃ© Å¡arÅ¾e koloranty."
        },
        connection: {
            add: "Povoluje pÅidat server manuÃ¡lnÄ, pokud nebude automaticky detekovanÃ½.",
            clientIdentifier: "Toto nastavenÃ­ zobrazÃ­ identifikaci klienta v pÅÃ­padÄ vÃ­ce pÅipojenÃ­ k serveru.",
            disconnect: " Informace o pouÅ¾itÃ©m serveru. Pro pÅipojenÃ­ k jinÃ©mu serveru stisknÄte tlaÄÃ­tko odpojit.",
            discover: "ZjiÅ¡tÄnÃ­ ostatnÃ­ch serverÅ¯ v sÃ­ti.",
            dropServers: "Smazat vÅ¡echny detekovanÃ© servery ze seznamu.",
            dropServersNotAvailable: " Nebyl nalezen Å¾Ã¡dnÃ½ server.",
            edit: "Povoluje manuÃ¡lnÄ editovat jiÅ¾ nalezenÃ½ server.",
            editDisabled: "Nebyl vybrÃ¡n Å¾Ã¡dnÃ½ server."
        },
        continue: "Chcete pokraÄovat?",
        driverSettings: {
            alfaRestApi: {
                host: "VloÅ¾te prosÃ­m host name poÄÃ­taÄe nebo jeho IP adresu.",
                machineType: "PlatnÃ© pro vÅ¡echny stoje Alfa. (Windows i Linux)"
            },
            corobDsProxy: {
                machineType:
                    "PlatnÃ© pro modely Slave (D200, D600..), 4G (prvnÃ­ model) a 5G (EvoFlx). DspProxy musÃ­ bÃ½t nainstalovÃ¡no. FunkÄnÃ­ pouze pod Windows."
            },
            corobEvoDriver: {
                machineType: "PlatnÃ© pro modely 5G (EvoFlx). EVOservice musÃ­ bÃ½t nainstalovÃ¡no.(Windows i Linux)"
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "Vyberte prosÃ­m konfiguraÄnÃ­ soubor stroje. BÄÅ¾nÃ© nastavenÃ­ vybrÃ¡no.",
                hldRootDir: "Vyberte prosÃ­m hlavnÃ­ sloÅ¾ku pro HLD. BÄÅ¾nÃ© nastavenÃ­ vybrÃ¡no.",
                machineType:
                    "PlatnÃ© pro Corob Flex (500, 520, 540) = s dÅÃ­vÄjÅ¡Ã­m nÃ¡zvem Lenteq. HLD musÃ­ bÃ½t nainstalovÃ¡no. FunkÄnÃ­ pouze pod Windows."
            },
            corobNextDriver: {
                machineType:
                    "PlatnÃ© pro modely Slave (D200, D600..), 4G (prvnÃ­ model) and 5G (EvoFlx). NextDriver musÃ­ bÃ½t nainstalovÃ¡n a zalicencovÃ¡n. FunkÄnÃ­ pouze pro Linux."
            },
            dromontDDrv: {
                databasePath: "Cesta k databÃ¡zovÃ©mu souboru s kalibraÄnÃ­mi daty. BÄÅ¾nÃ© nastavenÃ­ vybrÃ¡no.",
                driverPath: "Cesta k ovladaÄi (D_DRV.exe). BÄÅ¾nÃ© nastavenÃ­ vybrÃ¡no.",
                machineType:
                    "NepÅÃ­mÃ¡ komunikace se strojem skrze nastavenou cestu. PlatnÃ© pro modely V1 a V2. D_SET musÃ­ bÃ½t nainstalovÃ¡n.(Linux i Windows)",
                resultPath: "Cesta k vÃ½slednÃ©mu souboru. BÄÅ¾nÃ© nastavenÃ­ vybrÃ¡no.",
                serviceSoftwarePath: "Cesta k servisnÃ­mu SW Dromont (D_SET.exe). BÄÅ¾nÃ© nastavenÃ­ vybrÃ¡no."
            },
            dromontDirect: {
                machineType:
                    "PÅÃ­mÃ¡ komunikace se strojem. PlatnÃ© pro modely V1 a V2. D_SET musÃ­ bÃ½t nainstalovÃ¡n.(Windows i Linux)",
                rootDir: "Vyberte hlavnÃ­ adresÃ¡Å Dromont. BÄÅ¾nÃ© nastavenÃ­ vybrÃ¡no."
            },
            dromontMisura: {
                driverPath:
                    "Cesta k ovladaÄi (MisuraRetail.exe) se mÅ¯Å¾e mÄnit v zÃ¡vislosti na verzi. BÄÅ¾nÃ© nastavenÃ­ vybrÃ¡no.",
                extensionPath: "Cesta ke komunikaÄnÃ­mu souboru pro servisnÃ­ akce.",
                formulaPath: "Cesta ke komunikaÄnÃ­mu souboru pro tÃ³novÃ¡nÃ­. ",
                machineType: "PlatnÃ© pro modely V3. Dromont Misura musÃ­ bÃ½t nainstalovÃ¡n. Pouze pro Windows."
            },
            fastAndFluidIDD: {
                machineType: "PlatnÃ© pro vÅ¡echny stroje F&F. FunkÄnÃ­ pouze pod Windows.",
                path: "PodporovÃ¡ny jsou IDD2 (HA 450, HA 650, X-smart, a dalÅ¡Ã­) - musÃ­ bÃ½t zalicencovÃ¡no, IDD3 (HP 500, a dalÅ¡Ã­), IDD4 (HA 180, HA 480, HA 680, Xprotint, a dalÅ¡Ã­.)."
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "PlatÃ© pro vÅ¡echny stroje F&F. Windows i Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "PlatnÃ© pro vÅ¡echny stroje Hero. FunkÄnÃ­ pouze pod Windows."
            },
            italtinto: {
                machineType:
                    "PlatnÃ© pro vÅ¡echny stroje Italtinto. Wcal nebo ItaltintoCal musÃ­ bÃ½t nainstalovÃ¡ny. FunkÄnÃ­ pouze pod Windows.",
                path: "Cesta k upravenÃ©mu konfiguraÄnÃ­mu souboru Italtinto."
            },
            manualAdvanced: {
                machineType: "PlatnÃ© pro vÅ¡echny manuÃ¡lnÃ­ stroje vÄetnÄ podpory zÃ¡sobnÃ­kÅ¯. (Windows i Linux)",
                path: "Cesta ke konfiguraÄnÃ­m souborÅ¯m s daty o stroji a zÃ¡sobnÃ­cÃ­ch."
            },
            manualSimple: {
                machineType: "PlatnÃ© pro vÅ¡echny manuÃ¡lnÃ­ stroje. Windows i Linux.",
                path: "Cesta ke konfiguraÄnÃ­mu souboru s daty o stroji."
            },
            none: {
                machineType: "NenÃ­ vybrÃ¡n ovladaÄ stroje"
            },
            santintColorLink3: {
                machineType: "PlatnÃ© pro vÅ¡echny stroje Santint. FunkÄnÃ­ pouze pod Windows."
            },
            simulation: {
                machineType: "PlatnÃ© pro simulÃ¡tor stroje pokud nenÃ­ pÅipojen Å¾Ã¡dnÃ½ reÃ¡lnÃ½ stroj.",
                path: "Cesta k simulaÄnÃ­mu konfiguraÄnÃ­mu souboru, kterÃ½ se musÃ­ zhodovat s vloÅ¾enou databÃ¡zi."
            },
            udcp: {
                machineType: "UDCP dÃ¡vkovaÄ"
            }
        },
        environment: {
            activeServerPlugins: "PÅehled doplÅkovÃ½ch pluginÅ¯.",
            allowAutoCloseTab:
                "PÅi zapnutÃ­ tohoto nastavenÃ­ se po ukonÄenÃ­ procesu tÃ³novÃ¡nÃ­ vÅ¡echny zÃ¡loÅ¾ky recepter automaticky zavÅou.",
            allowAutomaticClientStart:
                "Aktivace tohoto nastaveni povede k tomu, Å¾e %{name} sa automaticky spustÃ­ po zapnutÃ­ poÄÃ­taÄe.",
            allowAutomaticPrint:
                "Å tÃ­tek se vytiskne automaticky. VyÅ¾aduje dalÅ¡Ã­ nastavenÃ­ ohlednÄ tisku pÅed tÃ³novÃ¡nÃ­m po tÃ³novÃ¡nÃ­ nebo obojÃ­.",
            allowBuildingSitePanel: "Na panelu receptur bude aktivovÃ¡n panel stanoviÅ¡tÄ.",
            allowCustomers: "Na panelu receptur budou pÅÃ­stupnÃ­ zÃ¡kaznÃ­ci.",
            allowDispensing: "Na panelu receptury bude aktivovÃ¡no tlaÄÃ­tko tÃ³novat.",
            allowFileTransfer:
                "S tÃ­mto nastavenÃ­m je dostupnÃ½ automatickÃ½ export a import dat za pouÅ¾itÃ­ pÅenosu souborÅ¯.",
            allowFormulaModificationPanel: "Na Panelu receptur bude aktivovÃ¡n Panel s datem Ãºpravy receptury.",
            allowFormulaStatusPanel: "Na Panelu receptur bude aktivovÃ¡n StavovÃ½ panel.",
            allowLight: "%{name} Bude pÅÃ­stupnÃ©.",
            allowOrdering: "Na panelu receptury bude aktivovÃ¡no tlaÄÃ­tko objednat.",
            allowPricing:
                "Na panelu receptury lze pouÅ¾Ã­t ceny. Viditelnost cen je stanovena v DostupnÃ½ch cenÃ¡ch. Ceny jsou stanoveny v NastavenÃ­ cen.",
            allowProductPreviewImage: "BÄhem tÃ³novÃ¡nÃ­ se zobrazÃ­ obrÃ¡zek produktu",
            allowQualityControl: "Bude aktivovÃ¡na kontrola kvality.",
            allowSearchCheaperColors: "Na panelu receptur bude dostupnÃ© vyhledÃ¡vÃ¡nÃ­ levnÄjÅ¡Ã­ch odstÃ­nÅ¯.",
            allowSoundNotification:
                "ZvukovÃ© upozornÄnÃ­ o objednÃ¡vce. PÅehraje hudebnÃ­ melodii, kdyÅ¾ je pÅijata objednÃ¡vka.",
            allowSpectro: "Sekce Spectro budou pÅÃ­stupnÃ¡.",
            allowTabs: "Pokud je toto nastavenÃ­ povoleno, bude moÅ¾nÃ© pracovat s vÃ­ce panely zÃ¡roveÅ.",
            applyZoom: "Zoom zvÄtÅ¡uje nebo zmenÅ¡uje rozliÅ¡enÃ­. KlÃ¡vesovÃ© zkratky CTRL + a CTRL - jsou takÃ© pouÅ¾itelnÃ©.",
            automaticLogout: "NastavenÃ­ doby po kterÃ© dojde k automatickÃ©mu odhlÃ¡Å¡enÃ­.",
            availableDatabases: "NastavenÃ­ umoÅ¾Åuje pÅepÃ­nÃ¡nÃ­ mezi databÃ¡zemi, pokud je k dispozici vÃ­ce neÅ¾ jedna.",
            backupLocalDB: "Exportuje lokÃ¡lnÃ­ databÃ¡zi. ExportovanÃ½ soubor lze pouÅ¾Ã­t jako zÃ¡lohu databÃ¡ze.",
            barcodeTesting:
                "ProstÅedÃ­ pro testovÃ¡nÃ­ ÄÃ¡rovÃ©ho kÃ³du slouÅ¾Ã­ ke kontrole sprÃ¡vnosti naskenovanÃ©ho ÄÃ¡rovÃ©ho kÃ³du jeho porovnÃ¡nÃ­m s ÄÃ¡rovÃ½mi kÃ³dy vloÅ¾enÃ½mi v databÃ¡ze.",
            customBanner: "Nastavte si svÃ© vlastnÃ­ logo nebo banner a jeho pozici.",
            customCurrencyFormat: "VlastnÃ­ formÃ¡t mÄny mÅ¯Å¾e pÅepsat vÃ½chozÃ­ formÃ¡t mÄny na zÃ¡kladÄ vybranÃ©ho jazyka. ",
            customDateFormat: "VlastnÃ­ formÃ¡t data mÅ¯Å¾e pÅepsat vÃ½chozÃ­ formÃ¡t data na zÃ¡kladÄ vybranÃ©ho jazyka.",
            customNumberFormat: "VlastnÃ­ formÃ¡t ÄÃ­sel mÅ¯Å¾e pÅepsat vÃ½chozÃ­ formÃ¡t ÄÃ­sel na zÃ¡kladÄ vybranÃ©ho jazyka.",
            customTimeFormat: "VlastnÃ­ formÃ¡t Äasu mÅ¯Å¾e pÅepsat vÃ½chozÃ­ formÃ¡t Äasu na zÃ¡kladÄ vybranÃ©ho jazyka.",
            defaultPrinter:
                "VybranÃ¡ tiskÃ¡rna bude automaticky pouÅ¾ita pÅi tisku Å¡tÃ­tkÅ¯, pokud se nezmÄnÃ­ v oknÄ moÅ¾nosti tisku.",
            defaultTemplate:
                "VybranÃ¡ Å¡ablona se automaticky pouÅ¾ije pÅi tisku Å¡tÃ­tkÅ¯, pokud se nezmÄnÃ­ v oknÄ moÅ¾nosti tisku.",
            deleteImportedData: "OdstranÃ­ dÅÃ­ve importovanÃ¡ vlastnÃ­ data. Data lze po odstranÄnÃ­ znovu importovat.",
            diskSpaceNotification: "Zkontrolujte dostupnÃ© mÃ­sto na disku.",
            dispensingNotes: "Na panelu receptur, bude pÅÃ­stupnÃ¡ sekce pro vklÃ¡dÃ¡nÃ­ poznÃ¡mek.",
            downloadListEmpty: "Å½Ã¡dnÃ© stahovÃ¡nÃ­ neprobÃ­hÃ¡",
            enableVirtualKeyboard: "V %{name}, bude k dispozici virtuÃ¡lnÃ­ klÃ¡vesnice.",
            exportLocalSettings:
                "Exportuje lokÃ¡lnÃ­ nastavenÃ­ toho poÄÃ­taÄe. ExportovanÃ½ soubor lze importovat do jinÃ©ho poÄÃ­taÄe, aby se nastavili identickÃ© lokÃ¡lnÃ­ nastavenÃ­.",
            exportStaticSql:
                "Exportuje lokÃ¡lnÃ­ nastavenÃ­ toho poÄÃ­taÄe. ExportovanÃ½ soubor lze pouÅ¾Ã­t k vytvoÅenÃ­ databÃ¡ze s tÃ­mto nastavenÃ­m.",
            exportTranslationKeys: "Exportovat nejnovÄjÅ¡Ã­ pÅeklady a poslat je e-mailem dodavateli SW k importu.",
            favoriteButton: "KliknÄte pro pÅidÃ¡nÃ­ receptury mezi oblÃ­benÃ©.",
            formulaNotes: "Na panelu receptur bude pÅÃ­stupnÃ¡ sekce poznÃ¡mky k receptuÅe.",
            helpSettings: "Informace jsou viditelnÃ© v sekci nÃ¡povÄda na panelu rychlÃ©ho pÅÃ­stupu",
            importCustomData: "Importuje mÃ­stnÃ­ vlastnÃ­ data na zÃ¡kladÄ vybranÃ©ho formÃ¡tu.",
            importExcelFile: "Importujte excelovÃ½ soubor s daty, kterÃ¡ majÃ­ bÃ½t pÅidÃ¡na do databÃ¡ze.",
            importsLocalSettings: "Importuje lokÃ¡lnÃ­ nastavenÃ­ z jinÃ©ho poÄÃ­taÄe na tento.",
            internalNote: "Na panelu receptur bude pÅÃ­stupnÃ¡ internÃ­ poznÃ¡mka.",
            lockComputer:
                "NastavenÃ­ zajistÃ­, Å¾e prostÅedÃ­ softwaru %{name} se nedÃ¡ opustit - umoÅ¾Åuje maximÃ¡lnÃ­ zÃ¡Å¾itek z kioskovÃ©ho reÅ¾imu. PÅÃ­stupnÃ© pouze pro Windows.",
            maxNumberTabs: "Limit zÃ¡loÅ¾ek urÄuje, kolik zÃ¡loÅ¾ek receptur lze otevÅÃ­t souÄasnÄ.",
            memoryTabs: "Povolit znovuotevÃ­rÃ¡nÃ­ nedÃ¡vno otvÄÅenÃ½ch karet po spuÅ¡tÄnÃ­ softwaru.",
            printAfterDispensing:
                "NastavenÃ­ vyÅ¾aduje informace o tom, kolik kopiÃ­ Å¡tÃ­tkÅ¯ by mÄlo bÃ½t vytiÅ¡tÄno po procesu tÃ³novÃ¡nÃ­.",
            printAsImage:
                "Tisk jako obrÃ¡zek umoÅ¾Åuje ÅeÅ¡it problÃ©my, kdyÅ¾ bÄÅ¾nÃ½ zpÅ¯sob tisku selÅ¾e. NepouÅ¾Ã­vejte, kdyÅ¾ bÄÅ¾nÃ½ spÅ¯sob tisku funguje sprÃ¡vnÄ. Funguje jenom pro Linux.",
            printBeforeDispensing:
                "NastavenÃ­ vyÅ¾aduje informace o tom, kolik kopiÃ­ Å¡tÃ­tkÅ¯ by se mÄlo vytisknout pÅed tÃ³novÃ¡nÃ­m.",
            printEnabled: "Toto nastavenÃ­ umoÅ¾Åuje pouÅ¾itÃ­ tiskÃ¡rny. DalÅ¡Ã­ nastavenÃ­ naleznete v sekci ",
            printOnRequest: "Na panelu receptury bude aktivovÃ¡no tlaÄÃ­tko tisk.",
            printTaskVariable: "TiskovÃ¡ Ãºloha je zpracovÃ¡na pouze v pÅÃ­padÄ, Å¾e je zadanÃ¡ promÄnÃ¡ v datech tisku",
            quickTintTemplate: "VybranÃ¡ Å¡ablÃ³ba bude pouÅ¾ita pÅi tisku Å¡tÃ­tku z rychlÃ©ho tÃ³novÃ¡nÃ­.",
            restoreLocalSettings:
                "ObnovÃ­ lokÃ¡lnÃ­ nastavenÃ­ tohoto poÄÃ­taÄe. Po smazanÃ­ vÅ¡ech nastavenÃ­ lze vytvoÅit novÃ© nastavenÃ­.",
            runLightAtStartUp: "%{light} bude spuÅ¡tÄn namÃ­sto %{name}.",
            screenSaverTimeout: "Nastavit poÄet minut po kterÃ½ch se spustÃ­ spoÅiÄ obrazovky.",
            selectCustomDataFormat:
                "Vyberte formÃ¡t pÅ¯vodnÃ­ch dat, kterÃ¡ majÃ­ bÃ½t importovÃ¡na. KaÅ¾dÃ½ formÃ¡t mÅ¯Å¾e vyÅ¾adovat rÅ¯znÃ© dalÅ¡Ã­ soubory a nastavenÃ­.",
            setCustomHomeButton: "TlaÄÃ­tko domÅ¯ v %{name} vÃ¡s pÅesmÄruje na vybranÃ½ panel",
            setFts: "PlnotextovÃ© vyhledÃ¡vÃ¡nÃ­ umoÅ¾Åuje hledÃ¡nÃ­ receptury v jakÃ©koliv podobÄ - nemusÃ­ se zaÄÃ­t na zaÄÃ¡tku slova.",
            setKeyboardShortcuts: "NenÃ­ moÅ¾nÃ© nastavit stejnou klÃ¡vesovou zkratku pro dvÄ rÅ¯znÃ© akce.",
            setNumberOfDecimalPlaces:
                "ZaokrouhlovÃ¡nÃ­ urÄuje, kolik desetinnÃ½ch mÃ­st kolorantÅ¯ pouÅ¾itÃ½ch v receptuÅe se zobrazÃ­.",
            setOrderSearchParameters:
                "HledÃ¡nÃ­ objednÃ¡vek definuje, jakÃ© parametry se pouÅ¾ijÃ­ pÅi vyhledÃ¡vÃ¡nÃ­ mezi objednÃ¡vkami. PÅÃ­stupnÃ© pouze v %{name}.",
            setOverwriteLastTab:
                "Pokud je dosaÅ¾en maximÃ¡lnÃ­ poÄet zobrazenÃ½ch karet pÅi vÃ½bÄru receptury v rychlÃ©m vyhledÃ¡nÃ­, bude poslednÃ­ naÄtenÃ¡ karta pÅepsÃ¡na aktuÃ¡lnÃ­m vÃ½bÄrem.",
            setSearchPanel: "Nastavte si vlastnÃ­ zobrazenÃ­ a poÅadÃ­ poloÅ¾ek pÅi hledÃ¡nÃ­ receptury.",
            setVisibilityAndOrder:
                "VybranÃ© poloÅ¾ky navigace budou viditelnÃ© na panelu rychlÃ©ho pÅÃ­stupu. NejvyÅ¡Å¡Ã­ poloha zde definuje pozici nejvÃ­ce vlevo v panelu. MaximÃ¡lnÃ­ povolenÃ© mnoÅ¾stvÃ­ navigaÄnÃ­ch poloÅ¾ek je 6.",
            setYourLanguage: "ZmÄna jazyka vyÅ¾aduje restart softwaru.",
            settingsSearch: "VyhledÃ¡vÃ¡nÃ­ v sekci nastavenÃ­",
            showNewOrderNotifications: "OznÃ¡menÃ­ o objednÃ¡vce je vyskakovacÃ­ okno oznamujÃ­cÃ­ pÅijetÃ­ novÃ© objednÃ¡vky.",
            sorting: "RychlÃ© tÃ³novÃ¡nÃ­ mÅ¯Å¾ete zÃ¡sobnÃ­ky uspoÅÃ¡dat podle nÃ¡zvÅ¯ barviv nebo podle ID zÃ¡sobnÃ­kÅ¯.",
            turnOnKioskMode: "Skryje reÅ¾im kiosku na hlavnÃ­m panelu.",
            windowClosingRules:
                "NastavenÃ­ urÄuje, zda se okno rychlÃ©ho tÃ³novÃ¡nÃ­ uzavÅe pÅed nebo po zaÄÃ¡tku procesu tÃ³novÃ¡nÃ­."
        },
        formulaSettings: {
            additionalFormulaTab: "Toto nastavenÃ­ ÅeÅ¡Ã­, kterÃ½ panel se zobrazÃ­ po otevÅenÃ­ novÃ© receptury.",
            allowCustomFormulas: "Bude aktivovÃ¡no vytvÃ¡ÅenÃ­ a vyhledÃ¡vÃ¡nÃ­ vlastnÃ­ch receptur.",
            allowCustomPackageSize: "Na panelu receptura bude aktivovÃ¡na moÅ¾nost vlastnÃ­ velikosti balenÃ­.",
            allowEditingColorants:
                "Na panelu receptura bude aktivovÃ¡no tlaÄÃ­tko upravit kolorant (viditelnÃ© po vÃ½bÄru barvy).",
            alternativeFormulasPosition: "Definuje, jak zÃ­skat pÅÃ­stup k alternativnÃ­m recepturÃ¡m.",
            basePanelSize: "NastavenÃ­ velikosti bÃ¡ze na panel Receptur",
            bippPanelSize: "NastavenÃ­ velikosti bÃ¡ze v balenÃ­ produktu na panelu Receptur",
            blendColorNameAndCode:
                "NastavenÃ­ spojÃ­ vyhledÃ¡vacÃ­ pole pro nÃ¡zev barvy a kÃ³d barvy do jednoho vyhledÃ¡vacÃ­ho pole.",
            color: "Na panelu receptura bude viditelnÃ½ pouze barevnÃ½ nÃ¡hled.",
            colorCodePrimary: "Ve vyhledÃ¡vacÃ­m poli bude nejdÅÃ­ve zobrazen kÃ³d barvy.",
            colorPreviewAsImage: "Na panelu Receptur bude zobrazenÃ­ odstÃ­nu reprezentovÃ¡no obrÃ¡zkem.",
            colorPreviewResizable: "UmoÅ¾Åuje zmÄnit velikost panelu nÃ¡hledu barvy.",
            colorantPanelLimit:
                "NastavenÃ­ nastavuje poÄet kolorantÅ¯, kterÃ© budou vÅ¾dy viditelnÃ©, neÅ¾ se skryjÃ­ pod posuvnÃ­kem.",
            colorantPanelOrderBy: "Panel receptur mÅ¯Å¾e mÃ­t koloranty seÅazenÃ© podle jmÃ©na nebo mnoÅ¾stvÃ­.",
            customCanOption: "Vyberte, jakÃ© mÄrnÃ© jednotky lze pouÅ¾Ã­t pro vlastnÃ­ velikost balenÃ­ na panelu Receptury.",
            customCanSettingsUnit:
                "Zvolte, kterou mÄrnou jednotku lze pouÅ¾Ã­t jako vÃ½chozÃ­ pro nastavenÃ­ vlastnÃ­ho balenÃ­ v Panelu receptur.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "Aktivace tohoto nastavenÃ­ povede k vyskakovacÃ­m oknÅ¯m pro potvrzenÃ­ odstranÄnÃ­ poloÅ¾ky.",
            dropDownCalculate: "RozbalovacÃ­ menu pro vÃ½bÄr receptury, kterÃ½ hledÃ¡te, se rozÅ¡Ã­ÅÃ­ do spodnÃ­ ÄÃ¡sti okna",
            fandeckGroups: "NastavenÃ­ povoluje hierarchii se skupinami vzorkovnic, pokud jsou v databÃ¡zi k dispozici.",
            fandeckPanelSize: "NastavenÃ­ velikosti vÄjÃ­Åe na panelu Receptur",
            favoriteFormulasInitial: "PÅi startu %{name}, se zobrazÃ­ panel oblÃ­benÃ½ch poloÅ¾ek.",
            formulaAutomaticNaming:
                "ZmÄnÄna receptura bude automaticky pojmenovÃ¡na na zÃ¡kladÄ provedenÃ½ch Ãºprav kolorantÅ¯.",
            formulaPanel: "Po otevÅenÃ­ novÃ© karty se zobrazÃ­ panel receptur.",
            formulaPanelInitial: "PÅi startu %{name}, se zobrazÃ­ panel receptur.",
            formulaPanelSize: "NastavenÃ­ velikosti receptury na panelu Receptur",
            formulaPropertiesPosition: "Definuje zpÅ¯sob pÅÃ­stupu k vlastnostem receptury.",
            generateColorPreview:
                "PÅi tomto nastavenÃ­ bude nÃ¡hled barvy generovÃ¡n automaticky. VÃ½slednÃ½ nÃ¡hled nenÃ­ pÅesnÃ½.",
            historicalFormulasPosition: "Definuje, jak zÃ­skat pÅÃ­stup k historickÃ½m recepturÃ¡m.",
            image: "Na panelu receptur bude obrÃ¡zek produktu viditelnÃ½ vedle barevnÃ©ho nÃ¡hledu s moÅ¾nostÃ­ otevÅÃ­t panel s vÃ­ce informacemi",
            images: "Toto nastavenÃ­ urÄuje zdroj souborÅ¯ s obrÃ¡zky.",
            infoPanelResizable: "UmoÅ¾Åuje zmÄnit velikost panelu s dalÅ¡Ã­mi informacemi.",
            initialFormulaTab: "Toto nastavenÃ­ urÄuje kterÃ½ panel se zobrazÃ­ po startu %{0}. ",
            moreInfo:
                "Na panelu receptur bude informaÄnÃ­ panel viditelnÃ½ vedle barevnÃ©ho nÃ¡hledu a nÃ¡hledu obrÃ¡zku produktu.",
            orderByDistance:
                "Je-li toto nastavenÃ­ zapnuto, je vÃ½sledek hledÃ¡nÃ­ odstÃ­nÅ¯ seÅazen podle speciÃ¡lnÃ­ metriky vzdÃ¡lenosti.",
            productCode: "NastavenÃ­ povolÃ­ pouÅ¾itÃ­ kÃ³dÅ¯ a jmen produktÅ¯, pokud jsou dostupnÃ© v databÃ¡zi.",
            productFiles: "Toto nastavenÃ­ urÄuje zdroj produktovÃ½ch souborÅ¯, kterÃ© jsou dostupnÃ© na panelu Receptur.",
            productGroups:
                "Toto nastavenÃ­ povolÃ­ hierarchii produktovÃ½ch skupin v pÅÃ­padÄ, Å¾e jsou dostupnÃ© v databÃ¡zi.",
            productPanelSize: "Nastavit velikost produktu na panelu Receptur",
            searchNewFormula:
                "Po otevÅenÃ­ novÃ© karty se zobrazÃ­ hledÃ¡nÃ­ novÃ© receptury (obsahuje informace o naposledy tÃ³novanÃ½ch receptur a oblÃ­benÃ½ch receptur).",
            searchNewFormulaInitial:
                "PÅi startu %{name}, se objevÃ­ hledÃ¡nÃ­ novÃ© receptury (obsahuje informace o naposledy tÃ³novanÃ½ch receptur a oblÃ­benÃ½ch receptur).",
            searchPanelFormulaItems: "MusÃ­ bÃ½t vybrÃ¡na alespoÅ jedna z poloÅ¾ek receptury.",
            searchPanelProductItems: "MÅ¯Å¾e bÃ½t vybrÃ¡na pouze jedna z poloÅ¾ek produktu.",
            searchPanelQuickSelect:
                "TlaÄÃ­tko pro naÄtenÃ­ receptury nenÃ­ tÅeba pouÅ¾Ã­t. Po vÃ½bÄru budete hned pÅesmÄrovÃ¡nÃ­ na hlavnÃ­ kartu receptury.",
            setCompetitiveColorSearch:
                "V pÅÃ­padÄ, Å¾e je toto nastavenÃ­ zapnutÃ©, je v paletÄ barev a na panelu receptury dostupnÃ¡ moÅ¾nost hledÃ¡nÃ­ konkurenÄnÃ­ch odstÃ­nÅ¯.",
            setFormulaInfoInPreview: "Na panelu receptury budou vybranÃ¡ data vÅ¾dy viditÄlnÃ¡ v nÃ¡hledu barvy.",
            setFormulaPreview: "Toto nastavenÃ­ mÄnÃ­ pozici a zobrazenÃ­ nÃ¡hledu barvvy a informacÃ­ o barvÄ.",
            setFormulaRGBPreviewVisibleInformation:
                "Na panelu receptur, vybranÃ½ typ dat bude vÅ¾dy viditelnÃ½ v barevnÃ©m nÃ¡hledu.",
            setFormulaUnit:
                "Na panelu receptur, toto nastavenÃ­ rozhodne, kterÃ¡ jednotka kolorantÅ¯ se otevÅe jako prvnÃ­ po vÃ½bÄru barvy. Lze pouÅ¾Ã­t takÃ© v rychlÃ©m tÃ³novÃ¡nÃ­.",
            setFormulaVisibilityAndOrder:
                "Na panelu receptur, vybranÃ¡ data budou viditelnÃ¡ v sekci vÃ­ce informacÃ­ (pouÅ¾itelnÃ© pouze v pÅÃ­padÄ, Å¾e nÃ¡hled receptur v nastavenÃ­ receptur je obrÃ¡zek nebo vÃ­ce informacÃ­).",
            setMaxToleranceForCompetitiveColors:
                "NastavÃ­ maximÃ¡lnÃ­ tolerancÃ­ Delta E (CIA 2000) pro vyhledÃ¡vanÃ­ konkurenÄnÃ­ch odstÃ­nÅ¯.",
            setNumberOfCompetitiveColors:
                "Definujte, kolik konkurenÄnÃ­ch master odstÃ­nÅ¯ by mÄlo bÃ½t po vyhledÃ¡vÃ¡nÃ­ nabÃ­zeno. DefinovanÃ½ poÄet neodpovÃ­dÃ¡ finÃ¡lnÃ­mu poÄtu vÃ½sledkÅ¯.",
            setVisibleUnit:
                "Na panelu receptur, toto nastavenÃ­ rozhoduje, kterÃ© jednotky barviva jsou viditelnÃ© po vÃ½bÄru kolorantu. Lze pouÅ¾Ã­t takÃ© v rychlÃ©m tÃ³novÃ¡nÃ­.",
            showColorPreview:
                "Na panelu receptur, pÅi hledÃ¡nÃ­ novÃ© receptury se vedle nÃ¡zvu barvy zobrazÃ­ malÃ½ barevnÃ½ nÃ¡hled.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "Na panelu receptur, zobrazuje informace o kÃ³du barvy."
        },
        formulaValidation: {
            batchNumberInvalid: "Kanystr (%{colorants}) je plnÄnÃ½ vadnou sarÅ¾Ã­ kolorantÅ¯.",
            batchNumberWarning: "Kolorant (%{colorants}) s tÃ­mto ÄÃ­slem Å¡arÅ¾e mÅ¯Å¾e bÃ½t poÅ¡kozen.",
            bellowBaseLimit: "SouÄet mnoÅ¾stvÃ­ kolorantÅ¯ je pod ÃºrovnÃ­ hranice bÃ¡ze.",
            checkColorantBaseRules: "NastavenÃ­ kontroluje, zda lze v tÃ©to kombinaci pouÅ¾Ã­t pouÅ¾itÃ© koloranty a bÃ¡ze.",
            checkMinDosableAmount:
                "MinimÃ¡lnÃ­ tÃ³novatelnÃ© mnoÅ¾stvÃ­ je nejmenÅ¡Ã­ mnoÅ¾stvÃ­ barviva, kterÃ© lze dle doporuÄenÃ­ laboratoÅe dÃ¡vkovat.",
            checkOverfill:
                "NastavenÃ­ zkontroluje ihned po nastavenÃ­ mnoÅ¾stvÃ­, zda je v plechovce dostatek mÃ­sta pro koloranty.",
            checkTotalCntAmounts:
                "NastavenÃ­ zkontroluje, zda byly pÅekroÄeny limity pro minimÃ¡lnÃ­ a maximÃ¡lnÃ­ mnoÅ¾stvÃ­ kolorantu v balenÃ­ bÃ¡ze produktu. Tyto limity jsou definovÃ¡ny v databÃ¡zi.",
            colorantBaseRules: "Kolorant nenÃ­ platnÃ½ pro vybranou bÃ¡zi.",
            colorantMinAmount: "MnoÅ¾stvÃ­ kolorantu je niÅ¾Å¡Ã­ neÅ¾ minimÃ¡lnÃ­ tÃ³novatelnÃ© mnoÅ¾stvÃ­.",
            dispensingWithErrorsEnabled:
                "Pokud je povoleno, v pÅÃ­padÄ poruÅ¡enÃ­ ovÄÅenÃ­ se zobrazÃ­ varovnÃ¡ zprÃ¡va, ale pÅesto bude moÅ¾nÃ© pokraÄovat v tÃ³novÃ¡nÃ­.",
            invalidBatchNumber: "Kolorant mÃ¡ neplatnÃ½ nebo vadnÃ½ ÄÃ­slo Å¡arÅ¾e.",
            overBaseLimit: "SouÄet vÅ¡ech kolorantÅ¯ je vyÅ¡Å¡Ã­ neÅ¾ maximÃ¡lnÃ­ moÅ¾nÃ© mnoÅ¾stvÃ­ nutnÃ© k tÃ³novÃ¡nÃ­.",
            overfill: "Bylo detekovÃ¡no pÅeplnÄnÃ­.",
            unifyColorantBatchForMultipleCans:
                "Pokud je to povoleno, objevÃ­ se modal s informacÃ­ o doplnÄnÃ­ na maximum, kdyÅ¾ je mnoÅ¾stvÃ­ kolorantu vÄtÅ¡Ã­ neÅ¾ maximÃ¡lnÃ­ mnoÅ¾stvÃ­ kanystru a kanystr nenÃ­ naplnÄn na maximÃ¡lnÃ­ hladinu.",
            warningConfirmBtn: "Jsem si vÄdom rizika, pÅesto pokraÄovat"
        },
        help: "Podpora",
        helpLink: "Centrum nÃ¡povÄdy",
        helper: {
            automaticallyCheckForUpdates:
                "AutomatickÃ¡ kontrola aktualizace pro %{name} nebo databÃ¡ze v danÃ©m ÄasovÃ©m intervalu.",
            automaticallyDownloadUpdates: "Pokud je dostupnÃ¡ aktualizace, bude bez potvrzenÃ­ staÅ¾ena.",
            automaticallyInstallNewDatabases:
                "Pokud bude pÅijata dosud chybÄjÃ­cÃ­ DB, bude nainstalovÃ¡na jako novÃ¡. PotÃ© ji lze pouÅ¾Ã­t.",
            automaticallyInstallUpdates: "Po staÅ¾enÃ­ bude aktualizace nainstalovÃ¡na bez potvrzenÃ­.",
            canBrowseChangeLog: "PÅi aktualizaci softvÃ©ru se zobrazÃ­ oficiÃ¡lnÃ­ changelog %{name}.",
            forceInstall: "Aktualizace bude nainstalovÃ¡na silou.",
            installDuringNight: "Aktualizace bude nainstalovÃ¡na v prÅ¯bÄhu noci, pokud je poÄÃ­taÄ puÅ¡tÄn."
        },
        licensing: {
            collect:
                "Logy budou staÅ¾eny do vybranÃ©ho adresÃ¡Åe. Tyto logy pouÅ¾Ã­vÃ¡ vÃ½robce software k identifikaci a opravÄ chyb.",
            company: "SpoleÄnost, kterÃ¡ poskytuje licenci.",
            computerID: "Identifikace licence. Tento Ãºdaj umoÅ¾nÃ­ dodavateli software poskytnout pomoc.",
            email: "E-mail drÅ¾itele licence",
            licenseUuid: "Tento Ãºdaj umoÅ¾nÃ­ dodavateli software poskytnout pomoc.",
            name: "JmÃ©no drÅ¾itele licence.",
            openBugreport: "Pokud naleznete softwarovou chybu, kontaktujte nÃ¡s prosÃ­m s jejÃ­m popisem.",
            posInfoContactperson: "Informace o vlastnÃ­kovi mohol bÃ½t vytiÅ¡tÄny na Å¡tÃ­tku.",
            posInfoMachineInformation:
                "Informace o stroji v prodejnÄ, kterÃ© mohou bÃ½t pouÅ¾ity pro tiskovÃ½ Å¡Å¥Ã­tek anebo pro identifikaci stroje v sÃ­ti.",
            posInfoPos: "Informace o prodejnÃ­m mÃ­stÄ mohou bÃ½t vytÃ­Å¡tÄny na Å¡tÃ­tku.",
            reactivation: "Reaktivace nebo zmÄna stÃ¡vajÃ­cÃ­ licence.",
            refresh: "StÃ¡hnout nejnovÄjÅ¡Ã­ informace o licenci.",
            refreshUnavailable: "ObnovenÃ­ licence nenÃ­ k dispozici protoÅ¾e jste offline.",
            registrationContactperson: "RegistraÄnÃ­ informace identifikujÃ­cÃ­ kontaktnÃ­ osobu.",
            registrationMachineInformation: "RegistraÄnÃ­ informace pro identifikaci stroje.",
            registrationPos: "RegistraÄnÃ­ informace pro identifikaci mÃ­sta. ",
            versionScope: "VyprÅ¡enÃ­ licence produktu",
            versionType: "Typ produktu"
        },
        machineIsBusy: "Chyby se nedajÃ­ resetovat, protoÅ¾e stroj je zaneprÃ¡zdnÄn.",
        machineSettings: {
            allowManualColorantAddition:
                "Pokud poÅ¾adovanÃ© mnoÅ¾stvÃ­ kolorantu pÅekroÄÃ­ maximÃ¡lnÃ­ mnoÅ¾stvÃ­ vÃ½deje, toto nastavenÃ­ umoÅ¾Åuje ruÄnÃ­ pÅidÃ¡nÃ­ po vÃ½deji",
            autotasks:
                "AutomatickÃ© Ãºlohy jsou automatickÃ© ÃºdrÅ¾by strojÅ¯ a poÄÃ­taÄÅ¯, kterÃ© lze nastavit tak, aby se provÃ¡dÄly v urÄitÃ©m ÄasovÃ©m intervalu.",
            barcodeRefillValidation: "Toto nastavenÃ­ zapne validaci barcodu pÅi tÃ³novÃ¡nÃ­.",
            barcodeRefillValidationBaseAndColorant:
                "Kontrola ÄÃ¡rovÃ©ho kÃ³du je provedena pÅi doplÅovÃ¡nÃ­ kanystru a balenÃ­ pigmentu.",
            barcodeRefillValidationColorant: "Kontrola ÄÃ¡rovÃ©ho kÃ³du je provedena pÅi doplÅovÃ¡nÃ­ balenÃ­ pigmentu.",
            canisterBarcode:
                "ÄÃ¡rovÃ½ kÃ³d je pÅiÅazen ke kanystru s kolorantem. ÄÃ¡rovÃ½ kÃ³d je nutnÃ½ pro zajiÅ¡tÄnÃ­ doplnÄnÃ­ kolorantu.",
            checkCanBeforeDispense: "NastavenÃ­ je validnÃ­ pouze pro Fast & Fluid simulaci.",
            checkOverfill: "NastavenÃ­ zkontroluje, zda je pÅed tÃ³novÃ¡nÃ­m v plechovce dostatek mÃ­sta pro barviva.",
            currentlySelectedMachine: "Poskytuje informace o vybranÃ©m stroji.",
            dispenseInvalidColorants:
                "Toto nastavenÃ­ umoÅ¾Åuje vydÃ¡vat koloranty, kterÃ© nejsou definovÃ¡na v konfiguraci stroje tÃ­m, Å¾e vyzve k ruÄnÃ­mu pÅidÃ¡nÃ­ kolorantu.",
            dispenserConfigurationBackup: "UloÅ¾Ã­ a stÃ¡hne konfiguraci stroje pro zÃ¡lohy.",
            dispensingLogic:
                "JednotlivÃ© typy zajistÃ­ rÅ¯znÃ© chovÃ¡nÃ­ v pÅÃ­padÄ, Å¾e se mÃ¡ vytÃ³novat vÄtÅ¡Ã­ mnoÅ¾stvÃ­ colorantu neÅ¾ je povoleno nebo vyÅ¾adovÃ¡no. DodateÄnÃ© chovÃ¡nÃ­ je nastaveno v NastavenÃ­ tÃ³novÃ¡nÃ­.",
            enableTmc: "NastavenÃ­ umoÅ¾Åuje odesÃ­lÃ¡nÃ­ dat do TMC.",
            enableUserIdentification: "UÅ¾ivatel se musÃ­ pÅed tÃ³novÃ¡nÃ­m pÅihlÃ¡sit.",
            machineUnit: "StrojovÃ¡ jednotka definuje mÄrnou jednotku kolorantÅ¯ v nÃ¡dobÃ¡ch.",
            minDispensedAmount:
                "Min. TÃ³novanÃ© mnoÅ¾stvÃ­ urÄuje, kolik kolorantÅ¯ musÃ­ bÃ½t vydÃ¡no, aby se zvÃ¡Å¾ilo provedenÃ­ odstÅiku (aby se zabrÃ¡nilo dalÅ¡Ã­mu odstÅiku).",
            minimalDispenseAmount:
                "MinimÃ¡lnÃ­ tÃ³novanÃ© mnoÅ¾stvÃ­ je nejmenÅ¡Ã­ doporuÄenÃ© mnoÅ¾stvÃ­ kolorantu, kterÃ© mÅ¯Å¾e bÃ½t vydÃ¡no. Pokud dojde k poruÅ¡enÃ­, objevÃ­ se zprÃ¡va (tÃ³novÃ¡nÃ­ je stÃ¡le moÅ¾nÃ©).",
            missingAutotaskCanisters: "MusÃ­ bÃ½t vybrÃ¡n alespoÅ 1 kanystr",
            missingAutotaskChannels: "MusÃ­ bÃ½t vybrÃ¡n alespoÅ 1 kanÃ¡l",
            missingAutotaskChannelsValue: "MusÃ­ bÃ½t vyplnÄn objem vÅ¡ech vybranÃ½ch kanÃ¡lÅ¯",
            missingAutotaskCleanTime: "MusÃ­ bÃ½t vyplnÄn Äas ÄiÅ¡tÄnÃ­",
            missingAutotaskName: "MusÃ­ bÃ½t vyplnÄn nÃ¡zev automatickÃ© Ãºlohy",
            missingAutotaskRecirculation: "MusÃ­ bÃ½t vyplnÄny Äas a rychlost recirkulace",
            missingAutotaskStirring: "MusÃ­ bÃ½t vyplnÄny Äas a rychlost mÃ­chÃ¡nÃ­",
            missingAutotaskVolume: "MusÃ­ bÃ½t vyplnÄn objem odstÅiku",
            placeCanSensor:
                "NastavenÃ­ aktivuje senzor pro umÃ­stÄnÃ­ plechovky â tÃ³novÃ¡nÃ­ nezaÄne, dokud plechovka nebude sprÃ¡vnÄ umÃ­stÄna.",
            placeCanSensorDelay:
                "DoporuÄenÃ© nastavenÃ­ spojenÃ© s mÃ­stem senzoru plechovy. ZajiÅ¡Å¥uje, Å¾e vÃ½dej zaÄÃ­nÃ¡ aÅ¾ po definovanÃ©m ÄasovÃ©m obdobÃ­, bÄhem kterÃ©ho byla plechovka sprÃ¡vnÄ umÃ­stÄna.",
            purgeVolume: "Hodnota odstÅiku nastavuje, kolik kolorantu se odstÅÃ­kne pÅi provÃ¡dÄnÃ­ chytrÃ©ho odstÅiku.",
            rccUrl: "RCC (Redlike Control Center) je zodpovÄdnÃ© za komunikaci se strojem.",
            refillThreshold:
                "Pokud hodnota pigmentu v kanystru s danÃ½m UFI nebo ÄÃ­sla Å¡arÅ¾Ã­ dosÃ¡hne niÅ¾Å¡Ã­ hodnoty neÅ¾ je definovanÃ¡, UFI nebo ÄÃ­slo Å¡arÅ¾e bude vyÅazeno.",
            refillThresholdBatch:
                "Pokud hodnota pigmentu v kanystru s danÃ½m ÄÃ­slem Å¡arÅ¾Ã­ dosÃ¡hne niÅ¾Å¡Ã­ hodnoty neÅ¾ je definovanÃ¡, ÄÃ­slo Å¡arÅ¾e bude vyÅazeno.",
            refillThresholdUfi:
                "Pokud hodnota pigmentu v kanystru s danÃ½m UFI dosÃ¡hne niÅ¾Å¡Ã­ hodnoty neÅ¾ je definovanÃ¡, UFI bude vyÅazeno.",
            removeCanSensor:
                "NastavenÃ­ aktivuje senzor pro vyjmutÃ­ plechovky - vÃ½dej se nepovaÅ¾uje za provedenÃ½, pokud nebyla plechovka vyjmuta.",
            removeCanSensorDelay:
                "DoporuÄenÃ© nastavenÃ­ pÅipojenÃ© k odstranÄnÃ­ senzoru plechovky. ZajiÅ¡Å¥uje, Å¾e vÃ½dej byl dokonÄen aÅ¾ po definovanÃ©m ÄasovÃ©m obdobÃ­, bÄhem kterÃ©ho byla plechovka vyjmuta.",
            skipPlaceCanDialog:
                "KdyÅ¾ je toto nastavenÃ­ zapnuto, stroj nebude Äekat na umÃ­stÄnÃ­ plechovky, dokud nestisknete tlaÄÃ­tko OK, ale automaticky spustÃ­ proces tÃ³novÃ¡nÃ­.",
            skipRemoveCanDialog:
                "KdyÅ¾ je toto nastavenÃ­ zapnuto, stroj nebude Äekat na vyjmutÃ­ plechovky, dokud nestisknete tlaÄÃ­tko OK, ale bude tÃ³novÃ¡nÃ­ automaticky povaÅ¾ovat za ukonÄenÃ©.",
            smartPurgeType: "Typ odstÅiku mÅ¯Å¾e zvÃ¡Å¾it pouze tÃ³novÃ¡nÃ­ a nebo tÃ³novÃ¡nÃ­ a jinou odsÅikovou akci pÅi",
            splitFormula:
                "Pokud poÅ¾adovanÃ© mnoÅ¾stvÃ­ kolorantu pÅesÃ¡hne maximÃ¡lnÃ­ mnoÅ¾stvÃ­ pro tÃ³novÃ¡nÃ­, nastavenÃ­ umoÅ¾Åuje vydat ÄÃ¡st kolorantu, doplnit zÃ¡sobnÃ­k a potÃ© pokraÄovat v tÃ³novÃ¡nÃ­ zbytku.",
            tintometricSystem:
                "TintometrickÃ½ systÃ©m (soubor dostupnÃ½ch kolorantÅ¯) definuje, jakÃ© koloranty a receptury budou k dispozici v aplikaci a nastavenÃ­ aplikace.",
            validateBarcodeBaseCan:
                "BÃ¡ze plechovky musÃ­ bÃ½t ovÄÅena pomocÃ­ ÄÃ¡rovÃ©ho kÃ³du. NastavenÃ­ zajiÅ¡Å¥uje pouÅ¾itÃ­ sprÃ¡vnÃ© bÃ¡ze",
            validateColorantsDuringInit:
                "Konfigurace stroje se pÅi kaÅ¾dÃ©m spuÅ¡tÄnÃ­ RCC porovnÃ¡ s databÃ¡zÃ­. V pÅÃ­padÄ nezhody se objevÃ­ oznÃ¡menÃ­."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Definuje, kolik vÃ½sledkÅ¯ by mÄlo bÃ½t nabÃ­dnuto po matchingu."
        },
        navigation: {
            barcodeScan: "OtevÅe okno s moÅ¾nostÃ­ zadat ÄÃ¡rovÃ½ kÃ³d ruÄnÄ.",
            canisterBarcodes:
                "OtevÅe okno s pÅehledem ÄÃ¡rovÃ½ch kÃ³dÅ¯ kanystrÅ¯ a s moÅ¾nostÃ­ nastavit ÄÃ¡rovÃ© kÃ³dy pro kanystry.",
            canisterLevel: "OtevÅe okno s pÅehledem ÃºrovnÃ­ kanystrÅ¯ a s moÅ¾nostÃ­ nastavit ÃºrovnÄ kanystrÅ¯.",
            canisters: "OtevÅe panel s pÅehledem ÃºrovnÃ­ kanystrÅ¯ a s moÅ¾nostÃ­ nastavit ÃºrovnÄ kanystrÅ¯.",
            clean: "OtevÅete okno s moÅ¾nostÃ­ ÄiÅ¡tÄnÃ­ kanÃ¡lÅ¯ stroje.",
            colorPanel: "OtevÅe panel s moÅ¾nostÃ­ hledat novou recepturu v elektronickÃ© vzorkovnici.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "OtevÅe okno s pÅehledem provedenÃ½ch doplÅovÃ¡nÃ­ kanystrÅ¯.",
            customFormula: "OtevÅe panel s moÅ¾nostÃ­ vytvoÅit novou vlastnÃ­ recepturu.",
            customers: "OtevÅe panel s pÅehledem zÃ¡kaznÃ­kÅ¯ s moÅ¾nostÃ­ je pÅidat/upravit/smazat.",
            dispensingHistory: "OtevÅe panel s pÅehledem vykonanÃ½ch tÃ³novÃ¡nÃ­.",
            favorites: "OtevÅe panel s moÅ¾nostÃ­ vÃ½bÄru oblÃ­benÃ© receptury.",
            help: "OtevÅe okno s informacemi o podpoÅe zÃ¡kaznÃ­kÅ¯, jestli je dodavatel doplnil.",
            hideItems: "OtevÅe okno s moÅ¾nostÃ­ oznaÄit produkty a vÄjÃ­Åe jako skrytÃ©.",
            historyOfOrders: "PlatÃ­ jenom pro %{name} - otevÅe panel s pÅehledem vytÃ³novanÃ½ch objednÃ¡vek.",
            machineReset: "SpustÃ­ reset stroje.",
            matching: "OtevÅe panel s moÅ¾nostÃ­ matchingu novÃ©ho odstÃ­nu.",
            myOrders: "OtevÅe panel s pÅehledem poslanÃ½ch objednÃ¡vek.",
            purge: "OtevÅe okno s moÅ¾nostÃ­ nastavenÃ­ odstÅikÅ¯ kanystrÅ¯.",
            quickTint: "OtevÅe okno s moÅ¾nostÃ­ ruÄnÃ­ho tÃ³novÃ¡nÃ­.",
            searchFormula: "OtevÅe panel s moÅ¾nostÃ­ vyhledat novou recepturu.",
            spectro: "OtevÅe panel s moÅ¾nostÃ­ meÅenÃ­ pomocÃ­ spektrometru.",
            stir: "OtevÅe okno s moÅ¾nostÃ­ nastavenÃ­ mÃ­chÃ¡nÃ­ kanystrÅ¯.",
            ticketing: "OtevÅe panel ticketingu.",
            toDispense: "OtevÅe panel s pÅehledem pÅijatÃ½ch objednÃ¡vek."
        },
        noHelpForLicense: "Pro VaÅ¡i licenci nenÃ­ k dispozici Å¾Ã¡dnÃ¡ podpora, poÅ¾Ã¡dejte svÃ©ho dodavatele, aby ji pÅidal.",
        posInfo: {
            sync: "Synchronizuje data se sekcÃ­ Registrace"
        },
        poweredByDeso: "Poskytuje %{name}",
        priceSettings: {
            VatPrice: "Hodnota DPH na kolorantu v %.",
            VatPriceProduct: "ObecnÃ¡ hodnota DPH bude stejnÃ¡ pro vÅ¡echny odstÃ­ny. UdÃ¡vÃ¡no v %.",
            basePurchase: "KupnÃ­ cena bÃ¡ze (vÄetnÄ bÃ¡ze vÃ½hradnÄ).",
            basePurchasePriceProduct: "NÃ¡kupnÃ­ cena balenÃ­ danÃ© bÃ¡ze. UdÃ¡vÃ¡no ve zvolenÃ© mÄnÄ.",
            baseSell: "ProdejnÃ­ cena pouze z bÃ¡ze (vÄetnÄ marÅ¾e bÃ¡ze / marÅ¾e).",
            baseSellFull: "PlnÃ¡ prodejnÃ­ cena bÃ¡ze.",
            cntName: "UrÄuje k jakÃ©mu kolorantu je cena vÃ¡zÃ¡na.",
            cntPurchase: "VÃ½kupnÃ­ cena za kolorant (vÄetnÄ kolorantu).",
            cntPurchaseByName: "VÃ½kupnÃ­ cena za kolorantu vypoÄtenÃ¡ individuÃ¡lnÄ pro kaÅ¾dou (vÄetnÄ kolorantu).",
            cntPurchasePricePerLiter: "NÃ¡kladovÃ¡ cena kolorantu za litr (bez marÅ¾e nebo zdraÅ¾enÃ­).",
            cntSell: "ProdejnÃ­ cena pouze za koloranty (vÄetnÄ kolorantu a marÅ¾e).",
            cntSellByName:
                "ProdejnÃ­ cena vÅ¡ech kolorantÅ¯ pouÅ¾itÃ½ch v produktu se poÄÃ­tÃ¡ jednotlivÄ pro kaÅ¾dÃ© (vÄetnÄ kolorantu a marÅ¾e).",
            cntSellFull: "NÃ¡kupnÃ­ cena pro pigmenty bez slevy.",
            cntSellFullByName: "NÃ¡kupnÃ­ cena pro pigmenty vypoÄÃ­tanÃ¡ zvlÃ¡Å¡Å¥ pro kaÅ¾dÃ½ pigment bez slevy.",
            cntSellPricePerLiter: "ProdejnÃ­ cena kolorantu za litr (pouze cena kolorantu). Nastaveno ve vybranÃ© mÄnÄ.",
            cntVat: "DPH kolorantu udÃ¡vanÃ¡ v %.",
            colorants:
                "Ceny generickÃ½ch kolorantÅ¯ budou stejnÃ© pro kaÅ¾dÃ½ kolorant. Tato funkce je uÅ¾iteÄnÃ¡ zejmÃ©na pro nastavenÃ­ DPH.",
            colorantsPosCoeficient: "ObecnÃ½ koeficient kolorantu pro prodejnu.",
            colorantsSellPrice:
                "ObecnÃ¡ cena kolorantu bude stejnÃ¡ pro kaÅ¾dÃ½ kolorant. Je doporuÄeno, aby byla prodejnÃ­ cena v kombinaci se slevou. UdÃ¡vÃ¡no ve zvolenÃ© mÄnÄ.",
            currencyCodeNew: "KÃ³d mÄny musÃ­ bÃ½t v oficiÃ¡lnÃ­ podobÄ, napÅÃ­klad EUR.",
            currencyNameNew: "NÃ¡zev mÄny, napÅÃ­klad Euro.",
            currencyRateNew:
                "Kurz mÄny vÅ¯Äi hlavnÃ­ mÄnÄ, napÅÃ­klad 25,855 KÄ za 1 â¬. Sazba musÃ­ bÃ½t prÅ¯bÄÅ¾nÄ upravovÃ¡na, aby byla aktuÃ¡lnÃ­.",
            currencyRoundingNew:
                "ZaokrouhlovÃ¡nÃ­ nastavÃ­ nejmenÅ¡Ã­ moÅ¾nou splatnou hodnotu mÄny, napÅÃ­klad Euro mÃ¡ zaokrouhlovÃ¡nÃ­ 0,01, protoÅ¾e nejmenÅ¡Ã­ moÅ¾nÃ¡ hodnota je 1 cent.",
            currencySymbolNew: "OficiÃ¡lnÃ­ symbol mÄny, napÅÃ­klad â¬ za euro.",
            defaultPrice: "Cena kolorantu nastavenÃ¡ ve vybranÃ© databÃ¡zi (bez DPH).",
            defaultPriceGroup: "Cena kolorantu pro cenovou skupinu nastavenou ve vybranÃ© databÃ¡zi (bez DPH).",
            defaultVatPrice: "DPH vybranÃ©ho kolorantu ve vybranÃ© databÃ¡zi.",
            discountHeader: "Sleva odeÄÃ­tÃ¡ definovanou hodnotu z nÃ¡kupnÃ­ ceny kolorantu. UdÃ¡vÃ¡no v %.",
            discountHeaderProduct: "Sleva odeÄÃ­tÃ¡ definovanou hodnotu z nÃ¡kupnÃ­ ceny produktu kolorantu. UdÃ¡vÃ¡no v %.",
            export: "Export souboru s cenami. Ceny je moÅ¾nÃ© upravit a potÃ© znovu naimportovat.",
            import: "Importovat naformÃ¡tovanÃ½ (exportovanÃ½) soubor nebo upravit ceny.",
            localPrices:
                "LokÃ¡lnÃ­ ceny mÄnÃ­ navrhovanÃ© ceny z hlavnÃ­ databÃ¡ze a jsou dostupnÃ© pouze lokÃ¡lnÄ na tomto poÄÃ­taÄi.",
            margin: "Vyberte jakÃ½ vÃ½poÄet ceny mÃ¡ bÃ½t pouÅ¾it pro urÄenÃ­ finÃ¡lnÃ­ ceny. MarÅ¾e a obchodnÃ­ pÅirÃ¡Å¾ka pÅiÄÃ­tajÃ­, zatÃ­mco sleva z celkovÃ© prodejnÃ­ ceny odeÄÃ­tÃ¡.",
            marginAll: "Cena za marÅ¾i / pÅirÃ¡Å¾ku pro vÃ­ce balenÃ­ (vÄetnÄ marÅ¾e / pÅirÃ¡Å¾ky).",
            marginHeader: "MarÅ¾e pÅidÃ¡vÃ¡ definovanou hodnotu k nÃ¡kupnÃ­ cenÄ kolorantu. UdÃ¡vÃ¡no v %.",
            marginHeaderProduct: "MarÅ¾e pÅidÃ¡vÃ¡ definovanou hodnotu k nÃ¡kupnÃ­ cenÄ produktu. UdÃ¡vÃ¡no v %.",
            marginPerPkg: "Cena za marÅ¾i / pÅirÃ¡Å¾ku za jedno balenÃ­ (vÄetnÄ marÅ¾e / pÅirÃ¡Å¾ky).",
            markupHeader: "PÅirÃ¡Å¾ka pÅidÃ¡vÃ¡ urÄenou hodnotu k nÃ¡kupnÃ­ cenÄ kolorantu. UdÃ¡vÃ¡no v %.",
            markupHeaderProduct: "PÅirÃ¡Å¾ka pÅidÃ¡vÃ¡ urÄenou hodnotu k nÃ¡kupnÃ­ cenÄ produktu. UdÃ¡vÃ¡no v %.",
            packagePricing: "DodateÄnÃ½ pÅÃ­platek je stanoven individuÃ¡lnÄ pro kaÅ¾dou velikost balenÃ­.",
            packageSurcharge: "Ceny generickÃ½ch balenÃ­ budou stejnÃ© za kaÅ¾dÃ½ pÅÃ­platek za balenÃ­.",
            priceDefinition: "Definice logiky cen.",
            priceGroupNumber: "CenovÃ© skupiny zobrazujÃ­ poÄet relevantnÃ­ch cenovÃ½ch skupin.",
            priceGroupPricePerLiter: "Cena kolorantu pouÅ¾itÃ¡ pÅi vÃ½poÄtu ceny cenovÃ© skupiny.",
            priceGroups:
                "CenovÃ© skupiny zobrazujÃ­ ÄÃ­slo pÅÃ­sluÅ¡nÃ© cenovÃ© skupiny (hranice jsou stanoveny v databÃ¡zi nebo v generickÃ©m oceÅovÃ¡nÃ­).",
            priceGroupsEnabled: "CenovÃ© skupiny zobrazujÃ­ poÄet relevantnÃ­ch cenovÃ½ch skupin.",
            priceGroupsGeneric:
                "CenovÃ© skupiny jsou cenovÃ© intervaly koneÄnÃ©ho kolorantu na zÃ¡kladÄ cen barviv v receptuÅe.",
            productBasePackageSellPrice: "ProdejnÃ­ cena za balenÃ­ danÃ© bÃ¡ze. Nastaveno ve vybranÃ© mÄnÄ.",
            productBaseSellPrice: "ProdejnÃ­ cena bÃ¡ze za litr (pouze cena bÃ¡ze). Nastaveno ve vybranÃ© mÄnÄ.",
            productBaseVat: "ZÃ¡kladnÃ­ hodnota DPH produktu pro danÃ© balenÃ­ udÃ¡vanÃ¡ v %.",
            productName: "UrÄuje k jakÃ© produktovÃ© bÃ¡zi je cena vÃ¡zÃ¡na.",
            productPosCoeficient: "ObecnÃ½ koeficient produktu pro prodejnu.",
            productPricing: "PÅi vÃ½deji vlastnÃ­ch balenÃ­ se pouÅ¾Ã­vÃ¡ nÃ¡kupnÃ­ cena pro vÅ¡echna balenÃ­.",
            productSize: "UrÄuje k jakÃ©mu balenÃ­ produktovÃ© bÃ¡ze je cena vÃ¡zÃ¡na.",
            productVat: "Hodnota DPH produktovÃ© bÃ¡ze udÃ¡vanÃ¡ v %.",
            products:
                "Ceny generickÃ½ch produktÅ¯ budou stejnÃ© pro kaÅ¾dÃ½ produkt. Tato funkce je uÅ¾iteÄnÃ¡ zejmÃ©na pro nastavenÃ­ DPH.",
            productsSellPrice:
                "ObecnÃ© ceny produktÅ¯ budou stejnÃ© pro vÅ¡echny koloranty. Je doporuÄeno, aby byla prodejnÃ­ cena v kombinaci se slevou. UdÃ¡vÃ¡no ve zvolenÃ© mÄnÄ.",
            sellPriceAll: "ProdejnÃ­ cena vÃ­ce balenÃ­ (vÄetnÄ bÃ¡ze, kolorantu, pÅÃ­platku a marÅ¾e / pÅirÃ¡Å¾ky).",
            sellPricePerKg:
                "ProdejnÃ­ cena produktu za kilogram (vÄetnÄ bÃ¡ze, kolorantu, pÅiÃ­platku a marÅ¾e / pÅirÃ¡Å¾ky).",
            sellPricePerL: "ProdejnÃ­ cena produktu za litr (vÄetnÄ bÃ¡ze, kolorantu, pÅiÃ­platku a marÅ¾e / pÅirÃ¡Å¾ky).",
            sellPricePerPkg: "ProdejnÃ­ cena jednoho balenÃ­ (vÄetnÄ bÃ¡ze, kolorantu, pÅiÃ­platku a marÅ¾e / pÅirÃ¡Å¾ky).",
            setPriceTypesVisibilityAndOrder:
                "Na panelu receptury budou vybranÃ© ceny viditelnÃ© v sekci ceny. NejvyÅ¡Å¡Ã­ poloha zde definuje pozici nejvÃ­ce vlevo v sekci.",
            surchargeAll: "Cena pÅÃ­platku za vÃ­ce balenÃ­ (vÄetnÄ pÅÃ­platku).",
            surchargePerPkg: "Cena pÅÃ­platku za jedno balenÃ­ (vÄetnÄ pÅÃ­platku).",
            tintPurchaseAll: "KupnÃ­ cena za celÃ½ tÃ³novacÃ­ proces vÃ­ce balenÃ­ (vÄetnÄ kolorantu a pÅÃ­platku).",
            tintPurchasePerPkg: "KupnÃ­ cena za celÃ½ tÃ³novacÃ­ proces jednoho balenÃ­ (vÄetnÄ kolorantu a pÅÃ­platku).",
            tintSellFullAll:
                "KupnÃ­ cena za celÃ½ tÃ³novacÃ­ proces jednoho balenÃ­ (vÄetnÄ kolorantu a pÅÃ­platku) bez slevy.",
            tintlSellFullAllPerPackage:
                "KupnÃ­ cena za celÃ½ tÃ³novacÃ­ proces vÃ­ce balenÃ­ (vÄetnÄ kolorantu a pÅÃ­platku) bez slevy.",
            totalPurchaseAll: "CelkovÃ¡ kupnÃ­ cena produktu pro vÃ­ce balenÃ­ (vÄetnÄ kolorantu a bÃ¡ze).",
            totalPurchasePerKg: "CelkovÃ¡ kupnÃ­ cena produktu za kilogram (vÄetnÄ bÃ¡ze a kolorantu).",
            totalPurchasePerL: "CelkovÃ¡ kupnÃ­ cena produktu za litr (vÄetnÄ bÃ¡ze a kolorantu).",
            totalPurchasePerPkg: "CelkovÃ¡ kupnÃ­ cena produktu za jedno balenÃ­ (vÄetnÄ bÃ¡ze a kolorantu).",
            totalSellFullAll: "KompletnÃ­ prodejnÃ­ cena pro vÃ­ce balenÃ­ bez slevy.",
            totalSellFullPerKg: "KompletnÃ­ prodejnÃ­ cena pro kilogram bez slevy.",
            totalSellFullPerLiter: "KompletnÃ­ prodejnÃ­ cena pro litr bez slevy.",
            totalSellFullPerPackage: "KompletnÃ­ prodejnÃ­ cena pro jedno balenÃ­ bez slevy.",
            withAndWithoutVat: "Ceny na panelu receptury budou viditelnÃ© zÃ¡roveÅ jak s danÃ­ tak bez danÄ.",
            withVat: "VÅ¡echny ceny na panelu receptury budou viditelnÃ© s danÃ­.",
            withoutVat: "VÅ¡echny ceny na panelu receptury budou viditelnÃ© bez danÄ."
        },
        qualityControlSettings: {
            colorDifference: "Model barevnÃ©ho rozdÃ­lu pro kontrolu kvality.",
            deltaA: "Definuje toleranÄnÃ­ limit pro delta A pÅi kontrole kvality.",
            deltaB: "Definuje toleranÄnÃ­ limit pro delta B pÅi kontrole kvality.",
            deltaE: "Definuje toleranÄnÃ­ limit pro delta E pÅi kontrole kvality.",
            deltaL: "Definuje toleranÄnÃ­ limit pro delta L pÅi kontrole kvality.",
            deltaMetamerism: "Definuje toleranÄnÃ­ limit pro metamerism pÅi kontrole kvality."
        },
        registration: {
            sync: "Synchronizuje data se sekcÃ­ Inofrmace o prodejnÃ­m mÃ­stÄ."
        },
        searchingPleaseWait: "PoÄkejte prosÃ­m, hledÃ¡ se nejlepÅ¡Ã­ shoda",
        setupSteps: {
            customData: "VlastnÃ­ data",
            machineType: "Typ zaÅÃ­zenÃ­",
            userPreferences: "UÅ¾ivatelskÃ© preference"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "PÅi pouÅ¾itÃ­ profilovÃ½ch hodnot se namÄÅenÃ© vÃ½sledky pÅepoÄtou, aby se odstranil efekt filtrovÃ¡nÃ­. Povolte tuto moÅ¾nost, aby ste dosÃ¡hli univerzÃ¡lnÃ­ mÄÅenÃ­.",
            XRiteModelRM400: "NevyÅ¾aduje Å¾Ã¡dnÃ© ovladaÄe.",
            datacolorDiagnosticTile: "Datacolor pouÅ¾Ã­vÃ¡ diagnostickou doÅ¡tiÄku",
            datacolorSilent: "Datacolor silent",
            measureModes: "Zvolte podporovanÃ© ÃºrovnÄ lesku.",
            model: "Model",
            simulationPath: "Cesta k simulaÄnÃ­mu ovladaÄi. DefaultnÃ­ nastavenÃ­.",
            spectroType: "OvladaÄ spektrometru musÃ­ bÃ½t nainstalovÃ¡n. Pouze pro windows.",
            spectroTypeCom: "OvladaÄ spektrometru musÃ­ bÃ½t nainstalovÃ¡n. Zkontrolujte prosÃ­m pouÅ¾itÃ© COM porty.",
            spectroTypeDataColorReader:
                "PoÄÃ­taÄ musÃ­ mÃ­t pÅipojenÃ­ Bluetooth. Spektro musÃ­ bÃ½t spÃ¡rovanÃ© s poÄÃ­taÄem. Je nutnÃ½ Windows 10 s podzimnÃ­ aktualizacÃ­ 2018..",
            spectroTypeMinolta2XXXd:
                "MusÃ­ bÃ½t nainstalovÃ¡n oficiÃ¡lnÃ­ ovladaÄ spektra. Pozor na pouÅ¾itÃ½ COM port. Pro Windows i pro Linux.",
            spectroTypeNotSelected: "Zvolte typ spektra.",
            spectroTypeRM400: "NevyÅ¾aduje Å¾Ã¡dnÃ© ovladaÄe.",
            spectroTypeSimulation: "Hodnoty LAB jsou vyÅ¾adovÃ¡ny na obdrÅ¾enÃ­ simulaÄnÃ­ch vÃ½sledkÅ¯. Pro Windows i Linux.",
            spectroTypeXRite: "Jenom pro Windows."
        },
        ufiCode: {
            baseUfiCodeValidation:
                "PÅed tÃ­m, neÅ¾ je povoleno tÃ³novÃ¡nÃ­, je nutnÃ© ovÄÅit UFI kÃ³d na plechovce bÃ¡ze pomocÃ­ ÄÃ¡rovÃ©ho kÃ³du.",
            enableUfiCodes:
                "UFI kÃ³dy jsou v rÃ¡mci EU uÅ¾Ã­vÃ¡ny za ÃºÄelem poskytnutÃ­ informace o tom, jak nebezpeÄnÃ½ je produkt pro Å¾ivotnÃ­ prostÅedÃ­.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "V pÅÃ­padÄ, Å¾e kolorant v receptuÅe pÅekroÄÃ­ stanovenou hranici, jeho UFI kÃ³d bude vytiÅ¡tÄn na tiskovÃ½ Å¡tÃ­tek.",
            printUfiCodePercentage:
                "V pÅÃ­padÄ, Å¾e kolorant v receptuÅe pÅekroÄÃ­ stanovenou hranici, jeho UFI kÃ³d bude vytiÅ¡tÄn na tiskovÃ½ Å¡tÃ­tek spolu s jeho procentuÃ¡lnÃ­m zastoupenÃ­m.",
            ufiCodesByPercentage:
                "UFI kÃ³d, kterÃ©ho mnoÅ¾stvÃ­ v zÃ¡sobnÃ­ku v Äase tÃ³novÃ¡ni dominuje, je vytiÅ¡tÄn na tiskovÃ½ Å¡tÃ­tek. PÅejdÄte do nastavenÃ­ kanistru a definujte hraniÄnÃ­ hodnotu pro kaÅ¾dou nÃ¡dobu.",
            ufiCodesFromDatabase: "K tisku se pouÅ¾Ã­vÃ¡ UFI kÃ³d z hlavnÃ­ databÃ¡ze pÅidÄlenÃ½ sprÃ¡vcem databÃ¡ze.",
            ufiCodesFromLastFilling:
                "Bez ohledu na doplnÄnÃ© mnoÅ¾stvÃ­ se pro tisk pouÅ¾ije UFI kÃ³d z poslednÃ­ho plnÄnÃ­ zadanÃ©ho obsluhou."
        },
        userManagement: {
            add: "PÅidÃ¡nÃ­ novÃ©ho uÅ¾ivatele. UÅ¾ivatel mÅ¯Å¾e mÃ­t pÅiÅazen ÄÃ¡rovÃ½ kÃ³d nebo mÅ¯Å¾e bÃ½t nastaven jako vÃ½chozÃ­ uÅ¾ivatel.",
            assignedGroups:
                "Toto nastavenÃ­ definuje uÅ¾ivatelskou skupinu do kterÃ© uÅ¾ivatel patÅÃ­. UÅ¾ivatelÃ© mohou mÃ­t rÅ¯znÃ¡ oprvÃ¡nÄnÃ­ zÃ¡vislÃ¡ prÃ¡vÄ na tÃ©to skupinÄ.",
            availableGroups:
                "Toto nastavenÃ­ definuje uÅ¾ivatelskou skupinu. UÅ¾ivatelÃ© mohou mÃ­t rÅ¯znÃ¡ oprÃ¡vnÄnÃ­ zÃ¡vislÃ¡ prÃ¡vÄ na tÃ©to skupinÄ.",
            loggedUserDelete: "PÅihlÃ¡Å¡enÃ½ uÅ¾ivatel nemÅ¯Å¾e bÃ½t smazÃ¡n."
        },
        visit: "Anebo navÅ¡tivte",
        visitNoLicense: "Pro vÃ­ce informacÃ­, navÅ¡tivte prosÃ­m"
    },
    helpSettings: {
        customHelpLink: "Odkaz na vlastnÃ­ centrum nÃ¡povÄdy",
        helpSettings: "NastavenÃ­ podpory",
        message: "ZprÃ¡va"
    },
    helper: {
        automaticallyCheckForUpdates: "Vyhledat aktualizace automaticky",
        automaticallyDownloadUpdates: "StÃ¡hnout aktualizace automaticky",
        automaticallyInstallNewDatabases: "Automaticky instalovat novÃ© databÃ¡ze",
        automaticallyInstallUpdates: "Automaticky instalovat novÃ© aktualizace",
        bugReport: "HlÃ¡Å¡enÃ­ chyb",
        canBrowseChangeLog: "UkÃ¡zat online changelog %{name}",
        collect: "PÅevzÃ­t",
        collectLogFiles: "PÅevzÃ­t logy",
        component: "Komponenta",
        content: "Obsah",
        contentSize: "Velikost obsahu",
        download: "StÃ¡hnout",
        downloadLogFiles: "StÃ¡hnout logy",
        downloadingData: "Data se stahujÃ­",
        everyHours: "KaÅ¾dÃ© %{interval} hodiny",
        forceInstall: "Vynutit aktualizaci",
        installDuringNight: "PÅes noc (%{start} - %{end}) kaÅ¾dou %{interval} hodinu",
        newVersion: "NovÃ¡ verze",
        notConnected: "Helper nenÃ­ pÅipojen",
        openBugReport: "Odeslat zprÃ¡vu o chybÄ",
        packageSize: "Velikost balenÃ­",
        pleaseWait: "PoÄkejte prosÃ­m, mÅ¯Å¾e to chvÃ­li trvat.",
        send: "Odeslat",
        sendBugReportToCustomerService: "PoÅ¡lete zprÃ¡vu o chybÃ¡ch zÃ¡kaznickÃ©mu servisu",
        sendingReport: "PosÃ­lÃ¡ se",
        subject: "PÅedmÄt"
    },
    helperDialog: {
        1: "MÅ¯Å¾ete zkontrolovat aktualizace softwaru nebo databÃ¡ze.",
        2: "PokraÄovat ve stahovÃ¡nÃ­ aktualizaÄnÃ­ch balÃ­ÄkÅ¯?",
        3: "PokraÄovat v instalaci staÅ¾enÃ½ch aktualizaÄnÃ­ch balÃ­ÄkÅ¯?",
        10: "ProbÃ­hÃ¡ kontrola aktualizacÃ­ softwaru a databÃ¡ze, poÄkejte prosÃ­m ...",
        11: "K dispozici je aktualizace pro vÃ¡Å¡ poÄÃ­taÄ. Chcete ji stÃ¡hnout?",
        12: "Pro vÃ¡Å¡ poÄÃ­taÄ nejsou k dispozici Å¾Ã¡dnÃ© aktualizace.",
        14: "PÅi kontrole aktualizacÃ­ doÅ¡lo k chybÄ. %{0}",
        15: "Synchronizace zÃ³n databÃ¡zÃ­, poÄkejte prosÃ­m ...",
        20: "StahovÃ¡nÃ­ aktualizaÄnÃ­ho balÃ­Äku, poÄkejte prosÃ­m ...",
        21: "AktualizovanÃ½ balÃ­Äek, kterÃ½ byl staÅ¾en, se nynÃ­ ovÄÅuje, poÄkejte prosÃ­m ...",
        22: "StahovÃ¡nÃ­ aktualizaÄnÃ­ho balÃ­Äku selhalo, chcete to zkusit znovu?",
        23: "StahovÃ¡nÃ­ aktualizaÄnÃ­ho balÃ­Äku selhalo (soubor je poÅ¡kozen), chcete to zkusit znovu?",
        24: "PokraÄovat v instalaci aktualizace?",
        25: "Instalace automatickÃ© aktualizace zaÄne za %{0}",
        26: "K dispozici je aktualizace pro vÃ¡Å¡ poÄÃ­taÄ. Chcete ji stÃ¡hnout?",
        27: "PokraÄovat v instalaci aktualizace?",
        40: "ZastavenÃ­ aplikacÃ­ a sluÅ¾eb, Äekejte prosÃ­m...",
        41: "KopÃ­rovÃ¡nÃ­ novÃ½ch souborÅ¯, Äekejte prosÃ­m...",
        42: "SpouÅ¡tÄnÃ­ aplikacÃ­ a sluÅ¾eb, Äekejte prosÃ­m...",
        43: "ProbÃ­hÃ¡ aktualizace softwaru, poÄkejte prosÃ­m...",
        44: "VÃ¡Å¡ software byl ÃºspÄÅ¡nÄ aktualizovÃ¡n.",
        45: "Chcete zkusit instalaci znovu? Pokud se rozhodnete opakovat, ujistÄte se, Å¾e softwarovÃ© komponenty nejsou aktuÃ¡lnÄ pouÅ¾Ã­vÃ¡ny.",
        46: "RestartovÃ¡nÃ­ PC je nutnÃ© k ovlivnÄnÃ­ zmÄn, restartovÃ¡nÃ­ bude provedeno v %{0}",
        999: "DoÅ¡lo k vnitÅnÃ­ chybÄ: %{0}",
        automaticInstallation: "AutomatickÃ¡ instalace aktualizacÃ­",
        btnAbort: "PÅeruÅ¡it",
        btnCancel: "ZruÅ¡it",
        btnCheckUpdate: "Kontrola aktualizacÃ­",
        btnContinue: "PokraÄovat",
        btnDownloadUpdate: "StÃ¡hnout aktualizace",
        btnInstallUpdate: "Instalovat aktualizace",
        btnOk: "OK",
        btnRetry: "Opakovat",
        btnSkip: "PÅeskoÄit",
        checkingForUpdates: "Kontrola aktualizacÃ­",
        downloadingFailed: "StahovÃ¡nÃ­ se nezdaÅilo",
        downloadingPackage: "StahovÃ¡nÃ­ aktualizaÄnÃ­ho balÃ­Äku, poÄkejte prosÃ­m",
        finishingUpdate: "ProbÃ­hÃ¡ aktualizace",
        installingUpdate: "InstalovÃ¡nÃ­ aktualizace",
        internalError: "InternÃ­ chyba",
        rebootRequired: "VyÅ¾aduje se restart",
        startingComponents: "SpouÅ¡tÄnÃ­ softwarovÃ½ch komponent",
        stoppingComponents: "ZastavenÃ­ softwarovÃ½ch komponent",
        synchronizingDatabases: "Synchronizace databÃ¡zÃ­ zÃ³n",
        updateAvailable: "K dispozici aktualizace, vyberte ÄÃ¡sti, kterÃ© chcete aktualizovat",
        updateDownloaded: "Aktualizace byla staÅ¾ena",
        updateFailed: "Proces aktualizace selhal",
        updateInstalled: "Aktualizace byla nainstalovÃ¡na",
        verificationFailed: "OvÄÅenÃ­ balÃ­Äku aktualizace se nezdaÅilo",
        verifyingPackage: "OvÄÅenÃ­ balÃ­Äku aktualizace se nezdaÅilo",
        yourSoftwareIsUpToDate: "VÃ¡Å¡ software je aktuÃ¡lnÃ­",
        yourSoftwareVersion: "Verze software: %{0}"
    },
    importData: {
        abortImportingData: "PÅeruÅ¡it import",
        aborted: "Import byl pÅeÅuÅ¡en.",
        backupLocalDB: "ZÃ¡lohovat lokÃ¡lnÃ­ databÃ¡zi",
        confirmRestore: "Opravdu chete obnovit veÅ¡kerÃ¡ lokÃ¡lnÃ­ nastavenÃ­?",
        dataMissing: "Import selhal, protoÅ¾e zdrojovÃ½ soubor neobsahoval Å¾Ã¡dnÃ¡ data.",
        deleteImportedData: "Smazat importovanÃ¡ data",
        encodingFile: "KÃ³dovÃ¡nÃ­ souboru",
        exportLocalSettings: "Exportovat lokÃ¡lnÃ­ nastavenÃ­",
        exportStaticSql: "Exportovat Static SQL",
        fileDamaged: "Import selhal, protoÅ¾e zdrojovÃ½ soubor je poÅ¡kozen.",
        fileMissing: "Import selhal, protoÅ¾e zdrojovÃ½ soubor neexistuje.",
        format: "FormÃ¡t",
        formatPath: "FormÃ¡tovat data",
        headerMissing: "Import selhal, protoÅ¾e chybÃ­ hlaviÄka souboru.",
        import: "Import",
        importAborted: "Import byl pÅeruÅ¡en",
        importAborting: "Import se pÅeruÅ¡uje",
        importFailed: "Import selhal z dÅ¯vodu neoÄekÃ¡vÃ¡nÃ© chyby.",
        importLocalSettings: "Importovat lokÃ¡lnÃ­ nastavenÃ­",
        importPrices: "Importovat ceny",
        imported: "ÃspÄÅ¡nÄ importovÃ¡no",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "ProbÃ­hÃ¡ import",
        noFormatAvailable: "NenÃ­ k dispozici Å¾Ã¡dnÃ½ formÃ¡t",
        processing: "ZpracovÃ¡vÃ¡ se",
        processingCustomFormulas: "ZpracovÃ¡nÃ­ vlastnÃ­ch vzorkovnic",
        processingCustomers: "ZpracovÃ¡vÃ¡nÃ­ zÃ¡kaznÃ­kÅ¯",
        productsFile: "Soubor produktÅ¯",
        restoreLocalSettings: "Obnovit lokÃ¡lnÃ­ nastavenÃ­",
        underProgress: "Import probÃ­hÃ¡.",
        unknownFormat: "Import selhal, protoÅ¾e zdojovÃ½ soubor mÃ¡ neplatnÃ½ formÃ¡t.",
        userFormulasFile: "Soubor uÅ¾ivatelskÃ½ch vzorkovnic"
    },
    infoType: {
        baseDensity: "Hustota bÃ¡ze",
        baseMass: "Hmotnost bÃ¡ze",
        baseUfiCode: "UFI kÃ³d bÃ¡ze",
        baseVolume: "Objem bÃ¡ze",
        batchNumbersTable: "Tabulka ÄÃ­sel Å¡arÅ¾Ã­",
        bfsGrade: "Hodnota BFS",
        colorLab: "Lab odstÃ­nu",
        colorRgb: "RGB odstÃ­nu",
        colorRgbHex: "RGB Hex odstÃ­nu",
        colorXyz: "Xyz odstÃ­nu",
        colorantBatchNumbers: "ÄÃ­slo Å¡arÅ¾e pigmentÅ¯",
        colorantMass: "Hmotnost kolorantu",
        colorantUfiCodes: "UFI kÃ³dy kolorantu",
        colorantVolume: "Objem kolorantu",
        formulaDate: "Datum receptury",
        formulaDatetime: "Datum a Äas receptury",
        formulaMoreInfo: "VÃ­ce informacÃ­ k receptuÅe",
        formulaMoreInfoInternal: "VÃ­ce internÃ­ch informacÃ­ k receptuÅe",
        formulaMoreInfoPrint: "VÃ­ce informacÃ­ k tisku receptury",
        hbw: "Hodnota HBW",
        isPackageGravimetric: "Je balenÃ­ gravimetrickÃ©",
        maxColorantMass: "MaximÃ¡lnÃ­ povolenÃ¡ hmotnost kolorantÅ¯",
        maxColorantVolume: "MaximÃ¡lnÃ­ povolenÃ½ objem kolorantÅ¯",
        nominalMass: "NominÃ¡lnÃ­ hmotnost balenÃ­",
        nominalVolume: "NominÃ¡lnÃ­ objem balenÃ­",
        overfillDetected: "SpozorovÃ¡no pÅeplnÄnÃ­",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "CelkovÃ¡ hmotnost barvy",
        totalPaintVolume: "CelkovÃ½ objem barvy",
        ufiCodesTable: "Tabulka UFI kÃ³dÅ¯",
        verifiedFormula: "OvÄÅenÃ¡ receptura",
        yValue: "Hodnota Y"
    },
    initialTab: {
        favoriteFormulas: "OblÃ­benÃ© receptury",
        lastDispensedFormulas: "PoslednÃ­ tÃ³novanÃ© receptury",
        searchNewFormula: "Hledat novou recepturu"
    },
    invalidBatchNumbersModal: {
        header: "Zkontrolujte ÄÃ­slo Å¡arÅ¾e pigmentÅ¯",
        info: "AlespoÅ jeden kanystr je naplnÄnÃ½ vadnou Å¡arÅ¾Ã­ kolorantÅ¯",
        unknownStatus: "NeznÃ¡mÃ½ status Å¡arÅ¾e"
    },
    keyWords: {
        action: "akce",
        add: "pÅidat",
        addition: "pÅidÃ¡nÃ­",
        additional: " doplÅkovÃ½",
        address: "adresa",
        admin: "admin",
        advanced: "PokroÄilÃ©",
        after: "po",
        afterDispensing: "po tÃ³novÃ¡nÃ­",
        alfa: "Alfa",
        all: "vÅ¡e",
        allow: "povolit",
        alphabetically: "abecednÄ",
        amount: "mnoÅ¾stvÃ­",
        api: "api",
        ask: "Zeptat se",
        autocap: "autocap",
        autotask: "AutomatickÃ½ Ãºkol",
        availablePrice: "dostupnÃ¡ cena",
        backup: "zÃ¡loha",
        banner: "banner",
        barcode: "ÄÃ¡rovÃ½ kÃ³d",
        barcodes: "ÄÃ¡rovÃ© kÃ³dy",
        base: "bÃ¡ze",
        before: "pÅed",
        begin: "zaÄÃ­t",
        bfs: "bfs",
        bottom: "spodnÃ­",
        brand: "znaÄka",
        brush: "Å¡tÄtec",
        bug: "chyba",
        button: "tlaÄÃ­tko",
        buy: "koupit",
        cC3: "CC3",
        cM: "CM",
        calibration: "kalibrace",
        can: "plechovka",
        canHandling: "prÃ¡ce s plechovkou",
        canister: "kanystr",
        canisterFilling: "doplnÄnÃ­ kanystr",
        canisterLevels: "hodnoty kanystru",
        canisters: "kanystry",
        cap: "cap",
        center: "stÅed",
        centre: "stÅed",
        change: "zmÄna",
        changelog: "changelog",
        channels: "kanÃ¡ly",
        check: "kontrola",
        chunk: "kus",
        chunks: "kusy",
        city: "mÄsto",
        clean: "ÄistÃ½",
        cleaning: "ÄistÄnÃ­",
        clientIdentifier: "ID klienta",
        close: "zavÅÃ­t",
        closest: "nejbliÅ¾Å¡Ã­",
        code: "kÃ³d",
        collect: "sesbÃ­rat",
        color: "barva",
        colorLink3: "ColorLink3",
        colorPanel: "barevnÃ­ paleta",
        colorReader: "ColorReader",
        colorant: "kolorant",
        colorantConsumption: "spotÅeba kolorantu",
        colorantPrice: "cena kolorantu",
        colorants: "koloranty",
        colorix: "Colorix",
        colour: "barva",
        communication: "komunikace",
        compare: "porovnat",
        competitive: "konkurenÄnÃ­",
        computer: "poÄÃ­taÄ",
        config: "nastavenÃ­",
        configuration: "konfigurace",
        confirm: "potvrdit",
        confirmation: "potvrzenÃ­",
        connection: "spojenÃ­",
        contactPerson: "kontaktnÃ­ osoba",
        control: "ovlÃ¡dÃ¡nÃ­",
        copies: "kopie",
        corob: "Corob",
        cost: "cena",
        country: "zemÄ",
        create: "vytvoÅit",
        currency: "mÄna",
        current: "stÃ¡vajÃ­cÃ­",
        custom: "vlastnÃ­",
        customers: "zÃ¡kaznÃ­ci",
        daily: "dennÃ­",
        dark: "Dark",
        data: "data",
        database: "databÃ¡ze",
        datacolor: "Datacolor",
        date: "datum",
        decimals: "decimÃ¡lnÃ­",
        default: "vÃ½chozÃ­",
        delay: "zpoÅ¾dÄnÃ­",
        delete: "smazat",
        deletion: "smazÃ¡nÃ­",
        deltaE: "delta e",
        device: "zaÅÃ­zenÃ­",
        devices: "zaÅÃ­zenÃ­",
        diagnosticTile: "diagnostickÃ¡ doÅ¡tiÄka",
        dialog: "dialog",
        direct: "pÅÃ­mÃ½",
        disconnect: "odpojit",
        discount: "sleva",
        dispense: "tÃ³novat",
        dispenser: "tonovacÃ­ stroj",
        dispensing: "tÃ³novÃ¡nÃ­",
        down: "dole",
        download: "stÃ¡hnout",
        driver: "ovladaÄ",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "upravit",
        editor: "editor",
        email: "email",
        error: "chyba",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "expirace",
        export: "export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "vzorkovnice",
        fastFluid: "Fast & Fluid",
        file: "soubor",
        fill: "doplnit",
        fillToMax: "doplnit do maxima",
        find: "hledat",
        first: "prvnÃ­",
        flex: "Flex",
        folder: "adresÃ¡Å",
        formula: "receptura",
        formulas: "receptury",
        from: "z",
        fts5: "fts5",
        fullScreen: "celÃ¡ obrazovka",
        fullText: "full-text",
        fulltext: "plnotextovÃ©",
        g: "g",
        genericPricing: "obecnÃ© ceny",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "pomoc",
        helpCenter: "centrum pomoci",
        hero: "Hero",
        history: "historie",
        home: "domÅ¯",
        host: "host",
        humidifier: "zvlhÄovaÄ",
        iDD: "IDD",
        identification: "identifikace",
        image: "obrÃ¡zek",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "import",
        individually: "individuÃ¡lnÄ",
        info: "info",
        information: "informace",
        initial: "prÅ¯vodnÃ­",
        initialization: "inicializace",
        initialize: "inicializovat",
        insert: "vloÅ¾it",
        install: "nainstalovat",
        intellyPurge: "inteligentnÃ­ odstÅik",
        invalid: "neplatnÃ½",
        ipAddress: "ip adresa",
        italtinto: "Italtinto",
        items: "poloÅ¾ky",
        keyboard: "klÃ¡vesnice",
        kg: "kg",
        kiosk: "kiosek",
        kioskMode: "kioskovÃ½ mÃ³d",
        l: "l",
        lLD: "LLD",
        lab: "laboratoÅ",
        label: "popisek",
        labels: "popisky",
        language: "jazyk",
        largo: "largo",
        last: "poslednÃ­",
        lenteq: "Lenteq",
        levels: "ÃºrovnÄ",
        license: "licence",
        light: "Light",
        limit: "limit",
        link: "propojenÃ­",
        linux: "Linux",
        load: "naÄtenÃ­",
        lock: "zÃ¡mek",
        logFiles: "soubory log",
        logic: "logika",
        logo: "logo",
        lower: "niÅ¾Å¡Ã­",
        machine: "stroj",
        machineConfiguration: "konfigurace stroje",
        machineManagement: "management stroje",
        machineName: "jmÃ©no stroje",
        main: "hlavnÃ­",
        maintenance: "ÃºdrÅ¾ba",
        manual: "manuÃ¡lnÃ­",
        manualAddition: "ruÄnÃ­ doplnÄnÃ­",
        manualDispensing: "ruÄnÃ­ tÃ³novÃ¡nÃ­",
        manualScan: "ruÄnÃ­ skenovÃ¡nÃ­",
        margins: "okraje",
        markups: "oznaÄenÃ­",
        mass: "hmotnost",
        match: "shoda",
        measure: "zmÄÅit",
        measurement: "mÄÅenÃ­",
        measurementUnits: "mÄrnÃ© jednotky",
        melody: "melodie",
        message: "zprÃ¡va",
        minimal: "minimÃ¡lnÃ­",
        minolta: "Minolta",
        minus: "mÃ­nus",
        minutes: "minuty",
        misura: "Misura",
        ml: "ml",
        mode: "mÃ³d",
        model: "model",
        modification: "modifikace",
        modify: "zmÄnit",
        monthly: "mÄsÃ­ÄnÄ",
        moreInfo: "vÃ­ce informacÃ­",
        movableTable: "posuvnÃ½ stÅ¯l",
        move: "posunout",
        music: "hudba",
        myOrders: "mÃ© objednÃ¡vky",
        name: "jmÃ©no",
        naming: "pojmenovÃ¡nÃ­",
        nano: "Nano",
        navigation: "navigace",
        new: "novÃ½",
        nextDriver: "NextDriver",
        night: "noc",
        nixPro: "Nix Pro",
        notes: "poznÃ¡mka",
        notification: "notifikace",
        number: "ÄÃ­slo",
        off: "vypnuto",
        open: "otevÅeno",
        order: "objednÃ¡vka",
        ordering: "objednÃ¡vÃ¡nÃ­",
        overfill: "pÅeplnÄnÃ­",
        overview: "pÅehled",
        overwrite: "pÅepsat",
        own: "vlastnÃ­",
        pCPDriver: "PCPDriver",
        package: "balenÃ­",
        packagePrice: "cena balenÃ­",
        packages: "balenÃ­",
        panels: "panely",
        parameter: "parametry",
        path: "cesta",
        pc: "PC",
        phone: "telefon",
        phoneNumber: "telefonnÃ­ ÄÃ­slo",
        picture: "obrÃ¡zek",
        place: "mÃ­sto",
        placement: "umÃ­stÄnÃ­",
        plug: "zÃ¡tka",
        plugger: "zÃ¡tkovaÄ",
        plugging: "uzavÅenÃ­",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "prodejnÃ­ mÃ­sto",
        popUp: "vyskakovacÃ­",
        pos: "ProdejnÃ­ mÃ­sto",
        present: "souÄasnÃ½",
        preview: "nÃ¡hled",
        price: "cena",
        priceExport: "export cen",
        priceGroup: "skupina cen",
        priceImport: "import cen",
        prices: "ceny",
        pricing: "nacenÄnÃ­",
        primaryCurrency: "primÃ¡rnÃ­ mÄna",
        print: "tisk",
        printer: "tiskÃ¡rna",
        printing: "tisk",
        problem: "problÃ©m",
        product: "produkt",
        productPrice: "cena produktu",
        profiledValues: "profilovÃ© hodnoty",
        punch: "vÃ½raz",
        puncher: "vyrÃ¡Å¾eÄ",
        punching: "Vyrazit ",
        purge: "odstÅik",
        purgeType: "typ odstÅiku",
        purgeVolume: "mnoÅ¾stvÃ­ odstÅiku",
        quality: "kvalita",
        quick: "rychlÃ½",
        quickTint: "rychlÃ© tÃ³novÃ¡nÃ­",
        rM: "RM",
        raise: "zdvihnout",
        rcc: "rcc",
        reader: "ÄteÄka",
        reboot: "restartovat",
        receive: "pÅijmout",
        recirculate: "recirkulovat",
        recirculation: "recirkulace",
        redlike: "Redlike",
        refill: "doplnit",
        registration: "registrace",
        regular: "pravidelnÃ½",
        removal: "ostranÄnÃ­",
        remove: "ostranit",
        report: "nahlÃ¡sit",
        reset: "resetovat",
        resolution: "ÅeÅ¡enÃ­",
        restart: "restartovat",
        rgb: "rgb",
        rights: "prÃ¡va",
        rounding: "zaokrouhlenÃ­",
        rules: "pravidla",
        sanTint: "SanTint",
        save: "uloÅ¾it",
        scale: "mÄÅÃ­tko",
        scan: "skenovat",
        scope: "rozsah",
        screen: "obrazovka",
        screensaver: "spoÅiÄ obrazovky",
        search: "hledat",
        secondaryCurrency: "sekundÃ¡rnÃ­ mÄna",
        select: "vybrat",
        selectedFormula: "VybranÃ¡ receptura",
        sell: "prodat",
        sensor: "sensor",
        serialNumber: "sÃ©riovÃ© ÄÃ­slo",
        server: "server",
        servers: "servery",
        service: "sluÅ¾ba",
        serviceAction: "servisnÃ­ akce",
        serviceActions: "servisnÃ­ akce",
        serviceSoftware: "servisnÃ­ software",
        serviceWindow: "servisnÃ­ okno",
        settings: "nastavenÃ­",
        shelf: "stÅ¯l",
        shortcuts: "zkratky",
        shot: "shot",
        show: "zobrazit",
        shutDown: "vypnout",
        shutdown: "vypnout",
        silent: "Silent",
        simple: "jednoduchÃ½",
        simulation: "simulace",
        size: "velikost",
        skip: "pÅeskoÄit",
        smartPurge: "chytrÃ½ odstÅik",
        software: "software",
        softwareSupplier: "dodavatel softwaru",
        sort: "seÅadit",
        sound: "zvuk",
        spectro: "spektrometr",
        spectrophotometer: "spectrofotometr",
        speed: "rychlost",
        split: "rozdÄlit",
        start: "start",
        startup: "po startu",
        statistics: "statistiky",
        status: "stav",
        stir: "promÃ­chat",
        stirring: "mÃ­chÃ¡nÃ­",
        street: "ulice",
        support: "podpora",
        surcharge: "pÅÃ­platek",
        tab: "panel",
        tabs: "panely",
        task: "Ãºkoly",
        template: "Å¡ablona",
        testing: "testovÃ¡nÃ­",
        time: "Äas",
        tintingManagementCenter: "tinting management center",
        to: "k",
        toDispense: "k tÃ³novÃ¡nÃ­",
        tolerance: "tolerance",
        top: "nejvyÅ¡Å¡Ã­",
        total: "celek",
        translation: "pÅeklad",
        turnOff: "vypnout",
        turntable: "stÅ¯l",
        type: "typ",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "jednotka",
        up: "nahoru",
        update: "aktualizace",
        url: "url",
        user: "uÅ¾ivatel",
        userGroups: "uÅ¾ivatelskÃ© skupiny",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "DaÅ",
        validate: "validovat",
        validation: "validace",
        version: "verze",
        virtual: "virtuÃ¡lnÃ­",
        volume: "objem",
        weekly: "tÃ½dnÄ",
        window: "okno",
        windows: "Windows",
        with: "s",
        without: "bez",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y hodnota",
        zipCode: "PSÄ",
        zoom: "pÅiblÃ­Å¾enÃ­"
    },
    languages: {
        bg: "BulharÅ¡tina",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "NÄmÄina",
        el: "ÅeÄtina",
        en: "AngliÄtina",
        es: "Å panÄlÅ¡tina",
        fr: "FrancouzÅ¡tina",
        hr: "ChorvatÅ¡tina",
        hu: "MaÄarÅ¡tina",
        id: "IndonÃ©Å¡tina",
        is: "ÃslandÅ¡tina",
        it: "ItalÅ¡tina",
        lt: "LitevÅ¡tina",
        lv: "LotyÅ¡tina",
        ms: "MalajÅ¡tina",
        nl: "NizozemÅ¡tina",
        no: "NorÅ¡tina",
        pl: "PolÅ¡tina",
        pt: "PortugalÅ¡tina",
        ro: "RumunÅ¡tina",
        ru: "RuÅ¡tina",
        sk: "SlovenÅ¡tina",
        sr: "SrbÅ¡tina",
        sv: "Å vÃ©dÅ¡tina",
        zh: "ÄÃ­nÅ¡tina"
    },
    license: {
        activateLicense: "Aktivovat licenci",
        activateNewLicense: "Aktivujte novou licenci",
        checkLicenseKey: "Zkontrolovat licenÄnÃ­ klÃ­Ä",
        companyId: "ID spoleÄnosti",
        contactPerson: "KontaktnÃ­ osoba",
        copy: "KopÃ­rovat",
        country: "ZemÄ",
        emptyCity: "MÄsto je povinnÃ½ Ãºdaj",
        emptyCountry: "ZemÄ je povinnÃ½ Ãºdaj",
        emptyName: "NÃ¡zev prodejny je povinnÃ½ Ãºdaj",
        enterIdentificationKeys: "Zadejte svÃ© identifikaÄnÃ­ klÃ­Äe",
        expirationDate: "Datum expirace %{dateTime}",
        fillRegistration: "Zadejte registraÄnÃ­ Ãºdaje",
        insertLicense: "Pro offline aktivaci zadejte vygenerovanÃ½ klÃ­Ä",
        invalidEmail: "Email nenÃ­ sprÃ¡vnÄ zadÃ¡n",
        invalidPhone: "Telefon nenÃ­ sprÃ¡vnÄ zadÃ¡n",
        itemsMarkedasterisk: "(poloÅ¾ky oznaÄenÃ© hvÄzdiÄkou musÃ­ bÃ½t vyplnÄny)",
        lastUpdate: "PoslednÃ­ zmÄna %{dateTime}",
        leasedLicense: "PronajatÃ¡ licence",
        licenseActivated: "Licence je jiÅ¾ aktivnÃ­.",
        licenseStatus: "Stav licence",
        licenseWillExpire: "Platnost vaÅ¡Ã­ licence vyprÅ¡Ã­ za %{dayCount} dnÃ­",
        licenseWillExpireOneDay: "VaÅ¡e licence vyprÅ¡Ã­ za %{dayCount} dnÅ¯.",
        machineInformation: "Informace o stroji",
        noLicenseAvailable: "NenÃ­ k dispozici Å¾Ã¡dnÃ¡ licence",
        noProductsForKey: "Pro uvedenÃ© identifikaÄnÃ­ klÃ­Äe nejsou k dispozici Å¾Ã¡dnÃ© produkty.",
        pointOfSale: "Prodejna",
        producer: "VÃ½robce",
        reactivate: "Aktivovat znovu",
        reactivateLicense: "Reactivate license",
        region: "Oblast",
        registerLicense: "OkopÃ­rujte si prosÃ­m aktivaÄnÃ­ poÅ¾adavek a pÅesuÅte se na nÃ¡sledujÃ­cÃ­ odkaz:",
        registrationForm: "RegistraÄnÃ­ formulÃ¡Å",
        selectProduct: "Vyberte produkt",
        serialNumber: "SÃ©riovÃ© ÄÃ­slo",
        skipNewLicense: "Pokud chcete licenci aktivovat pozdÄji, kliknÄte na tlaÄÃ­tko pÅeskoÄit.",
        unlimitedLicense: "NeomezenÃ¡ licence",
        userId: "ID uÅ¾ivatele",
        uuid: "UUID licence",
        versionDetails: "Podrobnosti o verzi",
        versionScope: "Rozsah verze",
        versionType: "Typ verze",
        zip: "PSÄ"
    },
    login: {
        authenticate: "Autentizace",
        logIn: "PÅihlÃ¡sit se",
        loginAs: "PÅihlÃ¡sit se jako jinÃ½ uÅ¾ivatel",
        messages: {
            incorrectUsername: "UÅ¾ivatelskÃ© jmÃ©no nebo heslo je nesprÃ¡vnÃ©."
        },
        password: "Heslo",
        username: "UÅ¾ivatelskÃ© jmÃ©no"
    },
    machineActionHistory: {
        actionHistory: "Historie akcÃ­"
    },
    machineErrors: {
        channel: "Okruh",
        code: "KÃ³d",
        machineErrors: "Chyby stroje",
        noMachineErrors: "Nebyly nalezeny Å¾Ã¡dnÃ© chyby stroje",
        resetErrors: "Reset chyb"
    },
    machineSettings: {
        action: "Ãlohy",
        addAutotask: "PÅidat automatickou Ãºlohu",
        autoCanisterIn: "AutomatickÃ½ zÃ¡sobnÃ­k v",
        autoCanisterOut: "AutomatickÃ½ zÃ¡sobnÃ­k venku",
        automaticRefill: "AutomatickÃ© doplÅovÃ¡nÃ­",
        autotaskSettings: "NastavenÃ­ automatickÃ½ch Ãºloh",
        backupConfiguration: "ZÃ¡loha nastavenÃ­ tÃ³novacÃ­ho stroje",
        brushMaintenance: "ÃdrÅ¾ba Å¡tÄtcÅ¯",
        capMaintenance: "ÃdrÅ¾ba vÃ­Äka",
        checkCanisterBeforeDispense: "Zkontrolovat kanystr pÅed tÃ³novÃ¡nÃ­m",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Zkontrolovat minimÃ¡lnÃ­ moÅ¾nÃ© mnoÅ¾stvÃ­ kolorantu k tÃ³novÃ¡nÃ­",
        checkOverfill: "Zkontrolovat pÅeplnÄnÃ­ plechovky",
        checkTotalCntAmounts: "Zkontrolovat celkovÃ© mnoÅ¾stvÃ­ kolorantu v bÃ¡zi",
        cleanAll: "VyÄistit vÅ¡echny",
        computerReboot: "Restart poÄÃ­taÄe",
        computerShutdown: "VypnutÃ­ poÄÃ­taÄe",
        connectMachine: "PÅipojit stroj",
        days: "DnÅ¯",
        daysOfMonth: "Dny v mÄsÃ­ci",
        devices: "ZaÅÃ­zenÃ­",
        disabled: "ZakÃ¡zÃ¡no",
        dispenseAndPurge: "TÃ³novÃ¡nÃ­ a odstÅik",
        dispenseOnly: "Pouze tÃ³novÃ¡nÃ­",
        dispenserCleaning: "ÄiÅ¡tÄnÃ­ tÃ³novacÃ­ho stroje",
        dispensingWithErrorsEnabled: "Povolit tÃ³novÃ¡nÃ­ i pÅes chybu validace",
        editAutotask: "Upravit automatickou Ãºlohu",
        firstRun: "PrvnÃ­ bÄh",
        hours: "Hodin",
        humidifier: "ZvlhÄovaÄ",
        humidifierWaterLevelMaintenance: "ÃdrÅ¾ba ÃºrovnÄ vody zvlhÄovaÄe",
        machineConfigurationNoCanisters: "NastavenÃ­ stroje neobsahuje Å¾Ã¡dnÃ© kanystri.",
        machineName: "NÃ¡zev stroje",
        machineSettings: "NastavenÃ­ stroje",
        manualPuncher: "RuÄnÃ­ puncher",
        minDispensedAmount: "MinimÃ¡lnÃ­ vydanÃ© mnoÅ¾stvÃ­",
        minutes: "Minut",
        nextRun: "NÃ¡sledujÃ­cÃ­ spuÅ¡tÄnÃ­",
        noAutotasksSet: "Nejsou nastaveny Å¾Ã¡dnÃ© automatickÃ© Ãºlohy",
        noDataAvailable: "Å½Ã¡dnÃ¡ dostupnÃ¡ data",
        noMachine: "NenÃ­ pÅipojen Å¾Ã¡dnÃ½ stroj",
        onStart: "PÅi startu",
        plugger: "plugger",
        postpone: "OdloÅ¾it",
        puncher: "VyrÃ¡Å¾eÄ",
        purgeAll: "OdstÅiky vÅ¡ech",
        purgeOnly: "Pouze odstÅik",
        recirculateAll: "Recirkulovat vÅ¡echny",
        recirculateChannels: "Recirkulovat okruhy",
        recirculationSpeed: "Rychlost recirkulace",
        recirculationTime: "Doba recirkulace",
        refillAll: "Doplnit vÅ¡echny",
        refillCanisters: "Doplnit kanystry",
        runAt: "Spustit o",
        runDefinedDaysAt: "DefinovanÃ© dny",
        runEvery: "Spustit kaÅ¾dÃ½ch",
        runInDays: "Spustit ve dny",
        serialNum: "SÃ©riovÃ© ÄÃ­slo",
        settingsMachine: "NastavenÃ­ stroje",
        smartPurgeAll: "ChytrÃ© odstÅiky pro vÅ¡echny",
        smartPurgeChannels: "ChytrÃ© odstÅiky pro okruhy",
        smartPurgeRules: "Pravidla chytrÃ½ch odstÅikÅ¯",
        startType: "Typ spuÅ¡tÄnÃ­",
        stirAll: "PromÃ­chat vÅ¡echny",
        stirCanisters: "PromÃ­chat kanystry",
        stirringSpeed: "Rychlost promÃ­chÃ¡nÃ­",
        stirringTime: "Doba promÃ­chÃ¡nÃ­",
        switchPlateMaintenance: "ÃdrÅ¾ba desky",
        theCurrentlySelectedMachine: "AktuÃ¡lnÄ vybranÃ½ stroj",
        threshold: "PrÃ¡h",
        turntable: "PohyblivÃ½ stÅ¯l",
        unifyColorantBatchForMultipleCans: "SjednoÅ¥te Å¡arÅ¾i kolorantÅ¯ pro tÃ³novanÃ­ vÃ­ce plechovek",
        volume: "Objem",
        weekdays: "Dny v tÃ½dnu"
    },
    mainTab: {
        acceptedFormula: "PÅijatÃ¡ receptura",
        addBuildingSite: "PÅidat staveniÅ¡tÄ",
        addToFavorites: "PÅidat do oblÃ­benÃ½ch",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Specifikace staveniÅ¡tÄ",
        colorantsAreInvalid: "Jeden nebo vÃ­ce kolorantÅ¯ je nesprÃ¡vnÄ zadanÃ½",
        dispensedPackages: "VytÃ³novanÃ¡ balenÃ­",
        dispensingInProgress: "TÃ³novÃ¡nÃ­ prÃ¡vÄ probÃ­hÃ¡",
        dispensingIsAborted: "TÃ³novanÃ­ pÅeruÅ¡eno",
        dispensingIsNotAvailable: "TÃ³novÃ¡nÃ­ nenÃ­ dostupnÃ©",
        dispensingProgress: "%{done} z %{all}",
        editColorant: "Upravit kolorant",
        editNote: "Upravit poznÃ¡ku",
        findCompetitiveColor: "Zkusit vyhledat kompetetivnÃ­ barvu",
        forceDispensing: "VytÃ³novat na stroji",
        formulaInvalidColorants: "Receptura obsahuje neplatnÃ© koloranty: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "SkrytÃ© vÄjÃ­Åe",
        hiddenProducts: "SkrytÃ© produkty",
        historicalFormulas: "Historie receptur",
        lowerDeltaNumber: "ZvÃ½Å¡enÃ­ shody snÃ­Å¾enÃ­m ÄÃ­sla delta",
        machineError: "Chyba na stroji",
        machineIsBusy: "Stroj je zaneprÃ¡zdnÄnÃ½",
        machineNotConnected: "Stroj nenÃ­ pÅipojen",
        manualColorantAddition: "RuÄnÃ­ pÅidÃ¡nÃ­ pigmentu",
        modifiedFormula: "Receptura byla upravena",
        modifiedFormulaInLab: "Receptura byla upravena v laboratoÅi",
        newColorAfterScaling: "NovÃ¡ barva po vÃ¡Å¾enÃ­",
        newRgbNotAccuratelyMeasured: "NovÃ© RGB nenÃ­ zmÄÅeno pÅesnÄ, je pouze orientaÄnÃ­",
        noBaseAvailable: "NenÃ­ k dispozici Å¾Ã¡dnÃ¡ bÃ¡ze",
        noBuildingSiteAvailable: "Nejsou k dispozici Å¾Ã¡dnÃ© informace o stanoviÅ¡ti",
        noColorantForCorrection: "Nebyla vybrÃ¡na Å¾Ã¡dnÃ© dalÅ¡Ã­ koloranty pro korekci",
        noColorants: "Å½Ã¡dnÃ© koloranty",
        noCustomer: "Å½Ã¡dnÃ½ zÃ¡kaznÃ­k",
        noCustomers: "NenÃ­ dostupnÃ½ Å¾Ã¡dnÃ½ zÃ¡kaznÃ­k",
        noDispenseNotesAvailable: "Nejsou k dispozici Å¾Ã¡dnÃ© poznÃ¡mky k tÃ³novanÃ¡nÃ­",
        noFormulaAvailable: "MÃ¡te vybranou kombinaci bez receptury.",
        noFormulaSelected: "NenÃ­ vybrÃ¡na Å¾Ã¡dnÃ¡ receptura",
        noInternalNotesAvailable: "Å½Ã¡dnÃ© internÃ­ poznÃ¡mky nejsou dostupnÃ©",
        noNotesAvailable: "Nejsou k dispozici Å¾Ã¡dnÃ© poznÃ¡mky",
        noPackageAvailable: "NenÃ­ k dispozici Å¾Ã¡dnÃ© balenÃ­",
        noPackageSelected: "NenÃ­ vybrÃ¡no Å¾Ã¡dnÃ© balenÃ­",
        noProductAvailable: "NenÃ­ k dispozici Å¾Ã¡dnÃ½ produkt",
        noResultsFound: "Nebyly nalezeny Å¾Ã¡dnÃ© vÃ½sledky",
        openLocalFile: "OtevÅÃ­t z lokÃ¡lnÃ­ databÃ¡ze",
        openOnlineFile: "OtevÅÃ­t z internetu",
        order: "ObjednÃ¡vka",
        orderingIsNotAvailable: "ZaklÃ¡dÃ¡nÃ­ objednÃ¡vek nenÃ­ povoleno",
        originalColor: "PÅ¯vodnÃ­ barva",
        overAvailableLevel: "PÅes dostupnou ÃºroveÅ",
        package: "BalenÃ­",
        packageIsRequired: "BalenÃ­ je poÅ¾adovÃ¡no",
        packaging: "BalenÃ­",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Tisk nenÃ­ k dispozici",
        productFiles: "ProduktovÃ© soubory",
        productFilesViewer: "ProhlÃ­Å¾eÄ souborÅ¯ produktu",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "BÄÅ¾nÃ¡ cena",
        resetFormulaData: "NovÃ¡ receptura",
        rgbOnlyIndicative: "RGB pouze orientaÄnÃ­!",
        saveAsCustom: "UloÅ¾it jako",
        saveToStatsIsNotAvailable: "NenÃ­ moÅ¾nÃ© uloÅ¾it do historie",
        searchForCheaper: "VyhledÃ¡vat levnÄjÅ¡Ã­",
        selectFromCompetitive: "MÅ¯Å¾ete vybrat barvu z kompetetivnÃ­ch barev.",
        specialPrice: "SpeciÃ¡lnÃ­ cena",
        specialPriceVip: "SpeciÃ¡lnÃ­ cena VIP",
        splitFormula: "RozdÄlit recepturu",
        withVAT: "s DPH",
        withoutVAT: "bez DPH"
    },
    marginSettings: {
        allBases: "VÅ¡echny bÃ¡ze",
        allProducts: "VÅ¡echny produkty",
        editMargin: "Upravit marÅ¾i",
        marginAndDiscountWarning: "Pro pouÅ¾itÃ­ marÅ¾Ã­ a slev musÃ­te zvolit moÅ¾nost nastavenÃ­ vÃ½poÄtu ceny.",
        marginSettings: "NastavenÃ­ marÅ¾e",
        marginsFor: "MarÅ¾e pro",
        markupColorants: "ObchodnÃ­ pÅirÃ¡Å¾ka pro kolorant",
        sizeOfPackage: "Velikost balenÃ­",
        valueBase: "Hodnota bÃ¡ze",
        valueColorant: "Hodnota kolorantu"
    },
    matching: {
        actualColor: "AktuÃ¡lnÃ­ odstÃ­n",
        allCorrections: "VÅ¡echny korekce",
        allTillItems: "VÅ¡echny zÃ¡znamy po zvolenÃ½ zÃ¡znam",
        auto: "Automaticky",
        autoSelectAll: "Automaticky vÅ¡e",
        canStartCorrection: "PotÃ© mÅ¯Å¾ete spustit korekcÃ­.",
        canStartMatching: "PotÃ© mÅ¯Å¾ete spustit matching.",
        cannotBeUsed: "Matching nelze pouÅ¾Ã­t.",
        changeProductAndColorants: "Zkuste zmÄnit produkt nebo koloranty",
        checkConfig: "Zkontrolujte prosÃ­m konfiguraci matchingu.",
        colorCorrection: "Korekce odstÃ­nu",
        colorIsIndicative: "NÃ¡hled odstÃ­nu je pouze orientaÄnÃ­.",
        colorNotAccurate: "OdstÃ­n nemusÃ­ bÃ½t zobrazena pÅesnÄ, vÅ¾dy zÃ¡leÅ¾Ã­ na nastavenÃ­ vaÅ¡eho monitoru.",
        colorantInDispensedFormula: "Koloranty v tÃ³novanÃ© receptuÅe",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "ProblÃ©m s pÅipojenÃ­m",
        correctionHistory: "Historie korekcÃ­",
        correctionRunning: "ProbÃ­hÃ¡ korekce",
        draftFormula: "Draft formula",
        exclude: "VylouÄit",
        excludeAll: "VylouÄit vÅ¡echny",
        include: "Zahrnout",
        includeAll: "Zahrnout vÅ¡echny",
        invalidProduct: "NenÃ­ moÅ¾nÃ© provÃ©st matching pro produkt %{productName}",
        itemOnly: "Pouze zÃ¡znam",
        manualColorCorrection: "ManuÃ¡lnÃ­ korekce odstÃ­nu",
        matchFormula: "Receptura z matchingu",
        matchingInformation: "Matching information",
        matchingResult: "VÃ½sledek matchingu",
        matchingRunning: "ProbÃ­hÃ¡ matching",
        matchingSearchOptions: "MoÅ¾nosti hledÃ¡nÃ­ matchingu",
        measurement: "MÄÅenÃ­",
        noCorrection: "Nebyla nalezena Å¾Ã¡dnÃ¡ korekce",
        noSpectralCurveProvided: "PÅipojenÃ© zaÅÃ­zenÃ­ nelze pouÅ¾Ã­t pro matching, protoÅ¾e neposkytuje spektrÃ¡lnÃ­ kÅivku",
        notAvailableForMatching: "NenÃ­ k dispozici pro matching",
        originalFormula: "PÅ¯vodnÃ­ receptura",
        reformulate: "Reformulovat",
        reformulationRunning: "ProbÃ­hÃ¡ reformulace",
        resultColor: "VÃ½slednÃ½ odstÃ­n",
        saveAsCustomFormula: "UloÅ¾it ako vlastnÃ­ recepturu",
        searchInProgress: "ProbÃ­hÃ¡ vyhledÃ¡vÃ¡nÃ­, Äekejte prosÃ­m",
        selectColorfile: "ProsÃ­m vyberte colorfile.",
        selectRequiredItems: "ProsÃ­m vyberte produkt, bÃ¡zi, koloranty a balenÃ­.",
        selectedResult: "VybranÃ½ vÃ½sledek",
        spectralDataNotAvailable: "SpektrÃ¡lnÃ­ data nejsou k dispozici",
        startCorrection: "Spustit korekci",
        startMatching: "Spustit matching",
        targetColor: "CÃ­lovÃ½ odstÃ­n",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "PouÅ¾Ã­vÃ¡ se pro matching"
    },
    modal: {
        changeColorantUnit: "ZmÄnit jednotku kolorantu",
        payAttention: "Pozor!"
    },
    module: {
        productGroups: "ProduktovÃ© skupiny"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Filtr vzorkovnic",
            formulasOverLimit: "Okolo %{count} vÃ½sledkÅ¯. ProsÃ­m zadejte vÃ­ce znakÅ¯.",
            foundFormulas: "%{count} nalezenÃ½ch receptur",
            help: "NÃ¡povÄda:",
            helpText:
                "Zadejte napÅÃ­klad '%{filter}' k nalezenÃ­ receptury zaÄÃ­najÃ­cÃ­ na '%{formula}', produktu zaÄÃ­najÃ­cÃ­ho na '%{product}' a vzorkovnice '%{fandeck}'.",
            productFilter: "Filtr produktÅ¯",
            searchInFormulas: "Hledat v recepturÃ¡ch",
            typeMore: "ProsÃ­m zadejte vÃ­ce znakÅ¯"
        },
        menu: {
            actionHistory: "Historie udÃ¡lostÃ­",
            additionalFormulaTab: "DalÅ¡Ã­ karta receptury",
            advancedSettings: "RozÅ¡Ã­ÅenÃ© nastavenÃ­",
            autotaskSettings: "NastavenÃ­ automatickÃ½ch Ãºloh",
            availableDatabases: "DostupnÃ© databÃ¡ze",
            availablePrices: "DostupnÃ© ceny",
            bugReport: "HlÃ¡Å¡enÃ­ chyb",
            canisterBarcodes: "ÄÃ¡rovÃ© kÃ³dy kanystrÅ¯",
            canisterDispensingLogic: "Logika tÃ³novÃ¡nÃ­",
            canisterFilling: "PlnÄnÃ­ kanystrÅ¯",
            canisterSettings: "NastavenÃ­ kanystrÅ¯",
            clientServerSettings: "NastavenÃ­ klienta/serveru",
            closing: "UzavÃ­rÃ¡nÃ­",
            color: "Barva",
            colorModification: "Modifikace barvy",
            colorPanel: "NastavenÃ­ palety barev",
            colorRepresentation: "Reprezentace barvy a data",
            colorSearch: "HledÃ¡nÃ­ barvy",
            colorant: "Kolorant",
            colorantConsumption: "SpotÅeba kolorantÅ¯",
            colorantPricing: "Ceny za koloranty",
            colorantRefillHistory: "Historie doplÅovÃ¡nÃ­ kolorantÅ¯",
            competitiveSearch: "HledÃ¡nÃ­ konkurenÄnÃ­ch odstÃ­nÅ¯",
            connections: "SpojenÃ­",
            currency: "NastavenÃ­ mÄn",
            customData: "VlastnÃ­ data",
            database: "DatabÃ¡ze",
            databaseCheck: "Kontrola databÃ¡ze",
            databaseConnection: "PÅipojenÃ­ databÃ¡ze",
            defaultValues: "VÃ½chozÃ­ hodnoty",
            devices: "PÅÃ­stroje",
            dispensingHistory: "Historie tÃ³novÃ¡nÃ­",
            dispensingSettings: "NastavenÃ­ tÃ³novÃ¡nÃ­",
            driverSettings: "NastavenÃ­ ovladaÄe",
            environment: "ProstÅedÃ­",
            environmentConfiguration: "NastavenÃ­ prostÅedÃ­",
            environmentalSettings: "NastavenÃ­ prostÅedÃ­",
            favorites: "OblÃ­benÃ©",
            fileTransfer: "DESO File Transfer",
            formatting: "FormÃ¡tovÃ¡nÃ­",
            formula: "Formula",
            formulaData: "Data",
            formulaModification: "Formula modification",
            formulaPanels: "Panely receptury",
            formulaSettings: "NastavenÃ­ receptury",
            formulaUnit: "Jednotka receptury",
            generalSearch: "ObecnÃ© vyhledÃ¡vÃ¡nÃ­",
            globalSettingsSearch: "VyhledÃ¡vÃ¡nÃ­ v globÃ¡lnÃ­m nastavenÃ­",
            helpItems: "NastavenÃ­ podpory",
            importAndExport: "Import a export",
            importAndExportData: "Importovat vlastnÃ­ data",
            importCustomData: "Importovat vlastnÃ­ data",
            initialFormulaTab: "PrvnÃ­ karta receptury",
            interfaceSettings: "NastavenÃ­ rozhranÃ­",
            keyboardShortcuts: "KlÃ¡vesovÃ© zkratky",
            language: "NastavenÃ­ jazykÅ¯",
            languageSettings: "NastavenÃ­ jazyku",
            layout: "Vzhled",
            license: "Licence",
            licenseData: "Ãdaje o licenci",
            licenseIdentification: "Identifikace licence",
            licenseStatus: "Stav licence",
            licenseSupplier: "Dodavatel licence",
            licenseVersion: "Verze licence",
            localData: "LokÃ¡lni data",
            machine: "Stroj",
            machineActions: "ServisnÃ­ udÃ¡losti",
            machineAndDevices: "Stroj a zaÅÃ­zenÃ­",
            machineManagement: "SprÃ¡va stroje",
            machineSettings: "NastavenÃ­ stroje",
            mainSettings: "HlavnÃ­ nastavenÃ­",
            maintenance: "ÃdrÅ¾ba",
            marginAndDiscount: "MarÅ¾e a sleva",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "NavigaÄnÃ­ poloÅ¾ky",
            newFormulaWindow: "NovÃ© okno receptury",
            orderSearch: "VyhledÃ¡vÃ¡nÃ­ objednÃ¡vek",
            orderSettings: "NastavenÃ­ objednÃ¡vek",
            packageSurcharge: "ManipulaÄnÃ­ poplatek",
            popUps: "VyskakovacÃ­ okna",
            posInfo: "Informace o prodejnÄ",
            price: "NastavenÃ­ cen",
            priceManagement: "SprÃ¡va cen",
            priceSettings: "NastavenÃ­ cen",
            pricingOptions: "MoÅ¾nosti nacenÄnÃ­",
            printSettings: "NastavenÃ­ tisku",
            productPricing: "Ceny za produkty",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "RychlÃ© tÃ³novÃ¡nÃ­",
            rccConfig: "RCC konfigurace",
            rccConnection: "RCC pÅipojenÃ­",
            rccSettings: "RCC nastavenÃ­",
            refillSettings: "NastavenÃ­ doplÅovÃ¡nÃ­",
            refillingLogic: "Logika doplÅovÃ¡nÃ­",
            registration: "Registrace",
            searchSettings: "NastavenÃ­ vyhledÃ¡vÃ¡nÃ­",
            serverPlugins: "ServerovÃ© doplÅky",
            serviceActions: "ServisnÃ­ Ãºloha",
            settings: "NastavenÃ­",
            simplifiers: "PomocnÃ­ci",
            singleActions: "JednotlivÃ© Ãºlohy",
            smartPurgeRules: "Pravidla chytrÃ½ch odstÅikÅ¯",
            softwareOptions: "MoÅ¾nosti softvÃ©ru",
            spectroSettings: "NastavenÃ­ spektrometru",
            statistics: "Statistiky",
            switchToFrontdesk: "PÅepnout na frontdesk",
            switchToFullRedlike: "PÅepnout do %{name}",
            switchToLight: "PÅepnout do %{name}",
            switchToMachine: "PÅepnout na stroj",
            tabs: "Karty a vyskakovacÃ­ okna",
            testBarcodes: "Test ÄÃ¡rovÃ½ch kÃ³dÅ¯",
            updateOptions: "MoÅ¾nosti aktualizace",
            userManagemenet: "SprÃ¡va uÅ¾ivatelÅ¯",
            visibleUnits: "ViditelnÃ© jednotky"
        },
        navBar: {
            barcode: "ÄÃ¡rovÃ½ kÃ³d",
            help: "Podpora",
            hideItems: "SkrÃ½t produkty/vÄjÃ­Åe"
        },
        notificationPanel: {
            noNotifications: "Å½Ã¡dnÃ¡ novÃ¡ oznÃ¡menÃ­"
        },
        tabBar: {
            closeActive: "ZavÅÃ­t aktivnÃ­",
            closeAll: "ZavÅÃ­t vÅ¡e",
            closeAllExceptActive: "ZavÅÃ­t vÅ¡e kromÄ aktivnÃ­ho",
            customFormula: "VlastnÃ­ receptura",
            dispensingHistory: "Historie tÃ³novÃ¡nÃ­",
            favorites: "OblÃ­benÃ©",
            formulaSearch: "HledÃ¡nÃ­ receptury",
            rewriteSettings: "PÅepiÅ¡te lokÃ¡lnÃ­ nastavenÃ­"
        }
    },
    ordering: {
        assign: "PÅiÅadit",
        assignment: "PÅiÅazenÃ­",
        createdDate: "Datum vytvoÅenÃ­",
        finishDispensing: "DokonÄit tÃ³novÃ¡nÃ­",
        foundInOrders: "Nalezeno v objednÃ¡vkÃ¡ch",
        inactiveDatabase: "Receptura je z neaktivnÃ­ nebo neznÃ¡mÃ© databÃ¡ze %{0}",
        inactiveUnknownDatabase: "Receptura je z neaktivnÃ­ nebo neznÃ¡mÃ© databÃ¡ze",
        newOrderReceived: "Dostali jste novou objednÃ¡vku!",
        noOrderSelected: "Nebyla vybrÃ¡na Å¾Ã¡dnÃ¡ objednÃ¡vka",
        release: "Uvolnit",
        status: {
            accepted: "PÅijatÃ¡",
            canceled: "ZruÅ¡enÃ¡",
            created: "VytvoÅenÃ¡",
            done: "HotovÃ¡",
            partlyDone: "ÄÃ¡steÄnÄ hotovÃ¡",
            preparing: "PÅÃ­prava",
            unknown: "NeznÃ¡mÃ¡"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Pro tuto databÃ¡zi nelze pouÅ¾Ã­t aktualizace. Aktualizujte prosÃ­m pomocÃ­ Helperu.",
        newVersionWillBeInstalled: "Nainstaluje novou verzi vÄetnÄ vÅ¡ech dostupnÃ½ch partial updatÅ¯.",
        noPartialUpdatesAvailable: "Nejsou k dispozici Å¾Ã¡dnÃ© partial updaty",
        outOfDate: "neaktuÃ¡lnÃ­!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "K dispozici jsou partial updaty!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "PÅipomenout pozdÄji (po %{time} minutÃ¡ch)",
        swOutOfDate: "AktuÃ¡lnÃ­ verze softwaru je",
        updateAutomatically: "Pokud neodpovÃ­te, aktualizace se spustÃ­ automaticky za: %{time} s",
        updateToNewVersion: "Aktualizujte na nejnovÄjÅ¡Ã­ verzi",
        updateWillTakeMoreTime: "Aktualizace zabere vÃ­ce Äasu.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Aktualizuji"
    },
    posInfo: {
        address: "Adresa",
        contactName: "KontaktnÃ­ jmÃ©no",
        contactPerson: "KontaktnÃ­ osoba",
        identification: "Identifikace",
        machineInformation: "Informace o stroji",
        pos: "Prodejna",
        secondAddress: "DruhÃ¡ adresa",
        shopIdentification: "Identifikace obchodu",
        shopName: "NÃ¡zev obchodu",
        url: "Url",
        zipCode: "PSÄ"
    },
    priceTypeList: {
        priceBasePurchase: "NÃ¡kupnÃ­ cena bÃ¡ze",
        priceBaseSell: "ProdejnÃ­ cena bÃ¡ze",
        priceBaseSellFull: "CelkovÃ¡ prodejnÃ­ cena bÃ¡zÃ­",
        priceCntPurchase: "NÃ¡kupnÃ­ cena kolorantÅ¯",
        priceCntPurchaseByColorantName: "NÃ¡kupnÃ­ cena pro kolorant %{0}",
        priceCntPurchaseByName: "NÃ¡kupnÃ­ cena kolorantÅ¯ podle jmÃ©na",
        priceCntSell: "ProdejnÃ­ cena kolorantÅ¯",
        priceCntSellByColorantName: "NÃ¡kupnÃ­ cena pro kolorant %{0}",
        priceCntSellByName: "ProdejnÃ­ cena kolorantÅ¯ podle jmÃ©na",
        priceCntSellFull: "CelkovÃ¡ prodejnÃ­ cena kolorantÅ¯",
        priceCntSellFullByColorantName: "CelkovÃ¡ prodejnÃ­ cena %{0} kolorantÅ¯",
        priceCntSellFullByName: "CelkovÃ¡ prodejnÃ­ cena za kolorant",
        priceGroupBarcode: "ÄÃ¡rovÃ½ kÃ³d cenovÃ½ch skupin",
        priceMarginAll: "MarÅ¾e vÅ¡ech balenÃ­",
        priceMarginPerPkg: "MarÅ¾e jednoho balenÃ­",
        priceSellPriceAll: "ProdejnÃ­ cena vÅ¡ech balenÃ­",
        priceSellPricePerKg: "ProdejnÃ­ cena za kilogram",
        priceSellPricePerL: "ProdejnÃ­ cena za litr",
        priceSellPricePerPkg: "ProdejnÃ­ cena jednoho balenÃ­",
        priceSurchargeAll: "PÅÃ­platek za vÅ¡echna balenÃ­",
        priceSurchargePerPkg: "PÅÃ­platek za jedno balenÃ­",
        priceTintPurchaseAll: "Cena tÃ³novÃ¡nÃ­ vÅ¡ech balenÃ­",
        priceTintPurchasePerPkg: "Cena tÃ³novÃ¡nÃ­ jednoho balenÃ­",
        priceTintSellFullAll: "CelkovÃ¡ prodejnÃ­ cena vÅ¡ech balenÃ­ odstÃ­nÅ¯",
        priceTintSellFullAllPerPackage: "CelkovÃ¡ prodejnÃ­ cena balenÃ­ odstÃ­nu",
        priceTotalPurchaseAll: "CelkovÃ¡ nÃ¡kupnÃ­ cena za vÅ¡echna balenÃ­",
        priceTotalPurchasePerKg: "CelkovÃ¡ nÃ¡kupnÃ­ cena za kilogram",
        priceTotalPurchasePerL: "CelkovÃ¡ nÃ¡kupnÃ­ cena za litr",
        priceTotalPurchasePerPkg: "CelkovÃ¡ nÃ¡kupnÃ­ cena za jedno balenÃ­",
        priceTotalSellFullAll: "CelkovÃ¡ cena vÅ¡ech balenÃ­",
        priceTotalSellFullPerKg: "CelkovÃ¡ prodejnÃ­ cena za kilogram",
        priceTotalSellFullPerLiter: "CelkovÃ¡ prodejnÃ­ cena za litr",
        priceTotalSellFullPerPackage: "CelkovÃ¡ prodejnÃ­ cena balenÃ­"
    },
    pricing: {
        allBases: "VÅ¡echny bÃ¡ze",
        allPackages: "VÅ¡echna balenÃ­",
        backup: "ZÃ¡lohovat",
        basesOfProduct: "BÃ¡ze produktu %{productName}",
        colorantPricing: "Ceny za koloranty",
        export: "Export",
        import: "Import",
        packagePricing: "Ceny za balenÃ­",
        packageSurcharge: "PÅÃ­platek na balenÃ­",
        packages: "BalenÃ­",
        packagesOfProduct: "BalenÃ­ produktu %{productName}",
        posCoeficient: "Koeficient prodejny",
        priceGroupPricePerLiter: "Cena cenovÃ© skupiny za litr",
        priceGroups: "CenovÃ© skupiny",
        pricePerLiter: "Cena za litr",
        productPricing: "Ceny za produkty",
        purchasePrice: "NÃ¡kupnÃ­ cena",
        purchasePricePerLiter: "NÃ¡kupnÃ­ cena za litr",
        sellPrice: "ProdejnÃ­ cena",
        surcharge: "PÅÃ­platek"
    },
    print: {
        adminRightsRequired: "Pro Ãºpravu nebo vytvoÅenÃ­ novÃ© Å¡ablony jsou potÅeba prÃ¡va sprÃ¡vce.",
        allowAutomaticPrint: "Povolit automatickÃ½ tisk",
        allowPrintAfterDispensing: "Povolit tisk po tÃ³novÃ¡nÃ­",
        allowPrintBeforeDispensing: "Povolit tisk pÅed tÃ³novÃ¡nÃ­m",
        automaticPrint: "AutomatickÃ½ tisk",
        choosePrinter: "Vyberte tiskÃ¡rnu",
        chooseSettings: "Upravit nastavenÃ­",
        chooseTemplate: "Vyberte Å¡ablonu",
        copies: "Kopie",
        createTemplate: "VytvoÅit Å¡ablonu",
        createTemplateHint: "VytvoÅit novou Å¡ablonu od zaÄÃ¡tku. UloÅ¾te ji do sloÅ¾ky templates a restartujte RCC.",
        defaultPrinter: "TiskÃ¡rna",
        defaultSettings: "VÃ½chozÃ­ nastavenÃ­",
        defaultTemplate: "VÃ½chozÃ­ Å¡ablona",
        editTemplate: "Upravit Å¡ablonu",
        editTemplateHint: "Upravit %{name}. ZmÄny budou viditelnÃ© po restartu RCC.",
        noEditTemplate: "Å½Ã¡dnÃ¡ Å¡ablona k ÃºpravÄ",
        noPrinterSelected: "NenÃ­ vybrÃ¡na Å¾Ã¡dnÃ¡ tiskÃ¡rna",
        noPrintersAvailable: "Nejsou dostupnÃ© Å¾Ã¡dnÃ© tiskÃ¡rny",
        noTemplateSelected: "NenÃ­ vybrÃ¡na Å¾Ã¡dnÃ¡ Å¡ablona",
        noTemplatesAvailable: "Nejsou dostupnÃ© Å¾Ã¡dnÃ© Å¡ablony",
        numberOfCopies: "PoÄet kopiÃ­",
        openTemplateEditor: "OtevÅÃ­t editor Å¡ablon",
        printAfterDispensing: "Tisk po tÃ³novÃ¡nÃ­",
        printAsImage: "Tisknout jako obrÃ¡zek",
        printBeforeDispensing: "Tisk pÅed tÃ³novÃ¡nÃ­m",
        printOnRequest: "Tisk na vyÅ¾Ã¡danÃ­",
        printOptions: "MoÅ¾nosti tisku",
        printPagesAfterDispensing: "PoÄet kopiÃ­ po tÃ³novÃ¡nÃ­ plechovky",
        printPagesBeforeDispensing: "PoÄet kopiÃ­ pÅed tÃ³novÃ¡nÃ­m plechovky",
        printPreview: "NÃ¡hled tisku",
        printSettings: "NastavenÃ­ tisku",
        printTaskLinkVariable: "Odkaz na promÄnou",
        printVariable: "Tisk promÄnÃ©",
        printerName: "NÃ¡zev tiskÃ¡rny",
        printerOptions: "Volby tiskÃ¡rny",
        printerSettings: "NastavenÃ­ tiskÃ¡rny",
        quickTintTemplate: "Å ablona pro rychlÃ© tÃ³novÃ¡nÃ­",
        setDefaultPrinter: "Nastavit vÃ½chozÃ­ tiskÃ¡rnu",
        setDefaultTemplate: "Nastavit vÃ½chozÃ­ Å¡ablonu",
        setQuickTintTemplate: "Nastavit Å¡ablonu pro rychlÃ© tÃ³novÃ¡nÃ­",
        showPreviewDialogBeforePrint: "PÅed tiskem zobrazit dialogovÃ© okno s nÃ¡hledem",
        template: "Å ablona",
        templateName: "NÃ¡zev Å¡ablony",
        templateSettings: "NastavenÃ­ Å¡ablon"
    },
    printTemplate: {
        baseCode: "KÃ³d bÃ¡ze",
        baseName: "NÃ¡zev bÃ¡ze",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "MÄsto zÃ¡kaznÃ­ka",
        customerEmail: "E-mail zÃ¡kaznÃ­ka",
        customerName: "JmÃ©no zÃ¡kaznÃ­ka",
        customerPhone: "Telefon zÃ¡kaznÃ­ka",
        customerStreet: "Ulice zÃ¡kaznÃ­ka",
        customerZipCode: "PSÄ zÃ¡kaznÃ­ka",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "Hodnota BFS",
        orderQrCode: "QR kÃ³d",
        packageOrderCount: "PoÅadÃ­ balenÃ­",
        posAddress: "Adresa prodejny",
        posAddressSecond: "Adresa prodejny 2",
        posCity: "MÄsto prodejny",
        posContact: "Kontakt na prodejnu",
        posEmail: "E-mail prodejny",
        posPhone: "Telefon prodejny",
        posUrl: "Url prodejny",
        posZipCode: "PSÄ prodejny",
        priceBasePurchaseWithTax: "NÃ¡kupnÃ­ cena bÃ¡ze s DPH",
        priceBaseSellWithTax: "ProdejnÃ­ cena bÃ¡ze s DPH",
        priceCntPurchaseWithTax: "NÃ¡kupnÃ­ cena kolorantÅ¯ s DPH",
        priceCntTotalSellWithTax: "ProdejnÃ­ cena kolorantÅ¯ s DPH",
        priceMarginAllWithTax: "MarÅ¾e vÅ¡ech balenÃ­ s DPH",
        priceMarginPerPkgWithTax: "MarÅ¾e jednoho balenÃ­ s DPH",
        priceSellPriceAllWithTax: "ProdejnÃ­ cena vÅ¡ech balenÃ­ s DPH",
        priceSellPricePerKgWithTax: "ProdejnÃ­ cena za kilogram s DPH",
        priceSellPricePerLWithTax: "ProdejnÃ­ cena za litr s DPH",
        priceSellPricePerPkgWithTax: "ProdejnÃ­ cena jednoho balenÃ­ s DPH",
        priceSurchargeAllWithTax: "PÅÃ­platek za vÅ¡echny balenÃ­ s DPH",
        priceSurchargePerPkgWithTax: "PÅÃ­platek za jedno balenÃ­ s DPH",
        priceTintPurchaseAllWithTax: "Cena tÃ³novÃ¡nÃ­ vÅ¡ech balenÃ­ s DPH",
        priceTintPurchasePerPkgWithTax: "Cena tÃ³novÃ¡nÃ­ jednoho balenÃ­ s DPH",
        priceTotalPurchaseAllWithTax: "CelkovÃ¡ nÃ¡kupnÃ­ cena za vÅ¡echny balenÃ­ s DPH",
        priceTotalPurchasePerKgWithTax: "CelkovÃ¡ nÃ¡kupnÃ­ cena za kilogram s DPH",
        priceTotalPurchasePerLWithTax: "CelkovÃ¡ nÃ¡kupnÃ­ cena za litr s DPH",
        priceTotalPurchasePerPkgWithTax: "CelkovÃ¡ nÃ¡kupnÃ­ cena za jedno balenÃ­ s DPH",
        productAltName: "Produkt",
        recipeInline: "Receptura"
    },
    products: {
        bases: "BÃ¡ze",
        numberOfProducts: "PoÄet produktÅ¯",
        packagesFor: "BalenÃ­ pro",
        sizeOfPackage: "Velikost balenÃ­"
    },
    purgeModal: {
        purgeAll: "OdstÅÃ­knout vÅ¡e",
        purgeAllChannels: "OdstÅÃ­knout vÅ¡echny trysky",
        purgeVolume: "Objem odstÅiku",
        startPurge: "ZaÄÃ­t s odstÅikem"
    },
    qualityControl: {
        darker: "TmavÅ¡Ã­",
        dispensedMeasuredFormula: "TÃ³novanÃ¡ (mÄÅenÃ¡) receptura",
        lighter: "SvÄtlejÅ¡Ã­",
        measureDispensedFormula: "ZmÄÅte tÃ³novanou recepturu pro vÃ½poÄet delta E",
        moreBlue: "VÃ­ce modrÃ¡",
        moreGreen: "VÃ­ce zelenÃ¡",
        moreRed: "VÃ­ce ÄervenÃ¡",
        moreYellow: "VÃ­ce Å¾lutÃ¡",
        pleaseContinueToFormulaCorrection: "PokraÄujte prosÃ­m ke korekci receptury",
        qualityControlFailed: "Kontrola kvality selhala!",
        qualityControlPassed: "Kontrola kvality probÄhla ÃºspÄÅ¡nÄ"
    },
    quickTint: {
        dispensingInProgress: "TÃ³novÃ¡nÃ­ prÃ¡vÄ probÃ­hÃ¡",
        dispensingIsNotAvailable: "TÃ³novÃ¡nÃ­ nenÃ­ dostupnÃ©",
        machineNotConnected: "Stroj nenÃ­ pÅipojen",
        noColorantsSelected: "Nejsou vybrÃ¡ny Å¾Ã¡dnÃ© koloranty",
        noPrinterAvailable: "Tisk se nemÅ¯Å¾e provÃ©st, protoÅ¾e nenÃ­ k dispozici Å¾Ã¡dna tiskÃ¡rna.",
        noTemplateAvailable: "Tisk se nemÅ¯Å¾e provÃ©st, protoÅ¾e nenÃ­ k dispozici Å¾Ã¡dna Å¡ablona.",
        overMaxCanisterSize: "MnoÅ¾stvÃ­ jednoho nebo vÃ­ce kolorantÅ¯ je neplatnÃ©"
    },
    quickTintSettings: {
        alphabetically: "Podle abecedy",
        byCanister: "Podle kanystrÅ¯",
        closeAfterDispensing: "Po tÃ³novÃ¡nÃ­ uzavÅete",
        closeBeforeDispensing: "PÅed tÃ³novÃ¡nÃ­m uzavÅete",
        quickTintSettings: "NastavenÃ­ rychlÃ©ho tÃ³novÃ¡nÃ­",
        sorting: "UspoÅÃ¡dÃ¡nÃ­",
        windowClosingRules: "Pravidla pro uzavÃ­rÃ¡nÃ­ oken"
    },
    rccButtons: {
        abort: "ZruÅ¡it",
        all: "VÅ¡e",
        cancel: "ZruÅ¡it",
        continue: "PokraÄovat",
        help: "Pomoc",
        ignore: "Ignorovat",
        no: "Ne",
        noToAll: "Ne pro vÅ¡echny",
        ok: "OK",
        postpone: "OdloÅ¾it",
        resume: "PokraÄovat",
        retry: "Znovu",
        skip: "PÅeskoÄit",
        yes: "Ano",
        yesToAll: "Ano pro vÅ¡echny"
    },
    rccDialog: {
        98: "ProsÃ­m ovÄÅte bÃ¡zi %{0} ÄÃ¡rovÃ½m kÃ³dem.",
        99: "ProsÃ­m vloÅ¾te bÃ¡zi %{0} a potvrÄte (kliknÄte na OK)",
        100: "Stroj je v chybovÃ©m stavu, resetovat chyby?",
        101: "Stroj je v chybovÃ©m stavu, nenÃ­ moÅ¾nÃ© pokraÄovat",
        102: "Reset se nezdaÅil, nenÃ­ moÅ¾nÃ© pokraÄovat",
        103: "Receptura obsahuje neplatnÃ½ kolorant: %{0}",
        104: "Receptura obsahuje neplatnÃ© koloranty: %{0}",
        105: "Kolorant: %{0} je pod varovnou ÃºrovnÃ­",
        106: "Koloranty: %{0} jsou pod varovnou ÃºrovnÃ­",
        107: "Kolorant: %{0} je pod kritickou ÃºrovnÃ­",
        108: "Koloranty: %{0} jsou pod kritickou ÃºrovnÃ­",
        109: "VloÅ¾te plechovku",
        110: "VloÅ¾te plechovku: %{0} pro recepturu: %{1}",
        111: "Odeberte plechovku",
        112: "DÄrovat kanystr?",
        113: "Resetuji chyby, prosÃ­m Äekejte",
        114: "PosouvÃ¡m stÅ¯l, prosÃ­m poÄkejte",
        115: "DÄrovÃ¡nÃ­ kanystru, prosÃ­m poÄkejte",
        116: "TÃ³novÃ¡nÃ­ receptury %{0}, Äekejte prosÃ­m|BalenÃ­: %{1} z %{2}|Produkt: %{3}|BÃ¡ze: %{4}|Velikost plechovky: %{5}",
        117: "TÃ³novÃ¡nÃ­ receptury %{0}, Äekejte prosÃ­m|BalenÃ­: %{1} z %{2}|Produkt: %{3}|BÃ¡ze: %{4}|Velikost plechovky: %{5}",
        118: "TÃ³novÃ¡nÃ­, Äekejte prosÃ­m|BalenÃ­: %{0} z %{1}",
        119: "TÃ³novÃ¡nÃ­, Äekejte prosÃ­m|BalenÃ­: %{0} z %{1}",
        120: "RuÅ¡Ã­m tÃ³novÃ¡nÃ­, Äekejte prosÃ­m",
        121: "OvÄÅte kanystr pomocÃ­ ÄÃ¡rovÃ©ho kÃ³du",
        122: "OvÄÅte plechovku bÃ¡ze pomocÃ­ ÄÃ¡rovÃ©ho kÃ³du|Produkt: %{0}|BÃ¡ze: %{1}|Velikost plechovky: %{2}",
        123: "TÃ³novÃ¡nÃ­ bylo zruÅ¡eno, pÅejete si tÃ³novÃ¡nÃ­ obnovit?",
        124: "Objevila se chyba na stroji %{0} : %{1}. PÅejete si obnovit tÃ³novÃ¡nÃ­?",
        125: "UjistÄte se prosÃ­m, Å¾e dÅÃ­ve vloÅ¾enÃ¡ plechovka je vloÅ¾ena",
        126: "UjistÄte se, Å¾e je vloÅ¾ena novÃ¡ plechovka. TÃ³novÃ¡nÃ­ probÄhne od zaÄÃ¡tku",
        127: "Kolorant: %{0} je pod minimÃ¡lnÃ­m mnoÅ¾stvÃ­m pro tÃ³novÃ¡nÃ­. PÅejte si pokraÄovat bez ohledu na toto varovÃ¡nÃ­?",
        128: "Koloranty: %{0} jsou pod minimÃ¡lnÃ­m mnoÅ¾stvÃ­m pro tÃ³novÃ¡nÃ­. PÅejte si pokraÄovat bez ohledu na toto varovÃ¡nÃ­?",
        129: "ZvolenÃ¡ receptura pÅesahuje maximÃ¡lnÃ­ moÅ¾nÃ© mnoÅ¾stvÃ­ kolorantÅ¯, celkovÃ© mnoÅ¾stvÃ­ kolorantÅ¯ : %{0} %{1}, maximÃ¡lnÃ­ moÅ¾nÃ© mnoÅ¾stvÃ­ kolorantÅ¯: %{2} %{3}. PÅejete si pokraÄovat navzdory tomuto varovÃ¡nÃ­?",
        130: "Stroj je v chybovÃ©m stavu, resetovat chyby?",
        131: "Stroj je v chybovÃ©m stavu, nenÃ­ moÅ¾nÃ© pokraÄovat",
        132: "Reset se nezdaÅil, nenÃ­ moÅ¾nÃ© pokraÄovat",
        133: "Receptura odstÅiku je prÃ¡zdnÃ¡, nenÃ­ moÅ¾nÃ© pokraÄovat",
        134: "Receptura odstÅiku obsahuje poloÅ¾ky, kterÃ© nemohou bÃ½t odstÅÃ­knuty, chcete pokraÄovat?",
        135: "VloÅ¾te plechovku pro odstÅik",
        136: "Odeberte plechovku pro odstÅik",
        137: "Resetuji chyby, Äekejte prosÃ­m",
        138: "PosouvÃ¡m stÅ¯l, prosÃ­m poÄkejte",
        139: "ProbÃ­hÃ¡ odstÅik, Äekejte prosÃ­m",
        140: "ProbÃ­hÃ¡ odstÅik, Äekejte prosÃ­m",
        141: "RuÅ¡Ã­m odstÅik, Äekejte prosÃ­m",
        142: "Plechovka pro provedenÃ­ odstÅiku chybÃ­, zkontrolujte zda je vloÅ¾ena sprÃ¡vnÄ",
        143: "Receptura obsahuje poloÅ¾ky, kterÃ© nemohou bÃ½t odstÅÃ­knuty, pÅejete si pokraÄovat?",
        144: "VloÅ¾te plechovku na odstÅik",
        145: "PÅipravuje se, Äekejte prosÃ­m",
        146: "UkonÄuje se, Äekejte prosÃ­m",
        150: "ÄiÅ¡tÄnÃ­, Äekejte prosÃ­m",
        151: "ÄiÅ¡tÄnÃ­, Äekejte prosÃ­m",
        152: "RuÅ¡Ã­m ÄiÅ¡tÄnÃ­, Äekejte prosÃ­m",
        160: "PromÃ­chÃ¡vÃ¡nÃ­, Äekejte prosÃ­m",
        161: "PromÃ­chÃ¡vÃ¡nÃ­, Äekejte prosÃ­m",
        162: "RuÅ¡Ã­m promÃ­chÃ¡vÃ¡nÃ­, Äekejte prosÃ­m",
        170: "MÃ­chÃ¡nÃ­, Äekejte prosÃ­m",
        171: "MÃ­chÃ¡nÃ­, Äekejte prosÃ­m",
        172: "RuÅ¡Ã­m mÃ­chÃ¡nÃ­, Äekejte prosÃ­m",
        180: "Navazuji spojenÃ­ se strojem, prosÃ­m Äekejte",
        181: "SpojenÃ­ se strojem nemohlo bÃ½t navÃ¡zÃ¡no %{0}: %{1}}",
        182: "SpojenÃ­ se strojem nemohlo bÃ½t navÃ¡zÃ¡no. Pro vÃ­ce informacÃ­ zkontrolujte soubory s logy.",
        183: "Ve stroji chybÃ­ kolorant: %{0}, kterÃ½ je definovÃ¡n v databÃ¡zi",
        184: "Ve stroji chybÃ­ koloranty: %{0}, kterÃ© jsou definovÃ¡ny v databÃ¡zi",
        185: "UkonÄuji spojenÃ­ se strojem, prosÃ­m poÄkejte",
        190: "ZavÅete vÅ¡echna servisnÃ­ okna, abyste mohli pokraÄovat",
        200: "ResetovÃ¡nÃ­, Äekejte prosÃ­m",
        201: "TvrdÃ© resetovÃ¡nÃ­, Äekejte prosÃ­m",
        202: "ProbÃ­hÃ¡ inicializace, Äekejte prosÃ­m",
        203: "ResetovÃ¡nÃ­ chyb, Äekejte prosÃ­m",
        205: "VÃ­Äko zvlhÄovaÄe tryskyse otvÃ­rÃ¡, Äekejte prosÃ­m",
        206: "VÃ­Äko zvlhÄovaÄe trysky se zavÃ­rÃ¡, Äekejte prosÃ­m",
        207: "VÃ­Äko zvlhÄovaÄe trysky v pohybu, Äekejte prosÃ­m",
        210: "ProbÃ­hÃ¡ dÄrovÃ¡nÃ­, Äekejte prosÃ­m",
        211: "ProbÃ­hÃ¡ zÃ¡tkovÃ¡nÃ­, Äekejte prosÃ­m",
        215: "StÅ¯l se posouvÃ¡ nahoru, Äekejte prosÃ­m",
        216: "StÅ¯l se posouvÃ¡ dolÅ¯, Äekejte prosÃ­m",
        217: "StÅ¯l v pohybu, Äekejte prosÃ­m",
        220: "StÅ¯l se natÃ¡ÄÃ­ na pozici pro doplnÄnÃ­: %{0}, Äekejte prosÃ­m",
        221: "StÅ¯l se vracÃ­ do vÃ½chozÃ­ pozice, Äekejte prosÃ­m",
        222: "StÅ¯l se natÃ¡ÄÃ­, Äekejte prosÃ­m",
        230: "Stroj je zaneprÃ¡zdnÄn, prosÃ­m Äekejte",
        240: "DoplnÄnÃ­ kanystru %{0}",
        241: "ProsÃ­m doplÅte kanystr %{0}",
        242: "PolohovÃ¡nÃ­ kanystru: %{0} (%{1}) na pozici doplnÄnÃ­",
        243: "ProsÃ­m doplÅte kanystr %{0} za pouÅ¾itÃ­ ÄÃ¡rovÃ©ho kÃ³du",
        244: "ProsÃ­m doplÅte kanystr %{0} za pouÅ¾itÃ­ ÄÃ¡rovÃ©ho kÃ³du",
        250: "VyjmÄte nÃ¡dobu na Å¡tÄtce, vyÄistÄte ji a naplÅte ji vodou podle pokynÅ¯",
        251: "VraÅ¥te nÃ¡dobu na Å¡tÄtce zpÄt",
        254: "VÃ­Äko zvlhÄovaÄe trysky se otevÃ­rÃ¡",
        255: "VyÄistÄte vÃ­Äko zvlhÄovaÄe trysky podle pokynÅ¯",
        256: "PotvrÄte, Å¾e ÄiÅ¡tÄnÃ­ skonÄilo a vÃ­Äko zvlhÄovaÄe trysky je zpÄt na svÃ©m mÃ­stÄ",
        257: "VÃ­Äko zvlhÄovaÄe trysky se zavÃ­rÃ¡",
        260: "VyjmÄte destiÄku a vyÄistÄte ji",
        261: "VraÅ¥te destiÄku zpÄt",
        265: "VyÄistÄte stroj hadÅÃ­kem a odstraÅte veÅ¡kerÃ© rozlitÃ© barvivo nebo jinou tekutinu",
        266: "Po dokonÄenÃ­ potvrÄte",
        270: "NaplÅte nÃ¡dobu zvlhÄovaÄe vodou a po dokonÄenÃ­ potvrÄte",
        271: "NaplÅte nÃ¡dobu zvlhÄovaÄe vodou a po dokonÄenÃ­ potvrÄte",
        272: "Hladina vody je poÅÃ¡d nÃ­zkÃ¡, zkontrolujte ji znovu",
        273: "Hladina vody je poÅÃ¡d nÃ­zkÃ¡, zkontrolujte ji znovu",
        274: "Zkontrolujte hladinu vody v nÃ¡dobÄ zvlhÄovaÄe",
        275: "Äekejte, prosÃ­m",
        280: "PoÄÃ­taÄ se restartuje",
        281: "PoÄÃ­taÄ se vypÃ­na",
        300: "ChybÃ­ plechovka s bÃ¡zÃ­, zkontrolujte zda je vloÅ¾ena sprÃ¡vnÄ",
        301: "PÅipravuje se, Äekejte prosÃ­m",
        302: "DokonÄuje se, Äekejte prosÃ­m",
        303: "Receptura se nemÅ¯Å¾e vytÃ³novat, protoÅ¾e obsahuje kolorant %{0} kterÃ½ pÅesahuje maximÃ¡lnÃ­ tÃ³novatelnÃ© mnoÅ¾stvÃ­ z kanystru",
        304: "Receptura se nemÅ¯Å¾e vytÃ³novat, protoÅ¾e obsahuje kolorant %{0} kterÃ½ pÅesahuje maximÃ¡lnÃ­ tÃ³novatelnÃ© mnoÅ¾stvÃ­ z kanystrÅ¯",
        305: "Kolorant %{0} se nemÅ¯Å¾e vytÃ³novat najednou, chcete recepturu rozdÄlit?",
        306: "Koloranty %{0} se nemÅ¯Å¾ou vytÃ³novat najednou, chcete recepturu rozdÄlit?",
        307: "Stroj nevytÃ³nuje kolorant %{0} chcete pokraÄovat a pÅidat ho ruÄnÄ?",
        308: "Stroj nevytÃ³nuje koloranty: %{0} chcete pokraÄovat a pÅidat je ruÄnÄ?",
        309: "ZvolenÃ¡ receptura je prÃ¡zdnÃ¡, pouÅ¾Ã­jte plechovku bÃ¡ze jako takovÃ©",
        310: "NevytÃ³nuje se Å¾Ã¡dnÃ½ kolorant, pÅipravte plechovku bÃ¡ze na ruÄnÃ­ doplnÄnÃ­ kolorantu",
        311: "OdstraÅte plechovku bÃ¡ze a pÅipravte ji na ruÄnÃ­ doplnÄnÃ­ kolorantu",
        312: "PÅidat manuÃ¡lnÄ %{0} %{1} z kolorantu: %{2}, po vykonanÃ­ potvrÄte",
        313: "RuÄnÃ­ tÃ³novÃ¡nÃ­ receptury",
        314: "VybranÃ¡ receptura poruÅ¡uje pravidlo o pÅeplnenÃ­, celkovÃ© mnoÅ¾stvÃ­ kolorantÅ¯: %{0} %{1}, maximÃ¡lnÃ­ povolenÃ© mnoÅ¾stvÃ­ kolorantÅ¯: %{2} %{3}. Chcete pokraÄovat i pÅes toto varovÃ¡nÃ­?",
        315: "Naskenujte nebo napiÅ¡te UFI kÃ³d plechovky bÃ¡ze",
        316: "Naskenujte nebo napiÅ¡te UFI kÃ³d plechovky bÃ¡ze|Produkt: %{0}|BÃ¡ze: %{1}|Velikost plechovky: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "ZaÄne Ãºloha automatickÃ½ch odstÅikÅ¯",
        401: "ZaÄne Ãºloha automatickÃ½ch odstÅikÅ¯",
        405: "NÃ¡doba na Å¡tÄtce vyÅ¾aduje ÃºdrÅ¾bu",
        406: "NÃ¡doba na Å¡tÄtce vyÅ¾aduje ÃºdrÅ¾bu",
        410: "ZaÄne automatickÃ¡ ÃºdrÅ¾ba vÃ­Äka",
        411: "ZaÄne automatickÃ¡ ÃºdrÅ¾ba vÃ­Äka",
        415: "DestiÄka musÃ­ bÃ½t vyÄiÅ¡tÄna",
        416: "DestiÄka musÃ­ bÃ½t vyÄiÅ¡tÄna",
        420: "TÃ³novacÃ­ stroj musÃ­ bÃ½t vyÄiÅ¡tÄn",
        421: "TÃ³novacÃ­ stroj musÃ­ bÃ½t vyÄiÅ¡tÄn",
        425: "ZaÄne doplÅovÃ¡nÃ­ kanystrÅ¯",
        426: "ZaÄne doplÅovÃ¡nÃ­ kanystrÅ¯",
        430: "Restart poÄÃ­taÄe byl naplÃ¡novanÃ½",
        431: "Restart poÄÃ­taÄe byl naplÃ¡novanÃ½",
        435: "VypnutÃ­ poÄÃ­taÄe bylo naplÃ¡novanÃ©",
        436: "VypnutÃ­ poÄÃ­taÄe bylo naplÃ¡novanÃ©",
        440: "UmytÃ­ stroje bylo naplÃ¡novanÃ©",
        441: "UmytÃ­ stroje bylo naplÃ¡novanÃ©",
        445: "Recirkulace stroje byla naplÃ¡novanÃ¡",
        446: "Recirkulace stroje byla naplÃ¡novanÃ¡",
        450: "MÃ­chÃ¡nÃ­ stroje bylo naplÃ¡novanÃ©",
        451: "MÃ­chÃ¡nÃ­ stroje bylo naplÃ¡novanÃ©",
        990: "Objevila se chyba v stroji %{0}: %{1} Chcete zkusit znovu?",
        991: "Objevila se vnitÅnÃ­ chyba: %{0}",
        200000001: "VloÅ¾te plechovku",
        200000002: "Odeberte plechovku",
        200000003: "MnoÅ¾stvÃ­ %{0} pod minimÃ¡lnÃ­m mnoÅ¾stvÃ­m tÃ³novÃ¡nÃ­, pokraÄovat na vlastnÃ­ nebezpeÄÃ­?",
        200000004: "Doplnit %{0}"
    },
    rccDriverSettings: {
        databasePath: "Cesta k databÃ¡zi",
        dispenser: "DÃ¡vkovaÄ",
        dispenserConfigurationFile: "KonfiguraÄnÃ­ soubor stroje",
        driverPath: "Cesta k ovladaÄi",
        extensionPath: "Cesta k souboru s rozÅ¡Ã­ÅenÃ­m",
        folder: "SloÅ¾ka",
        formulaPath: "Cesta k souboru s recepturami",
        host: "Host",
        iddPath: "Cesta ke konfiguraÄnÃ­mu souboru pro IDD",
        italtintoPath: "Cesta ke konfiguraÄnÃ­mu souboru pro Italtinto",
        lldPath: "Cesta k LLD",
        machineType: "Typ stroje",
        noMachineAvailable: "Neni k dispozici Å¾Ã¡dnÃ½ stroj",
        protocolVersion: "Verze protokolu",
        rccDriverSettings: "NastavenÃ­ ovladaÄe",
        resultPath: "VÃ½slednÃ­ cesta",
        save: "UloÅ¾it nastavenÃ­",
        saveSettingsWarning: "VarovÃ¡nÃ­! ZmÄny vrÃ¡mci tÃ©to sekce mÅ¯Å¾ou zpÅ¯sobit nefunkÄnost stroje.",
        serviceSwPath: "Cesta k servisu Softwaru",
        simulationPath: "Cesta k simulaÄnÃ­mu souboru"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Povolit manuÃ¡lnÃ­ pÅidÃ¡nÃ­ kolorantu",
        ask: "Zeptat se",
        canHandlingOptions: "MoÅ¾nosti prÃ¡ce s plechovkou",
        checkCanBeforeDispense: "Zkontrolovat plechovku pÅed tÃ³novÃ¡nÃ­m",
        checkOverfill: "Zkontrolovat pÅeplnÄnÃ­",
        colorantBatchNumbers: "ÄÃ­slo Å¡arÅ¾e kolorantu",
        colorantPackageValidation: "Jen validace balenÃ­ kolorantÅ¯ ",
        disable: "ZakÃ¡zat",
        dispenseInvalidColorants: "TÃ³novÃ¡nÃ­ neplatnÃ½ch kolorantÅ¯",
        dispensingOptions: "MoÅ¾nosti tÃ³novÃ¡nÃ­",
        enable: "Povolit",
        enableUserIdentification: "Identifikace uÅ¾ivatele",
        fullValidation: "PlnÃ¡ validace",
        machineAccuracyWarning: "VarovÃ¡nÃ­ pÅesnosti stroje",
        machineOptions: "Volby stroje",
        machineUnit: "PouÅ¾Ã­t jednotku",
        minimalDispenseAmount: "MinimÃ¡lnÃ­ mnoÅ¾stvÃ­ pro tÃ³novÃ¡nÃ­",
        placeCanSensor: "AutomatickÃ© potvrzenÃ­ vloÅ¾enÃ­ plechovky",
        placeCanSensorDelay: "Zkontrolovat vloÅ¾enÃ­ plechovky po",
        rccMachineSettings: "NastavenÃ­ stroje",
        refillBarcodeValidation: "Validace ÄÃ¡rovÃ©ho kÃ³du doplnÄnÃ­",
        refillBarcodeValidationCanisterAndColorant: "Validace kanystru a balenÃ­ kolorantu",
        refillBarcodeValidationColorant: "Validace pouze balenÃ­ kolorantu",
        refillSettings: "NastavenÃ­ doplÅovÃ¡nÃ­",
        removeCanSensor: "AutomatickÃ© potvrzenÃ­ odebrÃ¡nÃ­ plechovky",
        removeCanSensorDelay: "Zkontrolovat odebrÃ¡nÃ­ plechovky",
        save: "UloÅ¾it nastavenÃ­",
        sec: "sek.",
        skipPlaceCanDialog: "PÅeskoÄit dialog umÃ­stÄnÃ­ plechovky",
        skipRemoveCanDialog: "PÅeskoÄit dialog odebrÃ¡nÃ­ plechovky",
        splitFormula: "RozdÄlit recepturu",
        tmcEnabled: "Povolit TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "OvÄÅte ÄÃ¡rovÃ½ kÃ³d plechovky",
        validateBarcodeRefill: "PÅed doplnÄnÃ­m ovÄÅte ÄÃ¡rovÃ½ kÃ³d",
        validateColorantsDuringInit: "Validovat koloranty pÅi inicializaci"
    },
    rccPanel: {
        actionsRunningOnDispenser: "V stroji prÃ¡vÄ probÃ­hajÃ­ Ãºlohy",
        addLevel: "PÅIDAT ÃROVEÅ",
        addManually: "PÅidat manuÃ¡lnÄ",
        barcodeNotSet: "Kanystr %{colorantName} (%{canisterName}) nemÃ¡ pÅiÅazen ÄÃ¡rovÃ½ kÃ³d.",
        cancel: "ZRUÅ IT",
        dispenseFormula: "TÃ³novacÃ­ receptura",
        dispenserIdle: "Stroj je neÄinnÃ½",
        dispenserIsBusy: "Stroj je zaneprÃ¡zdnÄn",
        dispenserIsIdle: "Stroj je neÄinnÃ½",
        dispenserIsReady: "Stroj je pÅipraven na dalÅ¡Ã­ Ãºlohy",
        dispensingFormula: "TÃ³novÃ¡nÃ­ receptury",
        errorCode: "KÃ³d chyby",
        explanation: "VysvÄtlenÃ­",
        fillToMax: "Doplnit do maxima",
        finished: "DokonÄenÃ­",
        inProgress: "ProbÃ­hÃ¡",
        machineIsReady: "Stroj je pÅipraven",
        moveToFill: "Posunout na doplnÄnÃ­",
        noMachineDialog: "NenÃ­ pÅipojen Å¾Ã¡dnÃ½ stroj",
        of: "z",
        packageSize: "Velikost balenÃ­",
        placeBaseCan: "VloÅ¾te plechovku bÃ¡ze",
        pleaseCheckYourMachineConnection: "Zkontrolujte pÅipojenÃ­ stroje.",
        pleaseRefill: "ProsÃ­m doplnit",
        solution: "ÅeÅ¡enÃ­",
        subErrors: "DÃ­lÄÃ­ chyby",
        timeToEnd: "Äas do konce",
        tintingFormula: "TÃ³novacÃ­ receptura",
        tintingPleaseWait: "TÃ³novÃ¡nÃ­, prosÃ­m Äekejte",
        validateBaseCan: "OvÄÅte plechovku bÃ¡ze",
        waiting: "ÄekÃ¡"
    },
    rccSettigns: {
        rccSettigns: "RCC nastavenÃ­",
        rccUrl: "RCC url"
    },
    rccSpectroDialog: {
        100: "PÅipojovÃ¡nÃ­ k VaÅ¡emu zaÅÃ­zenÃ­ pomocÃ­ Bluetooth. PÅesvÄdÄete se, Å¾e mÃ¡te povoleno Bluetooth a VaÅ¡e zaÅÃ­zenÃ­ je zapnuto.",
        101: "ZaÅÃ­zenÃ­ nebylo rozpoznÃ¡no. PÅejete si rozpoznat znovu?",
        110: "UjistÄte se, Å¾e je Nano pÅipojeno a proveÄte inicializaci stisknutÃ­m tlaÄÃ­tka na VaÅ¡em zaÅÃ­zenÃ­.",
        111: "Nano nebylo rozpoznÃ¡no. PÅejete si rozpoznat znovu?",
        112: "Odpojte Nano, poÄkejte 10 sekund, potÃ© jej znovu pÅipojte a pokraÄujte.",
        120: "PÅipojovÃ¡nÃ­ k zaÅÃ­zenÃ­, Äekejte prosÃ­m",
        121: "ZaÅÃ­zenÃ­ nebylo nalezeno. Chcete to zkusit znovu?",
        200: "PoloÅ¾te zaÅÃ­zenÃ­ na Äernou kalibraÄnÃ­ destiÄku a zmÃ¡ÄknÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        201: "PoloÅ¾te zaÅÃ­zenÃ­ na Äernou kalibraÄnÃ­ destiÄku a pokraÄujte.",
        202: "PoloÅ¾te zaÅÃ­zenÃ­ na Äernou kalibraÄnÃ­ destiÄku a zmÃ¡ÄknÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        205: "PoloÅ¾te zaÅÃ­zenÃ­ na bÃ­lou kalibraÄnÃ­ destiÄku a zmÃ¡ÄknÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        206: "PoloÅ¾te zaÅÃ­zenÃ­ na bÃ­lou kalibraÄnÃ­ destiÄku a pokraÄujte.",
        207: "PoloÅ¾te zaÅÃ­zenÃ­ na bÃ­lou kalibraÄnÃ­ destiÄku a zmÃ¡ÄknÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        210: "PoloÅ¾te zaÅÃ­zenÃ­ na diagnostickou destiÄku a pokraÄujte nebo zmÃ¡ÄknÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        211: "PoloÅ¾te zaÅÃ­zenÃ­ na diagnostickou destiÄku a pokraÄujte.",
        212: "PoloÅ¾te zaÅÃ­zenÃ­ na diagnostickou destiÄku a zmÃ¡ÄknÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        215: "ZavÅete kryt zaÅÃ­zenÃ­ a pokraÄujte nebo zmÃ¡ÄknÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        216: "ZavÅete kryt zaÅÃ­zenÃ­ a pokraÄujte.",
        217: "ZavÅete kryt zaÅÃ­zenÃ­ a zmÃ¡ÄknÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        220: "PoloÅ¾te zaÅÃ­zenÃ­ na zero destiÄku a pokraÄujte nebo zmÃ¡ÄknÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        221: "PoloÅ¾te zaÅÃ­zenÃ­ na zero destiÄku a pokraÄujte.",
        222: "PoloÅ¾te zaÅÃ­zenÃ­ na zero destiÄku a zmÃ¡ÄknÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        224: "UmÃ­stÄte pÅÃ­stroj na kalibraÄnÃ­ podloÅ¾ku a pokraÄujte nebo stisknÄte tlaÄÃ­tko pÅÃ­stroje",
        225: "UmÃ­stÄte pÅÃ­stroj na kalibraÄnÃ­ podloÅ¾ku a pokraÄujte",
        226: "UmÃ­stÄte pÅÃ­stroj na kalibraÄnÃ­ podloÅ¾ku a stisknÄte tlaÄÃ­tko pÅÃ­stroje",
        227: "UmÃ­stÄte pÅÃ­stroj na kalibraÄnÃ­ podloÅ¾ku a stisknÄte tlaÄÃ­tko pÅÃ­stroje",
        295: "DokonÄete kalibraci v oknÄ ovladaÄe",
        296: "ZaÅÃ­zenÃ­ nenÃ­ pÅipojeno. Chcete ho pÅipojit?",
        297: "PÅÃ­prava na kalibraci, prosÃ­m poÄkejte",
        298: "Kalibruji, Äekejte prosÃ­m",
        299: "DokonÄovÃ¡nÃ­ kalibrace, prosÃ­m poÄkejte",
        300: "UmÃ­stÄte zaÅÃ­zenÃ­ nad vzorek a pokraÄujte nebo stihnÄte tlaÄÃ­tko na VaÅ¡em zaÅÃ­zenÃ­.",
        301: "UmÃ­stÄte zaÅÃ­zenÃ­ nad vzorek a pokraÄujte.",
        302: "UmÃ­stÄte zaÅÃ­zenÃ­ nad vzorek a pokraÄujte stihnutÃ­m tlaÄÃ­tka na VaÅ¡em zaÅÃ­zenÃ­.",
        303: "ZaÅÃ­zenÃ­ nenÃ­ zkalirovÃ¡no. Chcete pokraÄovat s kalibracÃ­?",
        304: "ZaÅÃ­zenÃ­ nenÃ­ pÅipojeno. Chcete zaÅÃ­zenÃ­ pÅipojit?",
        390: "Zvolte reÅ¾im mÄÅenÃ­",
        395: "DokonÄete mÄÅenÃ­ v oknÄ ovladaÄe",
        397: "PÅipravuji mÄÅenÃ­, Äekejte prosÃ­m",
        398: "MÄÅenÃ­, Äekejte prosÃ­m",
        399: "DokonÄuji mÄÅenÃ­, Äekejte prosÃ­m",
        498: "StahujÃ­ se mÄÅenÃ­, prosÃ­m poÄkejte",
        499: "StahujÃ­ se vÅ¡echna mÄÅenÃ­, prosÃ­m poÄkejte",
        900: "Objevila se chyba nÃ¡stroje %{0} : %{1} Chcete zkusit znovu?",
        901: "Objevila se vnitÅnÃ­ chyba: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "PoÄÃ­taÄ musÃ­ mÃ­t pÅipojenÃ­ Bluetooth. Spektro musÃ­ bÃ½t spÃ¡rovÃ¡no s poÄÃ­taÄem. Je nutnÃ¡ podzimnÃ­ aktualizace systÃ©mu Windows 10 z roku 2018.",
        DatacolorSilent:
            "PÅi pouÅ¾itÃ­ tichÃ©ho reÅ¾imu jsou okna Datacoloru zobrazena pÅÃ­mo v %{name}. V tÄchto oknech nelze mÄnit  parametry spektra.",
        DatacolorUseDiagnosticTile: "PouÅ¾itÃ­ diagnostickÃ© destiÄky zlepÅ¡uje kvalitu mÄÅenÃ­.",
        comPort: "Com Port",
        diagnosticTile: "Datacolor s diagnostickou destiÄkou",
        measureModes: "ReÅ¾imy mÄÅenÃ­",
        measureModesOrder: "PoÅadÃ­ reÅ¾imÅ¯ mÄÅenÃ­",
        model: "Model",
        noSpectroAvailable: "NenÃ­ k dispozici Å¾Ã¡dnÃ© spektro",
        rccSpectroSettings: "NastavenÃ­ spektrometru",
        save: "UloÅ¾it nastavenÃ­",
        silent: "Datacolor Silent",
        simulationPath: "Cesta k simulaÄnÃ­m souborÅ¯m",
        spectroType: "Typ spektrometru",
        useProfiledValues: "PouÅ¾ijte profilovanÃ© hodnoty"
    },
    recirculateChannels: {
        recirculateAllChannels: "Recirkulovat vÅ¡echny okruhy",
        recirculateChannels: "Recirkulovat okruhy",
        recirculatingSpeed: "Rychlost recirkulace",
        recirculatingTime: "Doba recirkulace",
        startRecirculating: "ZahÃ¡jit recirkulaci"
    },
    redlikeLight: {
        finishPreviousSteps: "ProsÃ­m dokonÄete pÅedchozÃ­ krok",
        searchBySpectro: "Hledat pomocÃ­ spektrometru",
        searchFormula: "Vyhledat recepturu",
        selectBase: "Vybrat bÃ¡zi",
        selectColor: "Vyberte odstÃ­n",
        selectCustomer: "Vyberte zÃ¡kaznÃ­ka",
        selectFandeck: "Vyberte vzorkovnici",
        selectPackage: "Vyberte balenÃ­",
        selectProduct: "Vyberte produkt",
        startSelectFandeck: "ZaÄnÄte vyhledÃ¡nÃ­m vzorkovnice",
        startSelectProduct: "ZaÄnÄte vyhledÃ¡nÃ­m produktu",
        stepByStepProgress: "Postupujte krok za krokem",
        typeHereToSearch: "Zde vyhledejte",
        typeToFilter: "Zde zadejte filtr"
    },
    restartModal: {
        computerNeedsRestart: "PoÄÃ­taÄ vyÅ¾aduje restart!",
        notCompletelyTranslated:
            "ZmÄna jazyka vyÅ¾aduje restart softwaru. NÄkterÃ© ÄÃ¡sti softwaru nemusÃ­ bÃ½t v tuto chvÃ­li pÅeloÅ¾eny ÃºplnÄ.",
        restartIsRequired: "Po provedenÃ½ch zmÄnÃ¡ch je nutnÃ½ restart softwaru.",
        softwareNeedsRestart: "%{name} vyÅ¾aduje restart!"
    },
    searchPanel: {
        basePlaceholder: "nebo napiÅ¡te nÃ¡zev bÃ¡ze",
        baseStartPlaceholder: "ZaÄnÄte napsÃ¡nÃ­m nÃ¡zvu bÃ¡ze",
        colorCodeNamePlaceholder: "nebo napiÅ¡te kÃ³d/nÃ¡zev barvy",
        colorCodeNameStartPlaceholder: "ZaÄnÄte psÃ¡t kÃ³d/nÃ¡zev barvy",
        colorCodePlaceholder: "nebo napiÅ¡te kÃ³d barvy",
        colorCodeStartPlaceholder: "ZaÄnÄte psÃ¡t kÃ³d barvy",
        colorNameCodePlaceholder: "nebo napiÅ¡te nÃ¡zev/kÃ³d barvy",
        colorNameCodeStartPlaceholder: "ZaÄnÄte psÃ¡t nÃ¡zev/kÃ³d barvy",
        colorNamePlaceholder: "nebo napiÅ¡te nÃ¡zev barvy",
        colorNameStartPlaceholder: "ZaÄnÄte psÃ¡t nÃ¡zev barvy",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "nebo napiÅ¡te nÃ¡zev vzorkovnice",
        fandeckStartPlaceholder: "ZaÄnÄte psÃ¡t nÃ¡zev vzorkovnice",
        formulaByColor: "Receptura podle barvy",
        noResultsFound: "Nebyly nalezeny Å¾Ã¡dnÃ© vÃ½sledky",
        packagePlaceholder: "nebo napiÅ¡te nÃ¡zev balenÃ­",
        packageStartPlaceholder: "ZaÄnÄte napsÃ¡nÃ­m nÃ¡zvu balenÃ­",
        productPlaceholder: "nebo napiÅ¡te nÃ¡zev produktu",
        productStartPlaceholder: "ZaÄnÄte psÃ¡t nÃ¡zev produktu",
        standard: "Standard",
        typeFandeckToFilter: "Hledat podle nÃ¡zvu vzorkovnice",
        typeProductToFilter: "Hledat podle nÃ¡zvu produktu"
    },
    sendOrderModal: {
        customNote: "VlastnÃ­ poznÃ¡mka",
        noCompatibleServers: "Ve vaÅ¡Ã­ sÃ­ti nejsou Å¾Ã¡dnÃ© kompatibilnÃ­ servery",
        orderOverview: "PÅehled objednÃ¡vky",
        selectTargetMachine: "Zvolit cÃ­lovÃ½ stroj",
        sendOrder: "Odeslat objednÃ¡vku",
        sendOrderTo: "VaÅ¡e objednÃ¡vka bude odeslÃ¡na na %{serverName}",
        targetMachine: "CÃ­lovÃ½ stroj"
    },
    server: {
        computerId: "ID poÄÃ­taÄe",
        ip: "IP",
        selectServer: "Vyberte prosÃ­m jeden z dostupnÃ½ch serverÅ¯",
        server: "Server"
    },
    serverDialog: {
        1: "V definici znaÄky vaÅ¡Ã­ licence je chyba. ProsÃ­m zkontrolujte to u poskytovatele.",
        2: "NepodaÅilo se zpracovat data pro%{0}: %{1}",
        3: "NeplatnÃ¡ sÃ­Å¥ovÃ¡ cesta.",
        4: "NeplatnÃ½ typ cesty (podporovÃ¡ny jsou pouze typy %{0} a %{1}).",
        5: "Chyba pÅi zÃ¡pisu tÃ³novacÃ­ho souboru.",
        6: "TÃ³novacÃ­ soubor byl ÃºspÄÅ¡nÄ vytvoÅen.",
        7: "NepodaÅilo se najÃ­t kolorant s nÃ¡zvem: '%{0}' na ÅÃ¡dku '%{1}'",
        8: "NepodaÅilo se najÃ­t balenÃ­ s nÃ¡zvem: '%{0}' na ÅÃ¡dku '%{1}'",
        9: "NepodaÅilo se najÃ­t bÃ¡ze v produktu s nÃ¡zvem produktu: '%{0}' a nÃ¡zvem bÃ¡ze: '%{1}' na ÅÃ¡dku '%{2}'",
        10: "NepodaÅilo se najÃ­t bÃ¡ze v balenÃ­ produktu s nÃ¡zvem: '%{0}', nÃ¡zvem bÃ¡ze: '%{1}' a nÃ¡zvem balenÃ­: '%{2}' na ÅÃ¡dku '%{3}'",
        11: "NepodaÅilo se naprarsovat hodnotu ceny: '%{0}' na ÅÃ¡dku '%{1}' v listu '%{2}'",
        12: "PÅipravujÃ­ se bÃ¡ze, Äekejte prosÃ­m",
        13: "PÅipravujÃ­ se bÃ¡ze v produktech, Äekejte prosÃ­m",
        14: "PÅipravujÃ­ se balenÃ­, Äekejte prosÃ­m",
        15: "PÅipravujÃ­ se odstÃ­ny, Äekejte prosÃ­m",
        16: "PÅipravujÃ­ se odstÃ­ny ve vzorkovnicÃ­ch, Äekejte prosÃ­m",
        17: "PÅipravujÃ­ se vzorkovnice, Äekejte prosÃ­m",
        18: "PÅipravujÃ­ se data pro globÃ¡lnÃ­ vyhledÃ¡vÃ¡nÃ­, Äekejte prosÃ­m",
        19: "PÅipravujÃ­ se produkty, Äekejte prosÃ­m",
        30: "Partial update nelze pouÅ¾Ã­t na databÃ¡zi '%{0}'. Aktualizujte svÅ¯j software na nejnovÄjÅ¡Ã­ verzi. MinimÃ¡lnÃ­ poÅ¾adovanÃ¡ verze je '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "AktivnÃ­ serverovÃ© doplÅky",
        currentlyActive: "AktuÃ¡lnÄ aktivnÃ­ doplÅky",
        plugin: "DoplÅek",
        pluginName: "NÃ¡zev doplÅku",
        statusActive: "AktivnÃ­",
        statusInactive: "NeaktivnÃ­"
    },
    serviceActionsSettings: {
        canisterLevel: "ÃroveÅ kanystrÅ¯",
        capClose: "ZavÅÃ­t",
        capMiddle: "StÅed",
        capOpen: "OtevÅÃ­t",
        cleanAllChannels: "VyÄistit vÅ¡echny",
        cleanChannels: "VyÄistit kanÃ¡ly",
        computer: "PoÄÃ­taÄ",
        computerReboot: "Restartovat poÄÃ­taÄ",
        computerShutdown: "Vypnut poÄÃ­taÄ",
        connectMachine: "PÅipojit stroj",
        general: "HlavnÃ­",
        initialize: "ZahÃ¡jit",
        noMachineIsConnected: "NenÃ­ pÅipojen Å¾Ã¡dnÃ½ stroj",
        plug: "ZÃ¡tka",
        plugger: "ZÃ¡tkovaÄ",
        punch: "DÄvorovat",
        puncher: "DÄrovaÄka",
        purgeChannels: "OdstÅik kanystrÅ¯",
        recirculate: "Recirkulovat",
        recirculateAllChannels: "Recirkulovat vÅ¡echny okruhy",
        recirculateChannels: "Recirkulovat okruhy",
        serviceActions: "ServisnÃ­ akce",
        setCanisterLevel: "Nastavit ÃºroveÅ kanystrÅ¯",
        shelfDown: "Posunout stÅ¯l dolÅ¯",
        shelfUp: "Posunout stÅ¯l nahoru",
        showServiceWindow: "UkÃ¡zat servisnÃ­ okno",
        smartPurgeAllChannels: "ChytrÃ½ odstÅik vÅ¡ech",
        smartPurgeChannels: "ChytrÃ½ odstÅik",
        startErrorReset: "Spustit resetovÃ¡nÃ­ chyby",
        startHardReset: "Spustit tvrdÃ½ restart",
        startReset: "Spustit restart",
        stirAllCanisters: "ZamÃ­chat vÅ¡echny kanystry",
        stirCanisters: "ZamÃ­chat kanystry",
        stirCanistersMore: "ZamÃ­chat kanystry"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Porovnejte barevnÃ½ vzorek s mÄÅÃ­tkem lesku a zvolte ÃºroveÅ lesku",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Kalibrovat",
        calibrateInstrument: "Kalibrace pÅÃ­stroje",
        connectDevice: "PÅipojit zaÅÃ­zenÃ­",
        connectedTo: "PÅipojeno k",
        connectingDevice: "VaÅ¡e zaÅÃ­zenÃ­ se pÅipojuje",
        deselectAll: "VÅ¡echno odznaÄit",
        deviceCalibrated: "ZaÅÃ­zenÃ­ bylo zkalibrovÃ¡no a mÅ¯Å¾ete zaÄÃ­t mÄÅit",
        deviceIsNotCalibrated: "VaÅ¡e zaÅÃ­zenÃ­ nenÃ­ kalibrovÃ¡no",
        eraseResult: "Smazat vÃ½sledek",
        filter: "Filtr",
        foundInFormulas: "Nalezeno v recepturÃ¡ch",
        inactiveSpectro: "Funkce Spectro je pro vybranou databÃ¡zi neaktivnÃ­.",
        instrumentCalibration: "VÃ¡Å¡ pÅÃ­stroj musÃ­ bÃ½t kalibrovÃ¡n.",
        manualInput: "ManuÃ¡lnÃ­ vstup",
        measure: "MÄÅit",
        measurementResult: "VÃ½sledek mÄÅenÃ­",
        noFilters: "Å½Ã¡dnÃ© dostupnÃ© filtry",
        noFormulas: "Nebyly nalezeny Å¾Ã¡dnÃ© receptury",
        noSelectedSpectro: "NenÃ­ vybrÃ¡n Å¾Ã¡dnÃ½ spektrometr",
        notSelected: "NevybrÃ¡no",
        pressConnectButton: "UjistÄte se, Å¾e je VaÅ¡e zaÅÃ­zenÃ­ pÅipojeno a zmÃ¡ÄknÄte tlaÄÃ­tko pÅipojit",
        searchFormulas: "Hledat receptury",
        selectSpectro: "Vybrat spektro",
        showDetails: "UkÃ¡zat detail",
        skipCalibration: "PÅeskoÄit kalibraci",
        spectroIsConnected: "Spektrometr je pÅipojen",
        spectroIsReady: "Spektrometr je pÅipraven",
        spectroReady: "ZaÅÃ­zenÃ­ je pÅipraveno",
        startCalibrateNow: "Spustit kalibraci nynÃ­",
        startMeasureText: "VaÅ¡e zaÅÃ­zenÃ­ je kalibrovÃ¡no a mÅ¯Å¾ete zaÄÃ­t mÄÅit",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Delta E (CIE 2000) tolerance"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "VlastnÃ­ %{1} %{2}",
        deleteSelectedRecords: "Vymazat vybranÃ© zÃ¡znamy",
        exportHistory: "Exportovat historii",
        finishFormula: "DokonÄit recepturu",
        foundInFormulas: "Nalezeno v recepturÃ¡ch",
        hideHiddenRecords: "Nezobrazovat skrytÃ© receptury",
        hideSelectedRecord: "SkrÃ½t vybranÃ½ zÃ¡znam",
        historicalFormula: "HistorickÃ¡ receptura",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Obnovit vybranÃ½ zÃ¡znam",
        showAllRecords: "Zobrazit vÅ¡echny zÃ¡znamy",
        standardFormula: "StandardnÃ­ receptura",
        unknownFormula: "NeznÃ¡ma receptura"
    },
    stirCanisters: {
        selectCanisters: "VÃ½bÄr kanystrÅ¯",
        startStirring: "ZaÄÃ­t promÃ­chÃ¡vÃ¡nÃ­",
        stirAllCanisters: "PromÃ­chat vÅ¡echny kanystry",
        stirCanisters: "PromÃ­chat kanystry",
        stirringSpeed: "Rychlost promÃ­chÃ¡vÃ¡nÃ­",
        stirringTime: "Doba promÃ­chÃ¡vÃ¡nÃ­"
    },
    stock: {
        addColorant: "PÅidat kolorant",
        addColorantPackagesToStock: "PÅidat balenÃ­ kolorantu do skladu",
        addPackagesToStock: "PÅdat balenÃ­ do skladu ",
        addedToStock: "PÅidÃ¡no do skladu ",
        allDatabases: "VÅ¡echny databÃ¡ze",
        checkStockPackageInventory: "Pokud pouÅ¾it",
        clearAllItems: "VyÄistit vÅ¡echny poloÅ¾ky",
        colorantInventory: "InventÅ¯ra kolorarantÅ¯",
        colorantsStockInventory: "InventÅ¯ra kolorarantÅ¯ ve skladÄ",
        confirmSendingOrder: "Potvrdit odeslÃ¡nÃ­ objednÃ¡vky",
        consumptionPrediction: "PÅedpovÄÄ spotÅeby na pÅÃ­Å¡tÃ½ch %{weeks} tÃ½dnÅ¯",
        createOrder: "VytvoÅit objednÃ¡vku (%{sum})",
        expirationDate: "Datum expirace",
        inDelivery: "V dodÃ¡nÃ­",
        manualOrder: "ManuÃ¡lnÃ­ objednÃ¡vka",
        manualOrderProgress: "Kroky %{step}/%{total}",
        noPackagesFoundInStockForColorant: "Ve skladÄ nejsou Å¾Ã¡dnÃ© balenÃ­ pro tento kolorant.",
        onStock: "Ve skladÄ",
        orderSummary: "PÅehled objednÃ¡vky",
        prediction: "Predikce ",
        removePackageFromStock: "Odebrat %{colorantName} balenÃ­ ze skladu",
        removePackageNameFromStock: "Chcete odebrat jedno balenÃ­ %{packageName} ze skladu?",
        scanBarcodeOrSelectColorant: "Naskenujte ÄÃ¡rovÃ½ kÃ³d z balenÃ­ nebo vyberte kolorant.",
        selectPackageToRemove: "Vyberte balenÃ­, kterÃ© chcete odebrat",
        sendConfirmed: "OdeslÃ¡nÃ­ potvrzeno",
        setAmountsByPrediction: "Nastavte mnoÅ¾stvÃ­ dle predikce ",
        sortByColorantName: "SeÅadit podle nÃ¡zvu kolorantu",
        sortByOrderNeed: "SeÅadit podle priority objednÃ¡vky",
        sortByStockLevel: "SeÅadit podle skladovÃ½ch zÃ¡sob",
        toOrder: "K objednÃ¡nÃ­"
    },
    testBarcode: {
        noItemAssigned: "K ÄÃ¡rovÃ©mu kÃ³du nenÃ­ pÅiÅazena Å¾Ã¡dnÃ¡ poloÅ¾ka %{code}",
        pleaseScanBarcode: "ProsÃ­m naskenujte ÄÃ¡rovÃ½ kÃ³d bÃ¡ze, produktu, balenÃ­ nebo jinÃ© poloÅ¾ky",
        testBarcodes: "Test ÄÃ¡rovÃ½ch kÃ³dÅ¯"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "PoslednÃ­",
        next: "DalÅ¡Ã­"
    },
    ufiCodeModal: {
        currentStatus: "SouÄasnÃ½ stav",
        detailedInfoForColorant: "PodrobnÃ© info o kolorantu %{colorantName}",
        userSetUfiCode: "UFI kÃ³d stanovenÃ½ uÅ¾ivatelem, souÄasnÃ¡ hodnota"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "PotvrzenÃ­ UFI kÃ³du bÃ¡ze",
        confirmColorantRefilling: "PotvrzenÃ­ doplnÄnÃ­ kolorantu",
        enableUfiCodes: "Povolit UFI kÃ³dy",
        printUfiCode: "Tisknout v pÅÃ­padÄ, Å¾e mnoÅ¾stvÃ­ kolorantu pÅesahuje",
        printUfiCodePercentage: "Tisknout procenta v pÅÃ­padÄ, Å¾e mnoÅ¾stvÃ­ kolorantu pÅesahuje",
        scanOrTypeUfiCode: "Naskenujte nebo napiÅ¡te UFI kÃ³d",
        scanOrTypeUfiCodeOfBase: "Nakenujte nebo napiÅ¡te UFI kÃ³d plechovky bÃ¡ze",
        ufiCodesByPercentage: "PouÅ¾Ã­t UFI kÃ³dy v procentech",
        ufiCodesFromDatabase: "PouÅ¾Ã­t UFI kÃ³dy z databÃ¡ze",
        ufiCodesFromLastFilling: "PouÅ¾Ã­t UFI kÃ³dy z poslednÃ­ho plnÄnÃ­"
    },
    userSettings: {
        addUser: "PÅidat uÅ¾ivatele",
        assignedUserGroups: "PÅiÅazenÃ© skupiny uÅ¾ivatelÅ¯",
        availableUserGroups: "DostupnÃ© skupiny uÅ¾ivatelÅ¯",
        barcode: "ÄÃ¡rovÃ½ kÃ³d",
        confirmNewPassword: "PotvrÄte heslo",
        editPassword: "Ãprava hesla",
        editUser: "Ãprava uÅ¾ivatele",
        enableAutoLogin: "Povolit automatickÃ© pÅihlÃ¡Å¡enÃ­",
        newPassword: "NovÃ© heslo",
        noChange: "Nenastaly Å¾Ã¡dnÃ© zmÄny k uloÅ¾enÃ­",
        oldPassword: "StarÃ© heslo",
        password: "Heslo",
        passwordsDoNotMatch: "Hesla se neshodujÃ­",
        restoreUser: "Tento uÅ¾ivatel je smazÃ¡n. Chcete ho obnovit?",
        userGroup: "User Group",
        userGroups: "UÅ¾ivatelskÃ© skupiny",
        userManagement: "SprÃ¡va uÅ¾ivatelÅ¯",
        userSettings: "UÅ¾ivatelskÃ© nastavenÃ­",
        username: "UÅ¾ivatelskÃ© jmÃ©no",
        usernameIsMissing: "ChybÃ­ uÅ¾ivatelskÃ© jmÃ©no"
    },
    warningMissingDataModal: {
        continue: "NÄkterÃ¡ data chybÃ­, chcete pokraÄovat?",
        notFoundBase:
            "Tato produktovÃ¡ bÃ¡ze nenÃ­ dostupnÃ¡. PotvrÄte a buÄte opatrnÃ­, abyste pouÅ¾ili kompatiblnÃ­ produktovou bÃ¡zi nebo zruÅ¡te objednÃ¡vku.",
        notFoundProduct:
            "Tento produkt nenÃ­ dostupnÃ½. PotvrÄte a buÄte opatrnÃ­ se zÃ­skÃ¡nÃ­m kompatibilnÃ­ho produktu nebo zruÅ¡tÄ objednÃ¡vku."
    },
    weekdays: {
        friday: "PÃ¡tek",
        monday: "PondÄlÃ­",
        saturday: "Sobota",
        sunday: "NedÄle",
        thursday: "Ätvrtek",
        tuesday: "ÃterÃ½",
        wednesday: "StÅeda"
    },
    welcome: {
        availableDatabase: "Server se nemÅ¯Å¾e pÅipojit k databÃ¡zi. Zkontrolujte prosÃ­m nastavenÃ­ databÃ¡ze.",
        availableDatabaseLocalError: "Chyba bÄhem pÅipojovÃ¡nÃ­ k local databÃ¡zi (Å¡patnÃ½ soubor, nesprÃ¡vnÃ© heslo)",
        availableDatabaseLocalMissing: "LokÃ¡lnÃ­ databÃ¡ze chybÃ­",
        availableDatabaseLocalUpdate: "LokÃ¡lnÃ­ databÃ¡ze musÃ­ bÃ½t aktualizovÃ¡na na novÄjÅ¡Ã­ verzi",
        availableDatabaseMainAndLocalError:
            "Chyba bÄhem pÅipojovÃ¡nÃ­ k main a local databÃ¡zÃ­m (Å¡patnÃ© soubory, nesprÃ¡vnÃ© heslo)",
        availableDatabaseMainAndLocalMissing: "Main a lokÃ¡lnÃ­ databÃ¡ze chybÃ­",
        availableDatabaseMainAndLocalUpdate: "ObÄ databÃ¡ze (main i local) musÃ­ bÃ½t aktualizovÃ¡ny na novÄjÅ¡Ã­ verzi",
        availableDatabaseMainError: "Chyba bÄhem pÅipojovÃ¡nÃ­ k main databÃ¡zi (Å¡patnÃ½ soubor, nesprÃ¡vnÃ© heslo)",
        availableDatabaseMainMissing: "Main databÃ¡ze chybÃ­",
        availableDatabaseMainPartialUpdate:
            "Main databÃ¡zi je tÅeba aktualizovat na novÄjÅ¡Ã­ verzi prostÅednictvÃ­m partial updatu",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main databÃ¡zi je potÅeba aktualizovat na novÄjÅ¡Ã­ verzi prostÅednictvÃ­m partial updatu a lokÃ¡lnÃ­ databÃ¡zi je tÅeba aktualizovat na novÄjÅ¡Ã­ verzi",
        availableDatabaseMainUpdate: "Main databÃ¡ze musÃ­ bÃ½t aktualizovÃ¡na na novÄjÅ¡Ã­ verzi",
        closing: "Program se zavÃ­rÃ¡",
        compatibility:
            "Zkontrolujte prosÃ­m verzi VaÅ¡eho serveru. Klient je kompatibilnÃ­ pouze se serverem %{0} nebo vyÅ¡Å¡Ã­.",
        compatibilityCheck: "ProbÃ­hÃ¡ kontrola kompatibility",
        compatibilityDatabase: "VaÅ¡e databÃ¡ze nenÃ­ kompatibilnÃ­ se serevrem. ProsÃ­m zkontrolujte nastavenÃ­ databÃ¡ze.",
        connectingServer: "ProbÃ­hÃ¡ pÅipojovÃ¡nÃ­ k serveru %{ip}",
        databaseCompatibility: "VaÅ¡e databÃ¡ze nenÃ­ kompatibilnÃ­ se souÄasnou verzÃ­ softwaru.",
        databasesCompatibility: "VaÅ¡e databÃ¡ze nejsou kompatibilnÃ­ se souÄasnou verzÃ­ softwaru.",
        licenseVerification: "ProbÃ­hÃ¡ ovÄÅenÃ­ licence",
        loading: "NaÄÃ­tÃ¡nÃ­",
        lostConnection: "SpojenÃ­ se serverem bylo ztraceno",
        moduleMessage:
            "ProsÃ­m vÄnujte pozornost vÃ½bÄru modulu, dodateÄnÃ¡ zmÄna modulu bude dostupnÃ¡ pouze pro nÄkterÃ© uÅ¾ivatele.",
        refresh: "Obnovit",
        restoring: "Obnova spojenÃ­",
        selectModule: "ProsÃ­m vyberte jeden z dostupnÃ½ch modulÅ¯.",
        stopUpdate: "ZruÅ¡it aktualizaci",
        updateDatabase: "Aktualizovat databÃ¡zi",
        updatingDatabase: "DatabÃ¡ze se aktualizuje",
        updatingDatabases: "DatabÃ¡ze se aktualizujÃ­",
        updatingWarning: "Struktura databÃ¡ze se aktualizuje na nejnovÄjÅ¡Ã­ verzi, prosÃ­m Äekejte.",
        updatingWarningInfo: "NezavÃ­rejte tohle okno, jinak se musÃ­ aktualizace spustit od zaÄÃ¡tku."
    }
};
